<script>
  export let routes_db,
    socket_query,
    units_travel_db,
    user_level,
    monitorWorker;
  import { onMount, onDestroy, tick } from "svelte";
  import Hls from "hls.js";
  import {
    units_list,
    nicks_list,
    geos,
    geos_class,
    travels,
    table_pos,
    live,
    drivers_list,
    drivers,
    geos_class_list,
    route_list,
    route_list_d,
    travel_crtl,
    geos_joined,
    geos_class_join,
    internal_com,
    map_ready,
    monitor_extra_map,
    recognition,
    unit_groups,
    geos_full,
    poli_list,
    poli,
    poli_full,
    geos_map,
    cc_monitor,
    speaking_list,
    unit_list_ws_real,
    route_confidence,
    input_self_test,
    group,
  } from "./stores.js";
  import { dataset_dev } from "svelte/internal";
  import {
    EXT_OMNI_GEOC_URL,
    EXT_OMNI_ROUTE_URL,
    fetchJsonSafe,
  } from "./external-service-urls.js";
  import {
    acquirePooledMap,
    acquireMainMap,
    cancelMainMapReset,
    cancelPooledMapReset,
    createVectorMapOptions,
    MAP_POOL_SLOTS,
    MAP_RESET_VIEW,
    releaseMainMap,
    releasePooledMap,
  } from "./map-pool.js";

  const bc = new BroadcastChannel("map_external");
  const bc_route = new BroadcastChannel("map_external_route");
  const bc_coordenadas = new BroadcastChannel("map_external_coordenadas");
  const bc_control = new BroadcastChannel("map_external_control");

  const monitor_visual_db = localforage.createInstance({
    name: "monitor_1_db",
  });
  const MONITOR_VISUAL_CACHE_KEY = "monitor_visual_summary_v1";
  const MONITOR_VISUAL_CACHE_WRITE_DEBOUNCE_MS = 750;
  const MONITOR2_MIN_SEND_INTERVAL_MS = 1000;
  const MONITOR2_IDLE_TICK_MS = 15 * 1000;
  const LIGHTMETRICS_STREAM_KEEPALIVE_MS = 20 * 1000;
  const LIGHTMETRICS_STREAM_PROBE_MS = 4 * 1000;
  const LIGHTMETRICS_STREAM_RELOAD_AFTER_MS = 8 * 1000;
  const LIGHTMETRICS_STREAM_PLAY_RETRY_MS = 1500;

  let lightmetrics_monitor_status = {};
  let lightmetrics_monitor_loading = false;
  let lightmetrics_monitor_error = "";
  let lightmetrics_monitor_warning = "";
  let lightmetrics_monitor_last_group = "";
  let lightmetrics_stream_modal_open = false;
  let lightmetrics_stream_loading = false;
  let lightmetrics_stream_error = "";
  let lightmetrics_stream_message = "";
  let lightmetrics_stream_status = "IDLE";
  let lightmetrics_stream_request_id = "";
  let lightmetrics_stream_url = "";
  let lightmetrics_stream_unit_id = "";
  let lightmetrics_stream_asset_id = "";
  let lightmetrics_stream_device_id = "";
  let lightmetrics_stream_expires_at = 0;
  let lightmetrics_stream_video;
  let lightmetrics_stream_hls = null;
  let lightmetrics_stream_keepalive_timer = null;
  let lightmetrics_stream_probe_timer = null;
  let lightmetrics_stream_player_ready = false;
  let lightmetrics_stream_player_error = "";
  let lightmetrics_stream_loaded_url = "";
  let lightmetrics_stream_source_requested_at = 0;
  let lightmetrics_stream_retry_count = 0;
  let lightmetrics_stream_last_reload_reason = "";
  let lightmetrics_stream_last_play_attempt_at = 0;
  let lightmetrics_stream_play_attempt_inflight = false;

  function normalizeTravelIdAdd(value) {
    if (Array.isArray(value)) {
      return value.flatMap((entry) => normalizeTravelIdAdd(entry));
    }
    if (typeof value === "string") {
      return value
        .split(",")
        .map((entry) => entry.trim())
        .filter((entry) => entry !== "");
    }
    if (value == null || value === false) {
      return [];
    }
    return [String(value)];
  }

  const hos_list_db = localforage.createInstance({
    name: "hos_list_1_db",
  });

  function normalizeLightmetricsMonitorPayload(payload) {
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
      return {
        loading: false,
        error: "",
        warning: "",
        units: {},
      };
    }
    return {
      loading: payload.loading === true,
      error:
        typeof payload.error === "string" ? payload.error.trim() : "",
      warning:
        typeof payload.warning === "string" ? payload.warning.trim() : "",
      units:
        payload.units && typeof payload.units === "object" && !Array.isArray(payload.units)
          ? payload.units
          : {},
    };
  }

  function handleLightmetricsMonitorStatus(payload) {
    const normalized = normalizeLightmetricsMonitorPayload(payload);
    lightmetrics_monitor_loading = normalized.loading;
    lightmetrics_monitor_error = normalized.error;
    lightmetrics_monitor_warning = normalized.warning;
    lightmetrics_monitor_status = normalized.units;
  }

  function handleLightmetricsStreamStatus(payload) {
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
      return;
    }
    const payloadRequestId =
      typeof payload.streamRequestId === "string"
        ? payload.streamRequestId.trim()
        : "";
    const nextStatus =
      typeof payload.status === "string" && payload.status.trim() !== ""
        ? payload.status.trim().toUpperCase()
        : "IDLE";
    if (
      payloadRequestId != "" &&
      lightmetrics_stream_request_id != "" &&
      payloadRequestId != lightmetrics_stream_request_id &&
      nextStatus != "REQUESTED"
    ) {
      return;
    }
    lightmetrics_stream_status = nextStatus;
    lightmetrics_stream_loading =
      ["REQUESTED", "PENDING", "ACKNOWLEDGED"].includes(nextStatus) ||
      (nextStatus == "STARTED" && !hasLightmetricsStreamPlayback());
    lightmetrics_stream_message =
      typeof payload.message === "string" ? payload.message.trim() : "";
    lightmetrics_stream_error =
      typeof payload.error === "string" ? payload.error.trim() : "";
    if (payloadRequestId != "") {
      lightmetrics_stream_request_id = payloadRequestId;
    }
    if (
      typeof payload.streamSessionURL === "string" &&
      payload.streamSessionURL.trim() !== ""
    ) {
      lightmetrics_stream_url = payload.streamSessionURL.trim();
    }
    if (typeof payload.unitId === "string" && payload.unitId.trim() !== "") {
      lightmetrics_stream_unit_id = payload.unitId.trim();
    }
    if (typeof payload.assetId === "string" && payload.assetId.trim() !== "") {
      lightmetrics_stream_asset_id = payload.assetId.trim();
    }
    if (
      typeof payload.deviceId === "string" &&
      payload.deviceId.trim() !== ""
    ) {
      lightmetrics_stream_device_id = payload.deviceId.trim();
    }
    if (typeof payload.expiresAt === "number") {
      lightmetrics_stream_expires_at = payload.expiresAt;
    }
    if (
      ["REQUESTED", "PENDING", "ACKNOWLEDGED"].includes(nextStatus) &&
      lightmetrics_stream_message == ""
    ) {
      lightmetrics_stream_message =
        "Esperando que Protect entregue el video";
    }
    if (nextStatus === "STARTED" && !hasLightmetricsStreamPlayback()) {
      lightmetrics_stream_message =
        "El stream está en vivo. Esperando que llegue el video...";
    } else if (nextStatus === "STARTED" && lightmetrics_stream_message == "") {
      lightmetrics_stream_message = "Video disponible";
    }
    if (nextStatus === "STOPPED") {
      lightmetrics_stream_loading = false;
      destroyLightmetricsStreamPlayer();
    }
  }

  function getLightmetricsMonitorUnitState(unitId) {
    const item = lightmetrics_monitor_status[unitId];
    return item && typeof item === "object" && !Array.isArray(item)
      ? item
      : null;
  }

  function hasLightmetricsMonitorTrip(unitId) {
    const item = getLightmetricsMonitorUnitState(unitId);
    return item != null && item.tripActive === true;
  }

  function lightmetricsMonitorIconColor(unitId) {
    const item = getLightmetricsMonitorUnitState(unitId);
    if (!item) return "#9e9e9e";
    if (item.cameraConnected === false) return "#f57c00";
    if (item.movingNow === true) return "#1b8f5a";
    return "#1565c0";
  }

  function lightmetricsMonitorIconTooltip(unitId) {
    const item = getLightmetricsMonitorUnitState(unitId);
    if (!item) return "Sin viaje activo de Protect";
    if (item.cameraConnected === false) {
      return "Viaje activo sin cámara disponible";
    }
    if (item.movingNow === true) {
      return "Viaje activo y unidad en movimiento";
    }
    return "Viaje activo de Protect";
  }

  function lightmetricsStreamUnitLabel(unitId) {
    return typeof $nicks_list[unitId] != "undefined" ? $nicks_list[unitId] : unitId;
  }

  function lightmetricsStreamStatusLabel(status) {
    if (status == "REQUESTED") return "Solicitando video";
    if (status == "PENDING") return "Preparando video";
    if (status == "ACKNOWLEDGED") return "Esperando transmisión";
    if (status == "STARTED") return "Video en vivo";
    if (status == "STOPPED") return "Stream finalizado";
    if (status == "ERROR") return "No disponible";
    return "Sin actividad";
  }

  function hasLightmetricsStreamMediaReady() {
    if (!lightmetrics_stream_video) {
      return false;
    }
    if (
      lightmetrics_stream_video.currentSrc &&
      lightmetrics_stream_video.readyState >= 2 &&
      (lightmetrics_stream_video.videoWidth > 0 ||
        lightmetrics_stream_video.videoHeight > 0)
    ) {
      return true;
    }
    return false;
  }

  function hasLightmetricsStreamPlayback() {
    if (!hasLightmetricsStreamMediaReady()) {
      return false;
    }
    if (
      lightmetrics_stream_video.currentTime > 0.1 ||
      (!lightmetrics_stream_video.paused && !lightmetrics_stream_video.ended)
    ) {
      return true;
    }
    return false;
  }

  function markLightmetricsStreamPlayable() {
    lightmetrics_stream_player_ready = true;
    lightmetrics_stream_loading = false;
    lightmetrics_stream_player_error = "";
    if (lightmetrics_stream_status == "STARTED") {
      lightmetrics_stream_message = "Video disponible";
    }
  }

  async function ensureLightmetricsStreamPlayback(reason = "retry") {
    if (
      !lightmetrics_stream_modal_open ||
      !lightmetrics_stream_video ||
      lightmetrics_stream_url == ""
    ) {
      return false;
    }
    if (hasLightmetricsStreamPlayback()) {
      markLightmetricsStreamPlayable();
      return true;
    }
    const now = Date.now();
    if (
      lightmetrics_stream_play_attempt_inflight ||
      (lightmetrics_stream_last_play_attempt_at > 0 &&
        now - lightmetrics_stream_last_play_attempt_at <
          LIGHTMETRICS_STREAM_PLAY_RETRY_MS)
    ) {
      return false;
    }
    lightmetrics_stream_play_attempt_inflight = true;
    lightmetrics_stream_last_play_attempt_at = now;
    const videoElement = lightmetrics_stream_video;
    videoElement.muted = true;
    videoElement.defaultMuted = true;
    videoElement.playsInline = true;
    videoElement.autoplay = true;
    lightmetrics_stream_loading = true;
    lightmetrics_stream_player_error = "";
    lightmetrics_stream_message = hasLightmetricsStreamMediaReady()
      ? "El video está listo. Intentando reproducirlo..."
      : lightmetrics_stream_status == "STARTED"
        ? "El stream está en vivo. Esperando que llegue el video..."
        : "Esperando que Protect entregue el video";
    try {
      const playResult = videoElement.play();
      if (playResult && typeof playResult.then === "function") {
        await playResult;
      }
    } catch (_error) {
    } finally {
      lightmetrics_stream_play_attempt_inflight = false;
    }
    if (hasLightmetricsStreamPlayback()) {
      markLightmetricsStreamPlayable();
      return true;
    }
    if (hasLightmetricsStreamMediaReady()) {
      lightmetrics_stream_message = "El video está listo. Intentando reproducirlo...";
    }
    return false;
  }

  function destroyLightmetricsStreamPlayer() {
    lightmetrics_stream_player_ready = false;
    lightmetrics_stream_player_error = "";
    lightmetrics_stream_loaded_url = "";
    lightmetrics_stream_source_requested_at = 0;
    lightmetrics_stream_last_play_attempt_at = 0;
    lightmetrics_stream_play_attempt_inflight = false;
    if (lightmetrics_stream_hls) {
      lightmetrics_stream_hls.destroy();
      lightmetrics_stream_hls = null;
    }
    if (lightmetrics_stream_video) {
      try {
        lightmetrics_stream_video.pause();
      } catch (_error) {}
      lightmetrics_stream_video.removeAttribute("src");
      lightmetrics_stream_video.load();
    }
  }

  async function loadLightmetricsStreamPlayer(forceReload = false) {
    if (
      !lightmetrics_stream_modal_open ||
      !lightmetrics_stream_video ||
      lightmetrics_stream_url == "" ||
      (!forceReload && lightmetrics_stream_loaded_url == lightmetrics_stream_url)
    ) {
      return;
    }

    destroyLightmetricsStreamPlayer();
    lightmetrics_stream_loaded_url = lightmetrics_stream_url;
    lightmetrics_stream_source_requested_at = Date.now();
    const videoElement = lightmetrics_stream_video;
    videoElement.muted = true;
    videoElement.defaultMuted = true;
    videoElement.playsInline = true;
    videoElement.autoplay = true;
    lightmetrics_stream_loading = true;
    lightmetrics_stream_player_error = "";
    if (lightmetrics_stream_status == "STARTED") {
      lightmetrics_stream_message =
        "El stream está en vivo. Esperando que llegue el video...";
    } else {
      lightmetrics_stream_message =
        "Esperando que Protect entregue el video";
    }

    if (Hls.isSupported()) {
      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: true,
      });
      lightmetrics_stream_hls = hls;
      hls.attachMedia(videoElement);
      hls.on(Hls.Events.MEDIA_ATTACHED, () => {
        hls.loadSource(lightmetrics_stream_url);
      });
      hls.on(Hls.Events.MANIFEST_PARSED, async () => {
        await ensureLightmetricsStreamPlayback("manifest_parsed");
      });
      hls.on(Hls.Events.ERROR, (_event, data) => {
        if (data && data.fatal) {
          lightmetrics_stream_player_error =
            "El video tardó en responder. Reintentando...";
          requestLightmetricsStreamReload(
            data.type || data.details || "fatal_hls_error"
          );
        }
      });
      return;
    }

    if (videoElement.canPlayType("application/vnd.apple.mpegurl")) {
      videoElement.src = lightmetrics_stream_url;
      await ensureLightmetricsStreamPlayback("native_src_set");
      return;
    }

    lightmetrics_stream_player_error =
      "Este navegador no soporta video HLS en vivo";
  }

  function requestLightmetricsStreamReload(reason = "retry") {
    if (!lightmetrics_stream_modal_open || lightmetrics_stream_url == "") {
      return;
    }
    const now = Date.now();
    if (
      lightmetrics_stream_source_requested_at > 0 &&
      now - lightmetrics_stream_source_requested_at <
        LIGHTMETRICS_STREAM_RELOAD_AFTER_MS
    ) {
      return;
    }
    lightmetrics_stream_retry_count += 1;
    lightmetrics_stream_last_reload_reason = reason;
    lightmetrics_stream_message =
      lightmetrics_stream_status == "STARTED"
        ? "El stream está en vivo. Reintentando la carga del video..."
        : "Esperando transmisión. Reintentando la carga del video...";
    lightmetrics_stream_player_error = "";
    lightmetrics_stream_loaded_url = "";
    loadLightmetricsStreamPlayer(true);
  }

  function probeLightmetricsStreamPlayback() {
    if (!lightmetrics_stream_modal_open || lightmetrics_stream_url == "") {
      return;
    }
    if (hasLightmetricsStreamPlayback()) {
      markLightmetricsStreamPlayable();
      return;
    }
    if (hasLightmetricsStreamMediaReady()) {
      lightmetrics_stream_loading = true;
      lightmetrics_stream_message = "El video está listo. Intentando reproducirlo...";
      ensureLightmetricsStreamPlayback("probe_media_ready");
      return;
    }
    const now = Date.now();
    const sourceAge =
      lightmetrics_stream_source_requested_at > 0
        ? now - lightmetrics_stream_source_requested_at
        : 0;
    if (lightmetrics_stream_status == "STARTED") {
      lightmetrics_stream_loading = true;
      lightmetrics_stream_message =
        "El stream está en vivo. Esperando que llegue el video...";
    } else if (
      ["REQUESTED", "PENDING", "ACKNOWLEDGED"].includes(
        lightmetrics_stream_status
      )
    ) {
      lightmetrics_stream_loading = true;
      lightmetrics_stream_message =
        "Esperando que Protect entregue el video";
    }
    if (
      sourceAge >= LIGHTMETRICS_STREAM_RELOAD_AFTER_MS ||
      lightmetrics_stream_player_error != ""
    ) {
      requestLightmetricsStreamReload(
        lightmetrics_stream_player_error != ""
          ? "player_error"
          : "no_playback_yet"
      );
    }
  }

  function clearLightmetricsStreamKeepalive() {
    if (lightmetrics_stream_keepalive_timer) {
      clearInterval(lightmetrics_stream_keepalive_timer);
      lightmetrics_stream_keepalive_timer = null;
    }
  }

  function clearLightmetricsStreamProbe() {
    if (lightmetrics_stream_probe_timer) {
      clearInterval(lightmetrics_stream_probe_timer);
      lightmetrics_stream_probe_timer = null;
    }
  }

  function startLightmetricsStreamKeepalive() {
    clearLightmetricsStreamKeepalive();
    if (!lightmetrics_stream_modal_open || lightmetrics_stream_request_id == "") {
      return;
    }
    lightmetrics_stream_keepalive_timer = setInterval(() => {
      socket_query.emit("lightmetrics_stream_keepalive");
    }, LIGHTMETRICS_STREAM_KEEPALIVE_MS);
  }

  function startLightmetricsStreamProbe() {
    clearLightmetricsStreamProbe();
    if (!lightmetrics_stream_modal_open || lightmetrics_stream_url == "") {
      return;
    }
    lightmetrics_stream_probe_timer = setInterval(() => {
      probeLightmetricsStreamPlayback();
    }, LIGHTMETRICS_STREAM_PROBE_MS);
    probeLightmetricsStreamPlayback();
  }

  function resetLightmetricsStreamState() {
    clearLightmetricsStreamKeepalive();
    clearLightmetricsStreamProbe();
    destroyLightmetricsStreamPlayer();
    lightmetrics_stream_loading = false;
    lightmetrics_stream_error = "";
    lightmetrics_stream_message = "";
    lightmetrics_stream_status = "IDLE";
    lightmetrics_stream_request_id = "";
    lightmetrics_stream_url = "";
    lightmetrics_stream_unit_id = "";
    lightmetrics_stream_asset_id = "";
    lightmetrics_stream_device_id = "";
    lightmetrics_stream_expires_at = 0;
    lightmetrics_stream_retry_count = 0;
    lightmetrics_stream_last_reload_reason = "";
  }

  function closeLightmetricsStream(reason = "closed", notifyBackend = true) {
    if (notifyBackend && lightmetrics_stream_request_id != "") {
      socket_query.emit("lightmetrics_stream_close", { reason });
    }
    lightmetrics_stream_modal_open = false;
    resetLightmetricsStreamState();
  }

  function openLightmetricsStream(unitId, event = null) {
    if (event && typeof event.stopPropagation === "function") {
      event.stopPropagation();
      if (typeof event.preventDefault === "function") {
        event.preventDefault();
      }
    }
    selectMonitorUnit(unitId, event || {});
    lightmetrics_stream_modal_open = true;
    lightmetrics_stream_loading = true;
    lightmetrics_stream_error = "";
    lightmetrics_stream_message = "Solicitando video en vivo";
    lightmetrics_stream_status = "REQUESTED";
    lightmetrics_stream_unit_id = unitId;
    lightmetrics_stream_asset_id = "";
    lightmetrics_stream_device_id = "";
    lightmetrics_stream_request_id = "";
    lightmetrics_stream_url = "";
    lightmetrics_stream_expires_at = 0;
    lightmetrics_stream_retry_count = 0;
    lightmetrics_stream_last_reload_reason = "";
    destroyLightmetricsStreamPlayer();
    socket_query.emit("lightmetrics_stream_open", { unitId }, (payload) => {
      handleLightmetricsStreamStatus(payload);
    });
  }

  function subscribeLightmetricsMonitor() {
    if (user_level <= 0 || !$group) {
      return;
    }
    socket_query.emit("lightmetrics_monitor_subscribe", (payload) => {
      handleLightmetricsMonitorStatus(payload);
    });
  }

  function unsubscribeLightmetricsMonitor() {
    socket_query.emit("lightmetrics_monitor_unsubscribe");
  }

  function handleLightmetricsMonitorReconnect() {
    if (!mount_complete || user_level <= 0) {
      return;
    }
    const nextGroup = $group || "";
    if (nextGroup == "") {
      return;
    }
    lightmetrics_monitor_last_group = nextGroup;
    subscribeLightmetricsMonitor();
  }

  let mod_on = {};
  var observer = new IntersectionObserver(function (entry) {
    let visibility_changed = false;
    for (let x in entry) {
      const mobid = entry[x].target.id.split("_")[1];
      if (entry[x].isIntersecting) {
        if (!mod_on[mobid]) {
          mod_on[mobid] = true;
          visibility_changed = true;
        }
      } else if (mod_on[mobid]) {
        delete mod_on[mobid];
        visibility_changed = true;
      }
    }
    if (visibility_changed) schedule_monitor2_now();
  });
  function monitor_v(e) {
    observer.observe(e);
  }

  // --- Travel sentinel: auto-load more travel cards on scroll ---
  function travelSentinel(node) {
    const obs = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) loadMoreTravels();
    }, { rootMargin: '200px' });
    obs.observe(node);
    return { destroy() { obs.disconnect(); } };
  }

  let map_cover = false;
  const MAP_LAYER_MENU_AUTO_HIDE_MS = 2 * 1000;
  let map_layer_menu_visible = true;
  let map_layer_menu_hovered = false;
  let map_layer_menu_auto_hide_timer;
  let monitor_map_eta_seconds = -1;
  let monitor_map_eta_request = 0;
  let has_monitor_map_eta_context = false;
  let monitor_map_eta_unit = -1;
  let monitor_units_panel_collapsed =
    localStorage.getItem("monitor_units_panel_collapsed") == "true"
      ? true
      : false;
  let filtered_monitor_units = [];
  let visible_monitor_units = [];
  let collapsed_monitor_search_query = "";
  let collapsed_monitor_search_results = [];
  let collapsed_monitor_search_open = false;
  let collapsed_monitor_search_input;
  let collapsed_monitor_active_label = "";
  let collapsed_monitor_search_editing = false;
  const MONITOR_MAP_TYPE_OPTIONS = [
    { id: "roadmap", label: "Mapa", icon: "map" },
    { id: "hybrid", label: "Hibrido", icon: "layers" },
  ];
  let monitor_map_type = "roadmap";
  let monitor_map_zoom = MAP_RESET_VIEW.DEFAULT.zoom;

  function clearMapLayerMenuAutoHideTimer() {
    if (map_layer_menu_auto_hide_timer) {
      clearTimeout(map_layer_menu_auto_hide_timer);
      map_layer_menu_auto_hide_timer = undefined;
    }
  }

  function scheduleMapLayerMenuAutoHide(delay = MAP_LAYER_MENU_AUTO_HIDE_MS) {
    clearMapLayerMenuAutoHideTimer();
    if (!map_layer_menu_visible) {
      return;
    }
    map_layer_menu_auto_hide_timer = setTimeout(() => {
      if (!map_layer_menu_hovered) {
        map_layer_menu_visible = false;
      }
    }, delay);
  }

  function holdMapLayerMenu() {
    map_layer_menu_hovered = true;
    clearMapLayerMenuAutoHideTimer();
  }

  function releaseMapLayerMenu() {
    map_layer_menu_hovered = false;
    if (map_layer_menu_visible) {
      scheduleMapLayerMenuAutoHide();
    }
  }

  function showMapLayerMenu() {
    map_layer_menu_visible = true;
    scheduleMapLayerMenuAutoHide();
  }

  function hideMapLayerMenu() {
    map_layer_menu_visible = false;
    map_layer_menu_hovered = false;
    clearMapLayerMenuAutoHideTimer();
  }

  function toggleMapLayerMenu() {
    if (map_layer_menu_visible) {
      hideMapLayerMenu();
    } else {
      showMapLayerMenu();
    }
  }

  function toggleMapCoverage() {
    if (!map) {
      return;
    }
    map_cover = !map_cover;
    mapa_cobertura(map_cover);
    scheduleMapLayerMenuAutoHide();
  }

  function toggleMapTraffic() {
    if (!map || !trafficLayer) {
      return;
    }
    map_traffic = !map_traffic;
    if (map_traffic) {
      trafficLayer.setMap(map);
    } else {
      trafficLayer.setMap(null);
    }
    scheduleMapLayerMenuAutoHide();
  }

  function toggleMapGeofence() {
    if (!map) {
      return;
    }
    map_geofence = !map_geofence;
    localStorage.setItem("map_geofence", map_geofence);
    if (!map_geofence) {
      for (let x in circle_route) {
        circle_route[x].setMap(null);
      }
      circle_route = [];
      circle_route_ = [];
      for (let x in poligon_route) {
        poligon_route[x].setMap(null);
      }
      poligon_route = [];
      poligon_route_ = [];
    } else {
      show_geo(last_route_coordenada);
    }
    scheduleMapLayerMenuAutoHide();
  }

  function syncMonitorMapControls() {
    if (!map) {
      monitor_map_type = "roadmap";
      monitor_map_zoom = MAP_RESET_VIEW.DEFAULT.zoom;
      return;
    }

    monitor_map_type = map.getMapTypeId() || "roadmap";
    let currentZoom = map.getZoom();
    monitor_map_zoom =
      typeof currentZoom == "number"
        ? currentZoom
        : MAP_RESET_VIEW.DEFAULT.zoom;
  }

  function getMonitorMapZoomLimit(optionName, fallback) {
    if (!map) {
      return fallback;
    }

    let limit = map.get(optionName);
    return typeof limit == "number" ? limit : fallback;
  }

  function setMonitorMapType(type) {
    if (!map || !type || monitor_map_type == type) {
      return;
    }

    map.setMapTypeId(type);
    syncMonitorMapControls();
  }

  function changeMonitorMapZoom(delta) {
    if (!map || !delta) {
      return;
    }

    let currentZoom = map.getZoom();
    if (typeof currentZoom != "number") {
      currentZoom = MAP_RESET_VIEW.DEFAULT.zoom;
    }

    let minZoom = getMonitorMapZoomLimit("minZoom", 0);
    let maxZoom = getMonitorMapZoomLimit("maxZoom", 22);
    let nextZoom = Math.max(minZoom, Math.min(maxZoom, currentZoom + delta));

    if (nextZoom != currentZoom) {
      map.setZoom(nextZoom);
    }
  }

  function resetMonitorMapEta(cancelPending = false) {
    if (cancelPending) {
      monitor_map_eta_request += 1;
    }
    monitor_map_eta_seconds = -1;
  }

  function hasTravelEtaContext(unitId, dateIni = -1) {
    for (let item of future_travel) {
      if (item.id != unitId) {
        continue;
      }
      if (dateIni != -1) {
        return item.date_ini == dateIni;
      }
      if (item.step != 0) {
        return true;
      }
    }
    return false;
  }

  function setMonitorMapEtaContext(unitId, dateIni = -1) {
    has_monitor_map_eta_context = hasTravelEtaContext(unitId, dateIni);
    monitor_map_eta_unit = has_monitor_map_eta_context ? unitId : -1;
    if (!has_monitor_map_eta_context) {
      resetMonitorMapEta(true);
    }
  }

  function formatMonitorMapEta(seconds) {
    return (
      Math.round(seconds / 60 / 60) +
      "h " +
      Math.round((seconds / 60) % 60) +
      "m"
    );
  }

  async function updateMonitorMapEta(mobid, destination) {
    if (
      !destination ||
      destination.lat == null ||
      destination.lng == null ||
      !$live[mobid]
    ) {
      resetMonitorMapEta();
      return;
    }

    const requestId = ++monitor_map_eta_request;
    const coordenada_osrm =
      $live[mobid].lon +
      "," +
      $live[mobid].lat +
      ";" +
      destination.lng +
      "," +
      destination.lat;

    const osrm_r = await fetchJsonSafe(
      EXT_OMNI_ROUTE_URL +
        "/route/v1/driving/" +
        coordenada_osrm +
        "?geometries=geojson&generate_hints=false&skip_waypoints=true&overview=full",
      { fallback: null, logLabel: "monitor eta route" }
    );

    if (
      requestId !== monitor_map_eta_request ||
      monitor_map_eta_unit !== mobid ||
      !has_monitor_map_eta_context
    ) {
      return;
    }

    if (osrm_r && osrm_r.code == "Ok" && osrm_r.routes && osrm_r.routes[0]) {
      monitor_map_eta_seconds = osrm_r.routes[0].duration;
      return;
    }

    monitor_map_eta_seconds = -1;
  }

  let trafficLayer;
  let map_traffic = false;
  let map_geofence =
    localStorage.getItem("map_geofence") == "true" ? true : false;
  let map;
  let on_map = false;
  let mount_complete = false;
  let map_host;
  let route_detail_map_host;
  let geo_detail_map_host;
  function initMap() {
    map = acquireMainMap("monitor-main", map_host, {
      mapOptions: createVectorMapOptions({
        fullscreenControl: false,
        cameraControl: false,
        mapTypeControl: false,
        rotateControl: false,
        streetViewControl: false,
        zoomControl: false,
      }),
      resetView: MAP_RESET_VIEW.MEXICO_BOUNDS,
      cleanup: cleanup_monitor_main_map,
      recreateOnRelease: true,
    });
    map.addListener("mouseover", function () {
      on_map = true;
    });
    map.addListener("mouseout", function () {
      on_map = false;
    });

    trafficLayer = new google.maps.TrafficLayer();
    if (map_cover) {
      mapa_cobertura(true);
    }
    if (map_traffic) {
      trafficLayer.setMap(map);
    }
    if (map_geofence && last_route_coordenada.length) {
      show_geo(last_route_coordenada);
    }
    syncMonitorMapControls();
    showMapLayerMenu();

    geocoder = new google.maps.Geocoder();

    // center change
    /*
    map.addListener("center_changed", function () {
      geo_dinamic();
    });
    map.addListener("zoom_changed", function () {
      geo_dinamic();
    });
    */
    map.addListener("zoom_changed", syncMonitorMapControls);
    map.addListener("maptypeid_changed", syncMonitorMapControls);
  }

  function mapa_cobertura(type) {
    if (type) {
      var tech = "umts";
      var layers = [tech + "_garantizada"]; //tech + '_no_garantizada',
      for (let x in layers) {
        var layer = new google.maps.ImageMapType({
          getTileUrl: function getTileUrl(coord, zoom) {
            var url = "https://lbsva.telcel.com/tiles/gwc/service/wmts?";
            url += "layer=telcel:" + layers[x];
            url += "&style=";
            url += "&tilematrixset=EPSG:900913";
            url += "&Service=WMTS";
            url += "&Request=GetTile";
            url += "&Version=1.0.0";
            url += "&Format=image/png";
            url += "&TileMatrix=EPSG:900913:" + zoom;
            url += "&TileCol=" + coord.x;
            url += "&TileRow=" + coord.y;
            return url;
          },
          tileSize: new google.maps.Size(256, 256),
          isPng: true,
        });
        map.overlayMapTypes.push(layer);
      }
    } else {
      map.overlayMapTypes.clear();
    }
  }

  onMount(async () => {
    mount_complete = true;
    socket_query.on("connect", handleLightmetricsMonitorReconnect);
    socket_query.on("lightmetrics_monitor_status", handleLightmetricsMonitorStatus);
    socket_query.on("lightmetrics_stream_status", handleLightmetricsStreamStatus);
    hos_cron = setInterval(() => {
      refreshHosStatusList();
    }, 3 * 60 * 1000);
    await Promise.all([loadHosCache(), loadMonitorVisualCache()]);
    hos_cache_ready = true;

    if ($group) {
      hos_group_ready = $group;
      refreshHosStatusList();
      lightmetrics_monitor_last_group = $group;
      subscribeLightmetricsMonitor();
    }
  });
  $: {
    if ($map_ready == 1 && mount_complete && map_host != null && !map) {
      initMap();
      console.log("mapa cargado");
    }
  }

  $: {
    if (mount_complete && user_level > 0) {
      const nextGroup = $group || "";
      if (nextGroup != "" && nextGroup != lightmetrics_monitor_last_group) {
        if (lightmetrics_monitor_last_group != "") {
          unsubscribeLightmetricsMonitor();
        }
        lightmetrics_monitor_last_group = nextGroup;
        subscribeLightmetricsMonitor();
      }
    }
  }

  $: if (
    lightmetrics_stream_modal_open &&
    lightmetrics_stream_request_id != ""
  ) {
    startLightmetricsStreamKeepalive();
  } else {
    clearLightmetricsStreamKeepalive();
  }

  $: if (lightmetrics_stream_modal_open && lightmetrics_stream_url != "") {
    startLightmetricsStreamProbe();
  } else {
    clearLightmetricsStreamProbe();
  }

  $: if (
    lightmetrics_stream_modal_open &&
    lightmetrics_stream_url != "" &&
    lightmetrics_stream_video
  ) {
    loadLightmetricsStreamPlayer();
  }

  function cleanup_monitor_main_map() {
    clearMapLayerMenuAutoHideTimer();
    map_layer_menu_hovered = false;
    has_monitor_map_eta_context = false;
    monitor_map_eta_unit = -1;
    resetMonitorMapEta(true);

    if (trafficLayer) {
      trafficLayer.setMap(null);
      trafficLayer = undefined;
    }

    if (map) {
      map.overlayMapTypes.clear();
    }

    if (typeof m_inicio != "undefined") {
      m_inicio.setMap(null);
      m_inicio = undefined;
    }

    if (typeof m_fin != "undefined") {
      m_fin.setMap(null);
      m_fin = undefined;
    }

    for (let item of recorrido) {
      if (item) {
        item.setMap(null);
      }
    }
    recorrido = [];

    if (typeof recorrido_ruta != "undefined") {
      recorrido_ruta.setMap(null);
      recorrido_ruta = undefined;
    }

    if (typeof m_inicio_ruta != "undefined") {
      m_inicio_ruta.setMap(null);
      m_inicio_ruta = undefined;
    }

    if (typeof m_fin_ruta != "undefined") {
      m_fin_ruta.setMap(null);
      m_fin_ruta = undefined;
    }

    if (typeof l_ruta_estimada != "undefined") {
      l_ruta_estimada.setMap(null);
      l_ruta_estimada = undefined;
    }

    for (let item of circles) {
      item.setMap(null);
    }
    circles = [];

    for (let item of poligons) {
      item.setMap(null);
    }
    poligons = [];

    for (let item of circle_route) {
      item.setMap(null);
    }
    circle_route = [];
    circle_route_ = [];

    for (let item of poligon_route) {
      item.setMap(null);
    }
    poligon_route = [];
    poligon_route_ = [];
    last_route_coordenada = [];

    if (typeof driver_markers != "undefined") {
      driver_markers.setMap(null);
      driver_markers = undefined;
    }

    if (typeof geo_lc != "undefined") {
      geo_lc.setMap(null);
      geo_lc = undefined;
    }

    map_cover = false;
    on_map = false;
    monitor_map_type = "roadmap";
    monitor_map_zoom = MAP_RESET_VIEW.DEFAULT.zoom;
    map = undefined;
  }

  function cleanup_monitor_route_detail_map() {
    if (directionsRenderer) {
      directionsRenderer.setMap(null);
      google.maps.event.clearInstanceListeners(directionsRenderer);
      directionsRenderer = undefined;
    }

    directionsService = undefined;
    all_steps = [];
    map_routes = undefined;
  }

  function focus_monitor_route_bounds(bounds) {
    if (!map_routes || !bounds) {
      return;
    }

    cancelPooledMapReset(
      MAP_POOL_SLOTS.ROUTE_DETAIL,
      "monitor-route-detail"
    );

    let applyBounds = () => {
      if (!map_routes || !bounds) {
        return;
      }

      google.maps.event.trigger(map_routes, "resize");
      map_routes.fitBounds(bounds);
    };

    applyBounds();
    requestAnimationFrame(applyBounds);
    setTimeout(applyBounds, 120);
    setTimeout(applyBounds, 420);
  }

  function cleanup_monitor_geo_detail_map() {
    for (let circle of circles_new) {
      if (circle) {
        circle.setMap(null);
      }
    }
    circles_new = [];
    map_geo = 0;
  }

  let monitor_;
  onDestroy(() => {
    unsubscribeLightmetricsMonitor();
    closeLightmetricsStream("destroy", true);
    clearInterval(monitor_);
    if (monitor_kick_timeout) clearTimeout(monitor_kick_timeout);
    if (monitor_visual_cache_timer) clearTimeout(monitor_visual_cache_timer);
    clearMapLayerMenuAutoHideTimer();
    clearInterval(task_move);
    clearInterval(alert_reload_interval);
    if (hos_cron) clearInterval(hos_cron);
    socket_query.off("connect", handleLightmetricsMonitorReconnect);
    socket_query.off("hos_list", handleHosList);
    socket_query.off("hos_list_", handleHosListInvalidation);
    socket_query.off("lightmetrics_monitor_status", handleLightmetricsMonitorStatus);
    socket_query.off("lightmetrics_stream_status", handleLightmetricsStreamStatus);
    socket_query.off("rtc_offer", rtc_offer);
    socket_query.off("rtc_candidate", rtc_candidate);
    socket_query.off("driver_position");
    clearInterval(external_map_checker);
    bc_control.postMessage({ suspended: true });
    if (auto_travel_timer) clearTimeout(auto_travel_timer);
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    monitorWorker.onmessage = null;
    releasePooledMap(
      MAP_POOL_SLOTS.ROUTE_DETAIL,
      "monitor-route-detail",
      cleanup_monitor_route_detail_map
    );
    releasePooledMap(
      MAP_POOL_SLOTS.GEO_DETAIL,
      "monitor-geo-detail",
      cleanup_monitor_geo_detail_map
    );
    releaseMainMap("monitor-main", cleanup_monitor_main_map);
  });

  $: {
    if (!route_modal) {
      releasePooledMap(
        MAP_POOL_SLOTS.ROUTE_DETAIL,
        "monitor-route-detail",
        cleanup_monitor_route_detail_map
      );
    }
  }

  $: {
    if (!geo_modal) {
      releasePooledMap(
        MAP_POOL_SLOTS.GEO_DETAIL,
        "monitor-geo-detail",
        cleanup_monitor_geo_detail_map
      );
    }
  }

  let units_fw = [
    { type: "geo", name: "Agencia Corona La Alborada", id: "4864071059" },
    { type: "unit", id: "4864071059" },
    { type: "unit", id: "4864071059" },
    { type: "geo", name: "Agencia Corona Tamaulipas" },
    { type: "unit", id: "4864071059" },
    { type: "unit", id: "4864071059" },
    { type: "geo", name: "Agencia Corona La Alborada" },
    { type: "unit", id: "4864071059" },
    { type: "unit", id: "4864071059" },
    { type: "geo", name: "Agencia Corona Tamaulipas" },
    { type: "unit", id: "4864071059" },
    { type: "unit", id: "4864071059" },
  ];

  let units_ufw = [
    { type: "unit", nick: "TZ-419", id: "4864071059" },
    { type: "unit", nick: "TZ-210", id: "4864071059" },
    { type: "unit", nick: "TZ-200", id: "4864071059" },
    { type: "unit", nick: "TZ-100", id: "4864071059" },
    { type: "unit", nick: "TZ-419", id: "4864071059" },
    { type: "unit", nick: "TZ-210", id: "4864071059" },
    { type: "unit", nick: "TZ-200", id: "4864071059" },
    { type: "unit", nick: "TZ-100", id: "4864071059" },
  ];

  let travels_ufw = [
    {
      nick: "TZ-111",
      state: "OK",
      ign: 1,
      ruta: {
        name: "Ruta Corona La Alborada a Corona Tamaulipas",
        id: "4923043",
      },
      org: {
        name: "Agencia Corona La Alborada",
        id: "385434",
        time: "19/02/20 7:22",
      },
      dest: { name: "Agencia Corona Tamaulipas", id: "385434" },
      gps: { state: "OK", level: 0.8 },
      gsm: { state: "OK", level: 0.8, last: 38 },
      mov: { speed: 54, time_stop: 0 },
    },
  ];

  function time_code_s_(time) {
    if (time < 60) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("m[min]");
    } else if (time < 60 * 60) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("m[min]");
    } else if (time < 60 * 60 * 24) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("H[h] m[min]");
    } else if (time < 60 * 60 * 24 * 90) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("D[d] H[h] m[min]");
    } else {
      return "+3 meses";
    }
  }
  function time_code_s(time) {
    //if(time<60){return moment.utc().subtract(1, 'years').startOf('years').add({ seconds: time }).format('s[s]')} // 's[s]'
    if (time < 60) {
      return "0m";
    } else if (time < 3600) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("m[min]");
    } else if (time < 86400) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("H[h] m[min]");
    } else if (time < 7776000) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("D[d] H[h] m[min]");
    } else {
      return "+3 meses";
    }
  }
  function time_code(time) {
    if (time < 60) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ minutes: time })
        .format("m[min]");
    } else if (time < 60 * 24) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ minutes: time })
        .format("H[h] m[min]");
    } else {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ minutes: time })
        .format("D[d] H[h] m[min]");
    }
  }

  function isMonitorNumber(value) {
    return typeof value == "number" && !Number.isNaN(value);
  }

  function getMonitorMetricText(value, fallback = "--") {
    return value == null || value === "" ? fallback : value;
  }

  function createMonitorUnitState(seed = {}) {
    const defaults = {
      mov: { speed: null, time_stop: 0 },
      dest: {},
      ruta: {},
      gsm: { last: null, text: "", level: null, net: "" },
      gps: { level: null },
      pos: {},
      org: { time: "", name: "Desconocido" },
      geo_stay: [],
      alerts_list: [],
      state: "OK",
      monitor_crtl: { follow: 0 },
      oper: "Desconocido",
      alerts_now: 0,
      ign: null,
      outputs: null,
    };

    return {
      ...defaults,
      ...seed,
      mov: { ...defaults.mov, ...(seed.mov || {}) },
      dest: { ...defaults.dest, ...(seed.dest || {}) },
      ruta: { ...defaults.ruta, ...(seed.ruta || {}) },
      gsm: { ...defaults.gsm, ...(seed.gsm || {}) },
      gps: { ...defaults.gps, ...(seed.gps || {}) },
      pos: { ...defaults.pos, ...(seed.pos || {}) },
      org: { ...defaults.org, ...(seed.org || {}) },
      geo_stay: Array.isArray(seed.geo_stay) ? seed.geo_stay : defaults.geo_stay,
      alerts_list: Array.isArray(seed.alerts_list)
        ? seed.alerts_list
        : defaults.alerts_list,
      monitor_crtl: { ...defaults.monitor_crtl, ...(seed.monitor_crtl || {}) },
    };
  }

  let hydrated_monitor_visual_units = {};
  let monitor_visual_cache_loaded = false;
  let monitor_visual_cache_timer = null;

  function applyHydratedMonitorVisualCache() {
    if (!hydrated_monitor_visual_units || typeof hydrated_monitor_visual_units != "object") {
      return;
    }

    let changed = false;
    for (const unitId of Object.keys(hydrated_monitor_visual_units)) {
      if (!travels_fz[unitId]) {
        continue;
      }
      travels_fz[unitId] = createMonitorUnitState({
        ...travels_fz[unitId],
        ...hydrated_monitor_visual_units[unitId],
      });
      changed = true;
    }

    if (changed) {
      travels_fz = { ...travels_fz };
    }
  }

  async function loadMonitorVisualCache() {
    try {
      const cachedSnapshot = await monitor_visual_db.getItem(
        MONITOR_VISUAL_CACHE_KEY
      );
      if (!cachedSnapshot) {
        monitor_visual_cache_loaded = true;
        return;
      }

      const parsedSnapshot =
        typeof cachedSnapshot == "string"
          ? JSON.parse(cachedSnapshot)
          : cachedSnapshot;

      if (parsedSnapshot && typeof parsedSnapshot == "object") {
        hydrated_monitor_visual_units =
          parsedSnapshot.travels_fz && typeof parsedSnapshot.travels_fz == "object"
            ? parsedSnapshot.travels_fz
            : {};

        if (
          parsedSnapshot.future_travel_dist &&
          typeof parsedSnapshot.future_travel_dist == "object"
        ) {
          future_travel_dist = parsedSnapshot.future_travel_dist;
        }

        applyHydratedMonitorVisualCache();
      }
    } catch (_error) {
    } finally {
      monitor_visual_cache_loaded = true;
    }
  }

  function scheduleMonitorVisualCachePersist() {
    if (!monitor_visual_cache_loaded || Object.keys(travels_fz).length === 0) {
      return;
    }

    if (monitor_visual_cache_timer) {
      clearTimeout(monitor_visual_cache_timer);
    }

    monitor_visual_cache_timer = setTimeout(async () => {
      monitor_visual_cache_timer = null;
      try {
        await monitor_visual_db.setItem(
          MONITOR_VISUAL_CACHE_KEY,
          JSON.stringify({
            travels_fz,
            future_travel_dist,
          })
        );
      } catch (_error) {}
    }, MONITOR_VISUAL_CACHE_WRITE_DEBOUNCE_MS);
  }

  units_ufw = [];
  travels_ufw = [];
  let travels_fw = [];
  let travels_fz = {};
  let travels_fh = [];
  units_fw = [];
  let units_fw_p = {};
  let geo_dic = {};
  let travels_fw_master = {};
  let paginas_l = [];
  let monitor_init_sync_done = false;
  let monitor_kick_timeout = null;
  let monitor_last_run_at = 0;
  function schedule_monitor2_now() {
    if (monitor_kick_timeout != null) return;
    const wait = Math.max(
      0,
      MONITOR2_MIN_SEND_INTERVAL_MS - (Date.now() - monitor_last_run_at)
    );
    monitor_kick_timeout = setTimeout(() => {
      monitor_kick_timeout = null;
      monitor2();
    }, wait);
  }
  monitor_ = setInterval(
    () => monitor2({ idleTick: true }),
    MONITOR2_IDLE_TICK_MS
  );
  schedule_monitor2_now();
  $: {
    $live;
    schedule_monitor2_now();
  }
  $: {
    $travels;
    schedule_monitor2_now();
  }
  $: {
    $nicks_list;
    let travel_keys =
      $unit_list_ws_real.length > 0 ? $unit_list_ws_real : $units_list;
    let travel_key_set = new Set(travel_keys);
    if ($unit_list_ws_real.length > 0 && travels_fh.length > 0) {
      travels_fh = travels_fh.filter((travel) => travel_key_set.has(travel.id));
    }
    let existing_travel_ids = new Set(
      travels_fh.map((travel) => travel.id)
    );
    let add_new = false;
    for (const mobid of travel_keys) {
      if (!existing_travel_ids.has(mobid)) {
        travels_fh.push({ id: mobid });
        travels_fz[mobid] = createMonitorUnitState(
          hydrated_monitor_visual_units[mobid] || {}
        );
        existing_travel_ids.add(mobid);
        add_new = true;
      }
    }
    if (add_new) {
      schedule_monitor2_now();
    }
    travels_fh.sort(travels_order);
    travels_fw_master = {};
    for (let w = 0; w < travels_fh.length; w++) {
      travels_fw_master[travels_fh[w].id] = w;
    }
    let travels_fh_c = 0;
    let paginas_c = 0;
    paginas_l = [];
    for (let x in travels_fh) {
      if (travels_fh_c < 100) {
        travels_fh[x]["page"] = 0;
      } else if (travels_fh_c < 200) {
        travels_fh[x]["page"] = 1;
      } else if (travels_fh_c < 300) {
        travels_fh[x]["page"] = 2;
      } else if (travels_fh_c < 400) {
        travels_fh[x]["page"] = 3;
      } else if (travels_fh_c < 500) {
        travels_fh[x]["page"] = 4;
      } else if (travels_fh_c < 600) {
        travels_fh[x]["page"] = 5;
      } else if (travels_fh_c < 700) {
        travels_fh[x]["page"] = 6;
      } else if (travels_fh_c < 800) {
        travels_fh[x]["page"] = 7;
      } else if (travels_fh_c < 900) {
        travels_fh[x]["page"] = 8;
      } else if (travels_fh_c < 1000) {
        travels_fh[x]["page"] = 9;
      }
      travels_fh_c++;
    }
    paginas_c = Math.ceil(travels_fh_c / 100);
    if (paginas_c > 10) paginas_c = 10;
    for (let x = 0; x < paginas_c; x++) {
      paginas_l.push(x);
    }
  }
  $: {
    travels_fz;
    future_travel_dist;

    if (monitor_visual_cache_loaded && Object.keys(travels_fz).length > 0) {
      scheduleMonitorVisualCachePersist();
    }
  }
  $: {
    if (
      !monitor_init_sync_done &&
      Object.keys(travels_fz).length > 0 &&
      Object.keys($travels).length > 0 &&
      Object.keys($live).length > 0
    ) {
      monitor_init_sync_done = true;
      schedule_monitor2_now();
    }
  }
  let monitor_live_store_changed = false;
  let monitor_travels_store_changed = false;
  $: {
    $live;
    monitor_live_store_changed = true;
  }
  $: {
    $travels;
    monitor_travels_store_changed = true;
  }
  // Detectar cambios en geo stores para sincronizar al worker
  $: {
    $geos_map;
    $geos;
    $geos_class;
    $geos_joined;
    $poli;
    _m2_geoVer++;
    schedule_monitor2_now();
  }

  let now_ = Math.round(new Date().getTime() / 1000);
  let future_travel_dist = {};
  function sameFutureTravelDist(left, right) {
    const leftKeys = Object.keys(left || {});
    const rightKeys = Object.keys(right || {});

    if (leftKeys.length !== rightKeys.length) {
      return false;
    }

    for (const key of leftKeys) {
      if (!left[key] || !right[key] || left[key].dist !== right[key].dist) {
        return false;
      }
    }

    return true;
  }
  function monitor2_() {
    let live_ = $live;
    let travels_ = $travels;
    let travel_keys = Object.keys(travels_);
    now_ = Math.round(new Date().getTime() / 1000);
    for (let x in travel_keys) {
      let mobid = travel_keys[x];
      let time_stop = 0;
      if (
        typeof travels_[mobid] != "undefined" &&
        typeof travels_fz[mobid] != "undefined"
      ) {
        if (true) {
          //(mod_on[mobid]||typeof travels_fz[mobid]["ok"]=="undefined")
          if (
            travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
              "ls"
            ] == 1 ||
            travels_[mobid]["travel"].length > 1
          ) {
            if (
              travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
                "ls"
              ] == 1
            ) {
              time_stop =
                travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
                  "p"
                ][
                  travels_[mobid]["travel"][
                    travels_[mobid]["travel"].length - 1
                  ]["p"].length - 1
                ];
              time_stop =
                time_stop.length > 4 ? time_stop[4] - time_stop[3] : 0;
            } else {
              let now = Math.round(new Date().getTime() / 1000);
              time_stop =
                travels_[mobid]["travel"][travels_[mobid]["travel"].length - 2][
                  "p"
                ][
                  travels_[mobid]["travel"][
                    travels_[mobid]["travel"].length - 2
                  ]["p"].length - 1
                ];
              time_stop =
                time_stop.length > 4
                  ? time_stop[4] * 60 +
                    travels_[mobid]["travel"][
                      travels_[mobid]["travel"].length - 2
                    ]["ds"]
                  : time_stop[3] * 60 +
                    travels_[mobid]["travel"][
                      travels_[mobid]["travel"].length - 2
                    ]["ds"];
              time_stop = Math.round((now - time_stop) / 60);
            }

            if (travels_fz[mobid].org.name == "Desconocido") {
              let lat_org_ = travels_[mobid]["travel"][0]["ps"][0] / 10000;
              let lng_org_ = travels_[mobid]["travel"][0]["ps"][1] / 10000;
              let geo_org_ = geo_search(lat_org_, lng_org_);
              travels_fz[mobid].org.name = geo_org_[0];
              let org_time_ = moment(
                new Date(travels_[mobid]["travel"][0]["ds"] * 1000)
              ).format("DD/MM/YY HH:mm");
              travels_fz[mobid].org.time = org_time_;
            }
          }
          travels_fz[mobid]["alerts_now"] =
            typeof travels_[mobid]["alerts_now"] != "undefined"
              ? travels_[mobid]["alerts_now"]
              : travels_fz[mobid]["alerts_now"];
          travels_fz[mobid]["proto_status"] =
            typeof travels_[mobid]["proto_status"] != "undefined"
              ? travels_[mobid]["proto_status"]
              : "";
          travels_fz[mobid].mov.time_stop = time_stop;
          travels_fz[mobid]["monitor_crtl"] = travels_[mobid]["monitor_crtl"];
          travels_fz[mobid]["oper"] =
            typeof travels_[mobid]["monitor_crtl"]["driver"] == "undefined"
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["driver"] == ""
                ? "Desconocido"
                : travels_[mobid]["monitor_crtl"]["driver"];
          travels_fz[mobid]["dest"]["name"] =
            typeof travels_[mobid]["monitor_crtl"]["destino"] == "undefined"
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["destino"] == ""
                ? "Desconocido"
                : travels_[mobid]["monitor_crtl"]["destino"];
          travels_fz[mobid]["ruta"]["name"] =
            typeof travels_[mobid]["monitor_crtl"]["ruta"] == "undefined"
              ? "Desconocida"
              : travels_[mobid]["monitor_crtl"]["ruta"] == ""
                ? "Desconocida"
                : travels_[mobid]["monitor_crtl"]["ruta"];
          travels_fz[mobid]["alerts_list"] =
            typeof travels_[mobid]["alerts_list"] == "undefined"
              ? []
              : travels_[mobid]["alerts_list"];

          let live_mob = live_[mobid];
          if (
            typeof live_mob != "undefined" &&
            (typeof mod_on[mobid] != "undefined" ||
              typeof travels_fz[mobid]["ok"] == "undefined")
          ) {
            //()
            let time_last = now_ - live_mob["last_comm"];
            travels_fz[mobid].gsm.last = time_last < 300 ? true : false;
            travels_fz[mobid].gsm.text = time_code_s(time_last); //time_code_s
            travels_fz[mobid].mov.speed = live_mob["vel"];
            travels_fz[mobid].gsm.level = live_mob["rssi"];
            travels_fz[mobid].gps.level = live_mob["hdop"];
            travels_fz[mobid].gsm.net = live_mob["network"];
            travels_fz[mobid].ign = live_mob["ingnition"];
            travels_fz[mobid].outputs = live_mob["outputs_0"]
              ? live_mob["outputs_0"]
              : null;

            if (
              travels_fz[mobid].pos.lat != live_mob["lat"] &&
              travels_fz[mobid].pos.lon != live_mob["lon"]
            ) {
              travels_fz[mobid].pos.lat = live_mob["lat"];
              travels_fz[mobid].pos.lon = live_mob["lon"];
              let geo_stay_ = geo_search(live_mob["lat"], live_mob["lon"]);
              travels_fz[mobid].geo_stay =
                geo_stay_[0] != "Geocerca_automatica_"
                  ? geo_stay_[1] == 1 && last_geocode == mobid
                    ? travels_fz[mobid].geo_stay
                    : geo_stay_
                  : last_geocode != mobid
                    ? ["", 1, ""]
                    : travels_fz[mobid].geo_stay;
            }
            travels_fz[mobid]["ok"] = "ok";
          }
        }
      }
    }
    // Calculo de distancia a destino
    let future_travel_dist_ = {};
    for (let x in future_travel) {
      if (future_travel[x].dest_pos && live_[future_travel[x].id]) {
        let dist = get_km(
          future_travel[x].dest_pos[0],
          future_travel[x].dest_pos[1],
          live_[future_travel[x].id].lat,
          live_[future_travel[x].id].lon
        );
        if (dist < 0.4) {
          future_travel_dist_[future_travel[x].id] = {
            dist: "llego",
          };
        } else if (dist < 3) {
          future_travel_dist_[future_travel[x].id] = {
            dist: "proximo",
          };
        }
      }
    }
    //check diferencias
    if (!sameFutureTravelDist(future_travel_dist, future_travel_dist_)) {
      future_travel_dist = future_travel_dist_;
    }
  }
  monitorWorker.onmessage = function (event) {
    if (event.data.fun == "monitor2") {
      for (let x in event.data.travels_fz_) {
        travels_fz[x] = event.data.travels_fz_[x];
      }
      if (event.data.future_travel_dist)
        future_travel_dist = event.data.future_travel_dist;
    }
    if (event.data.fun == "get_geos_map" && map && mount_complete) {
      circle_route_ = event.data.circles;
      poligon_route_ = event.data.poligons;
      bc_route.postMessage({
        circle_route_: circle_route_,
        poligon_route_: poligon_route_,
      });
      for (let x in circle_route) {
        circle_route[x].setMap(null);
      }
      circle_route = [];
      for (let x in poligon_route) {
        poligon_route[x].setMap(null);
      }
      poligon_route = [];
      if (!map_geofence) return;
      geo_dinamic();
    }
  };
  // --- Estado para modo incremental de monitor2 ---
  let _m2_initialized = false;
  let _m2_prevLiveRefs = {};
  let _m2_prevTravelsRefs = {};
  let _m2_prevFzKeys = new Set();
  let _m2_prevGeoVer = 0;
  let _m2_geoVer = 0;
  let _m2_prevFt = null;
  let _m2_prevFd = null;
  let _m2_prevLg = null;
  let _m2_prevActiveSignature = "";

  function getMonitor2ActiveUnits() {
    const activeUnits = { ...mod_on };
    if (selected != -1) activeUnits[selected] = true;
    return activeUnits;
  }

  function monitor2({ idleTick = false } = {}) {
    if (Object.keys(travels_fz).length === 0) return;
    monitor_last_run_at = Date.now();
    const activeUnits = getMonitor2ActiveUnits();
    const activeSignature = Object.keys(activeUnits).sort().join("|");

    if (!_m2_initialized) {
      // Primera llamada: enviar estado completo al worker
      monitorWorker.postMessage({
        live: $live,
        travels: $travels,
        travels_fz: travels_fz,
        mod_on: activeUnits,
        future_travel: future_travel,
        future_travel_dist: future_travel_dist,
        last_geocode: last_geocode,
        geos_map: $geos_map,
        geos: $geos,
        geos_class: $geos_class,
        geos_joined: $geos_joined,
        poli: $poli,
        fun: "monitor2_init",
      });
      // Guardar referencias para deteccion de cambios
      const cl = $live;
      const ct = $travels;
      _m2_prevLiveRefs = {};
      for (const id in cl) _m2_prevLiveRefs[id] = cl[id];
      _m2_prevTravelsRefs = {};
      for (const id in ct) _m2_prevTravelsRefs[id] = ct[id];
      _m2_prevFzKeys = new Set(Object.keys(travels_fz));
      _m2_prevGeoVer = _m2_geoVer;
      _m2_prevFt = future_travel;
      _m2_prevFd = future_travel_dist;
      _m2_prevLg = last_geocode;
      _m2_prevActiveSignature = activeSignature;
      monitor_live_store_changed = false;
      monitor_travels_store_changed = false;
      _m2_initialized = true;
      return;
    }

    // Llamadas subsecuentes: solo enviar deltas
    const cl = $live;
    const ct = $travels;
    const dl = {};
    const dt = {};
    const nf = {};
    let hasDelta = false;
    const activeChanged = activeSignature !== _m2_prevActiveSignature;
    const shouldIdleRefresh =
      idleTick && Object.keys(activeUnits).length > 0;
    const shouldScanLive = monitor_live_store_changed;
    const shouldScanTravels = monitor_travels_store_changed;

    if (shouldScanLive) {
      for (const id in cl) {
        if (cl[id] !== _m2_prevLiveRefs[id]) {
          dl[id] = cl[id];
          hasDelta = true;
        }
      }
    }
    if (shouldScanTravels) {
      for (const id in ct) {
        if (ct[id] !== _m2_prevTravelsRefs[id]) {
          dt[id] = ct[id];
          hasDelta = true;
        }
      }
    }
    for (const id in travels_fz) {
      if (!_m2_prevFzKeys.has(id)) {
        nf[id] = travels_fz[id];
        hasDelta = true;
      }
    }

    const futureTravelChanged = future_travel !== _m2_prevFt;
    const futureTravelDistChanged = future_travel_dist !== _m2_prevFd;
    const lastGeocodeChanged = last_geocode !== _m2_prevLg;
    const geoChanged = _m2_geoVer !== _m2_prevGeoVer;

    if (
      !hasDelta &&
      !futureTravelChanged &&
      !futureTravelDistChanged &&
      !lastGeocodeChanged &&
      !geoChanged &&
      (activeChanged || shouldIdleRefresh)
    ) {
      const tickMsg = { fun: "monitor2_tick" };
      if (activeChanged) tickMsg.mo = activeUnits;
      monitorWorker.postMessage(tickMsg);
      if (shouldScanLive) monitor_live_store_changed = false;
      if (shouldScanTravels) monitor_travels_store_changed = false;
      _m2_prevActiveSignature = activeSignature;
      return;
    }

    let shouldSend = hasDelta || activeChanged;
    const msg = { fun: "monitor2_delta" };

    if (hasDelta) {
      msg.dl = dl;
      msg.dt = dt;
      msg.nf = nf;
    }
    if (activeChanged) msg.mo = activeUnits;

    // Solo enviar campos escalares/arrays si cambiaron por referencia
    if (futureTravelChanged) {
      msg.ft = future_travel;
      _m2_prevFt = future_travel;
      shouldSend = true;
    }
    if (futureTravelDistChanged) {
      msg.fd = future_travel_dist;
      _m2_prevFd = future_travel_dist;
      shouldSend = true;
    }
    if (lastGeocodeChanged) {
      msg.lg = last_geocode;
      _m2_prevLg = last_geocode;
      shouldSend = true;
    }

    // Geo data solo se reenvia si cambio
    if (geoChanged) {
      msg.gm = $geos_map;
      msg.ge = $geos;
      msg.gc = $geos_class;
      msg.gj = $geos_joined;
      msg.po = $poli;
      _m2_prevGeoVer = _m2_geoVer;
      shouldSend = true;
    }

    if (!shouldSend) {
      if (shouldScanLive) monitor_live_store_changed = false;
      if (shouldScanTravels) monitor_travels_store_changed = false;
      return;
    }
    monitorWorker.postMessage(msg);

    // Actualizar referencias
    if (shouldScanLive) {
      _m2_prevLiveRefs = {};
      for (const id in cl) _m2_prevLiveRefs[id] = cl[id];
      monitor_live_store_changed = false;
    }
    if (shouldScanTravels) {
      _m2_prevTravelsRefs = {};
      for (const id in ct) _m2_prevTravelsRefs[id] = ct[id];
      monitor_travels_store_changed = false;
    }
    _m2_prevFzKeys = new Set(Object.keys(travels_fz));
    _m2_prevActiveSignature = activeSignature;
  }
  function geo_dinamic_() {
    if (map.getZoom() > 12) {
      let window_map = map.getBounds().toJSON();
      for (let x in circle_route) {
        let c_lat = circle_route[x].getCenter().toJSON().lat;
        let c_lng = circle_route[x].getCenter().toJSON().lng;
        if (
          !(
            ((window_map.north > window_map.south &&
              c_lat > window_map.south &&
              c_lat < window_map.north) ||
              (window_map.north < window_map.south &&
                c_lat < window_map.south &&
                c_lat > window_map.north)) &&
            ((window_map.east > window_map.west &&
              c_lng > window_map.west &&
              c_lng < window_map.east) ||
              (window_map.east < window_map.west &&
                c_lng < window_map.east &&
                c_lng > window_map.west))
          )
        ) {
          circle_route[x].setMap(null);
          circle_route.splice(x, 1);
        }
      }
      for (let x in poligon_route) {
        let c_lat_min = 999999999;
        let c_lng_min = 999999999;
        let c_lat_max = -999999999;
        let c_lng_max = -999999999;
        for (let y = 0; y < poligon_route[x].getPath().getLength(); y++) {
          let r1 = poligon_route[x].getPath().getAt(y);
          if (r1.lat() < c_lat_min) c_lat_min = r1.lat();
          if (r1.lng() < c_lng_min) c_lng_min = r1.lng();
          if (r1.lat() > c_lat_max) c_lat_max = r1.lat();
          if (r1.lng() > c_lng_max) c_lng_max = r1.lng();
        }
        if (
          !(
            ((window_map.north > window_map.south &&
              c_lat_max > window_map.south &&
              c_lat_min < window_map.north) ||
              (window_map.north < window_map.south &&
                c_lat_max < window_map.south &&
                c_lat_min > window_map.north)) &&
            ((window_map.east > window_map.west &&
              c_lng_max > window_map.west &&
              c_lng_min < window_map.east) ||
              (window_map.east < window_map.west &&
                c_lng_max < window_map.east &&
                c_lng_min > window_map.west))
          )
        ) {
          poligon_route[x].setMap(null);
          poligon_route.splice(x, 1);
        }
      }
      for (let x in circle_route_) {
        if (
          ((window_map.north > window_map.south &&
            circle_route_[x][0] > window_map.south &&
            circle_route_[x][0] < window_map.north) ||
            (window_map.north < window_map.south &&
              circle_route_[x][0] < window_map.south &&
              circle_route_[x][0] > window_map.north)) &&
          ((window_map.east > window_map.west &&
            circle_route_[x][1] > window_map.west &&
            circle_route_[x][1] < window_map.east) ||
            (window_map.east < window_map.west &&
              circle_route_[x][1] < window_map.east &&
              circle_route_[x][1] > window_map.west))
        ) {
          let c_found = false;
          for (let z in circle_route) {
            if (
              circle_route[z].getCenter().toJSON().lat == circle_route_[x][0] &&
              circle_route[z].getCenter().toJSON().lng == circle_route_[x][1]
            ) {
              c_found = true;
            }
          }
          if (!c_found) {
            let color_c = "#79b700";
            circle_route.push(
              new google.maps.Circle({
                strokeColor: color_c,
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: color_c,
                fillOpacity: 0.35,
                map: map,
                center: { lat: circle_route_[x][0], lng: circle_route_[x][1] },
                radius: 100,
                zIndex: 3,
              })
            );
          }
        }
      }
      for (let x in poligon_route_) {
        if (
          ((window_map.north > window_map.south &&
            poligon_route_[x][0][0] > window_map.south &&
            poligon_route_[x][0][0] < window_map.north) ||
            (window_map.north < window_map.south &&
              poligon_route_[x][0][0] < window_map.south &&
              poligon_route_[x][0][0] > window_map.north)) &&
          ((window_map.east > window_map.west &&
            poligon_route_[x][0][1] > window_map.west &&
            poligon_route_[x][0][1] < window_map.east) ||
            (window_map.east < window_map.west &&
              poligon_route_[x][0][1] < window_map.east &&
              poligon_route_[x][0][1] > window_map.west))
        ) {
          let c_found = false;
          for (let z in poligon_route) {
            for (let w = 0; w < poligon_route[z].getPath().getLength(); w++) {
              if (
                poligon_route[z].getPath().getAt(w).lat() ==
                  poligon_route_[x][0][0] &&
                poligon_route[z].getPath().getAt(w).lng() ==
                  poligon_route_[x][0][1]
              ) {
                c_found = true;
                break;
              }
            }
          }
          if (!c_found) {
            let color_c = "#79b700";
            let points = [];
            for (let w in poligon_route_[x]) {
              let lat = poligon_route_[x][w][0];
              let lng = poligon_route_[x][w][1];
              points.push({ lat: lat, lng: lng });
            }
            poligon_route.push(
              new google.maps.Polygon({
                paths: points,
                strokeColor: color_c,
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: color_c,
                fillOpacity: 0.35,
                map: map,
                zIndex: 2,
              })
            );
          }
        }
      }
    } else {
      for (let x in circle_route) {
        circle_route[x].setMap(null);
      }
      circle_route = [];
      for (let x in poligon_route) {
        poligon_route[x].setMap(null);
      }
      poligon_route = [];
    }
  }
  function geo_dinamic() {
    for (let x in circle_route) {
      circle_route[x].setMap(null);
    }
    circle_route = [];
    for (let x in circle_route_) {
      circle_route.push(
        new google.maps.Circle({
          strokeColor: "#79b700",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#79b700",
          fillOpacity: 0.35,
          map: map,
          center: {
            lat: circle_route_[x][0],
            lng: circle_route_[x][1],
          },
          radius: 100,
          zIndex: 3,
        })
      );
    }
    for (let x in poligon_route) {
      poligon_route[x].setMap(null);
    }
    poligon_route = [];

    for (let x in poligon_route_) {
      let points = [];
      for (let w in poligon_route_[x]) {
        let lat = poligon_route_[x][w][0];
        let lng = poligon_route_[x][w][1];
        points.push({ lat: lat, lng: lng });
      }
      poligon_route.push(
        new google.maps.Polygon({
          paths: points,
          strokeColor: "#79b700",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#79b700",
          fillOpacity: 0.35,
          map: map,
          zIndex: 5,
        })
      );
    }
  }
  let total_alerts = 0;
  let total_follow = 0;
  let total_wating = 0;
  $: {
    let total_alerts_ = 0,
      total_follow_ = 0,
      total_wating_ = 0;
    for (let x in travels_fz) {
      if (travels_fz[x].alerts_now > 0) total_alerts_++;
      if (travels_fz[x].monitor_crtl.follow == 1) total_follow_++;
      if (
        travels_fz[x].proto_status != "" &&
        typeof travels_fz[x].proto_status != "undefined"
      ) {
        total_wating_++;
      }
    }
    total_alerts = total_alerts_;
    total_follow = total_follow_;
    total_wating = total_wating_;
  }

  function dentro(point, vs) {
    let x = point[0],
      y = point[1];
    let inside = false;
    for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
      let xi = vs[i][0],
        yi = vs[i][1];
      let xj = vs[j][0],
        yj = vs[j][1];
      let intersect =
        yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  }

  function geo_search(lat, lng) {
    let box_size = 0.0001797 * 10; // 200 metros por celula
    let p = Math.floor((lat - 14.5408) / box_size);
    let q = Math.floor((lng + 118.2689) / box_size);
    let key_close_list = [
      p + "_" + q,
      p + "_" + (q + 1),
      p + "_" + (q - 1),
      p + 1 + "_" + q,
      p - 1 + "_" + q,
      p + 1 + "_" + (q + 1),
      p - 1 + "_" + (q - 1),
      p + 1 + "_" + (q - 1),
      p - 1 + "_" + (q + 1),
    ];
    let geos_arround = [];
    for (let w in key_close_list) {
      if ($geos_map[key_close_list[w]]) {
        for (let s in $geos_map[key_close_list[w]]) {
          if (!geos_arround.includes($geos_map[key_close_list[w]][s])) {
            geos_arround.push($geos_map[key_close_list[w]][s]);
          }
        }
      }
    }
    let found = false;
    for (let x in $poli) {
      if (geos_arround.includes(x)) {
        if (dentro([lat, lng], $poli[x][0])) {
          return [$poli[x][1], 2, x];
        }
      }
    }
    for (let x in $geos) {
      // filtro
      if (geos_arround.includes($geos[x][0])) {
        for (let y in $geos[x][1]) {
          let lat_ = $geos[x][1][y][0];
          let lng_ = $geos[x][1][y][1];
          if (get_km(lat, lng, lat_, lng_) <= 0.13) {
            if (typeof $geos_class[$geos[x][0]] != "undefined") {
              return [
                $geos_class[$geos[x][0]][0],
                $geos_class[$geos[x][0]][1],
                $geos[x][0],
              ];
            } else {
              if (typeof $geos_joined[$geos[x][0]] == "undefined") {
                return [
                  "Geocerca_automatica-" + $geos[x][0].split("-")[0],
                  1,
                  $geos[x][0],
                ];
              } else {
                for (let h in $geos_joined[$geos[x][0]]) {
                  if (
                    typeof $geos_class[$geos_joined[$geos[x][0]][h]] !=
                    "undefined"
                  ) {
                    return [
                      $geos_class[$geos_joined[$geos[x][0]][h]][0],
                      $geos_class[$geos_joined[$geos[x][0]][h]][1],
                      $geos_joined[$geos[x][0]][h],
                    ];
                  }
                }
                return [
                  "Geocerca_automatica-" + $geos[x][0].split("-")[0],
                  1,
                  $geos[x][0],
                ];
              }
            }
            found = true;
            break;
          }
        }
        if (found) {
          break;
        }
      }
    }
    return ["Geocerca_automatica_", 1, ""];
  }
  function get_km(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * (Math.PI / 180);
    var dLon = (lon2 - lon1) * (Math.PI / 180);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }
  function travels_order(a, b) {
    if ($nicks_list[b.id] < $nicks_list[a.id]) {
      return 1;
    } else {
      return -1;
    }
    return 0;
  }
  let show_drivers = -1;
  let show_destinos = -1;
  let show_rutas = -1;
  let driver_selected;
  let destino_selected;
  let ruta_selected;
  function drivers_edit(i) {
    show_drivers = i;
  }
  function destino_edit(i) {
    show_destinos = i;
  }
  function ruta_edit(i) {
    show_rutas = i;
  }
  function save_driver(unit, driver_id) {
    console.log(unit, driver_id);
    socket_query.emit("driver_save", unit, driver_id, (data) => {
      if (data == "ok") {
        show_drivers = -1;
      }
    });
  }
  function save_destino(unit, destino_id) {
    console.log(unit, destino_id);
    socket_query.emit("destino_save", unit, destino_id, (data) => {
      if (data == "ok") {
        show_destinos = -1;
      }
    });
  }
  function save_ruta(unit, ruta_id) {
    console.log(unit, ruta_id);
    socket_query.emit("ruta_save", unit, ruta_id, (data) => {
      if (data == "ok") {
        show_rutas = -1;
      }
    });
  }
  let m_inicio,
    m_fin,
    recorrido = [],
    recorrido_ruta,
    m_inicio_ruta,
    m_fin_ruta;
  let l_ruta_estimada;
  let selected = -1;
  let selected_ = -1;
  let live_ = {};
  $: {
    selected;
    schedule_monitor2_now();
  }
  $: {
    const selectedLive = selected != -1 ? $live[selected] : null;
    if (selectedLive && selectedLive !== live_) {
      selected_ = selected;
      maping(selected, {});
      geo_loc();
    }
  }
  var circles = [];
  let poligons = [];
  let task_move;
  let task_move_p = 0;
  function move_mark(m_fin, ini, end) {
    task_move_p = 0;
    try {
      clearInterval(task_move);
    } catch (e) {}
    task_move = setInterval(() => {
      if (typeof m_fin != "undefined") {
        m_fin.setPosition({
          lat: ini.lat + (end.lat - ini.lat) * task_move_p,
          lng: ini.lng + (end.lng - ini.lng) * task_move_p,
        });
        /*
        map.panTo({
          lat: ini.lat + (end.lat - ini.lat) * task_move_p,
          lng: ini.lng + (end.lng - ini.lng) * task_move_p,
        });
        */
      }
      task_move_p = task_move_p + 0.0016;
      if (task_move_p > 1.0016) {
        map.panTo({
          lat: end.lat,
          lng: end.lng,
        });
        try {
          clearInterval(task_move);
        } catch (e) {}
      }
    }, 100);
  }
  const style = document.createElement("style");
  style.innerHTML = `
    .custom-label {
      background-color: white; /* Fondo blanco */
      padding: 2px 5px; /* Espaciado interno */
      border-radius: 3px; /* Bordes redondeados */
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); /* Sombra */
      white-space: nowrap; /* Evita que el texto se divida en varias líneas */
    }
  `;
  document.head.appendChild(style);
  async function maping(mobid, source) {
    cancelMainMapReset("monitor-main");
    if (typeof source.target != "undefined") {
      if (source.target.id != "") {
        if (source.target.id == "alerts_box") {
          console.log("send alerts", source.target.attributes.mobid.value);
          socket_query.emit("alerts_now", source.target.attributes.mobid.value);
        }
        return 0;
      }
      //geocode($live[mobid].lat,$live[mobid].lon,mobid);
    }
    if (typeof $live[mobid] != "undefined")
      geocode($live[mobid].lat, $live[mobid].lon, mobid);
    if (typeof $travels[mobid] != "undefined") {
      if (
        $travels[mobid].monitor_crtl.follow == 0 &&
        (typeof $travels[mobid].monitor_crtl.ruta == "undefined" ||
          $travels[mobid].monitor_crtl.ruta == "")
      )
        ruta_estimada(mobid);
    }
    let bounds = new google.maps.LatLngBounds();
    let zIndex = 0;
    //console.log($travels[mobid],$live[mobid]);
    if (
      typeof $travels[mobid] == "undefined" ||
      typeof $live[mobid] == "undefined"
    ) {
      console.log("$travels||$live not ready");
      return 0;
    }
    if (typeof m_inicio != "undefined") {
      m_inicio.setMap(null);
    }
    if (typeof $travels[mobid].travel[0].p != "undefined") {
      m_inicio = new google.maps.Marker({
        position: {
          lat: $travels[mobid].travel[0]["ps"][0] / 10000,
          lng: $travels[mobid].travel[0]["ps"][1] / 10000,
        },
        map: map,
        animation: google.maps.Animation.DROP,
        icon: "img/dd-start.png",
        zIndex: zIndex,
      });
    }

    let icon_status =
      $live[mobid].ingnition == 0
        ? "wht-blank"
        : $live[mobid].vel == 0
          ? "purple-blank"
          : "grn-blank";
    var image = {
      url: "img/" + icon_status + ".png",
      scaledSize: new google.maps.Size(40, 40),
      labelOrigin: new google.maps.Point(20, -10),
    };

    zIndex++;
    if (typeof m_fin != "undefined") {
      m_fin.setMap(null);
    }
    if (typeof $live[mobid] != "undefined") {
      m_fin = new google.maps.Marker({
        position: { lat: $live[mobid].lat, lng: $live[mobid].lon },
        map: map,
        animation: google.maps.Animation.DROP,
        //icon: image,
        icon: {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          scale: 6, // Escala del icono (tamaño de la flecha)
          rotation: $live[mobid].heading, // Aplica el 'heading' como rotación
          fillColor:
            $live[mobid].ingnition == 0
              ? "#FAFBFA"
              : $live[mobid].vel == 0
                ? "#D580D5"
                : "#80C080",
          fillOpacity: 1,
          strokeWeight: 2,
          labelOrigin: new google.maps.Point(-3, -3),
        },
        zIndex: zIndex,
        label: {
          text:
            typeof $nicks_list[mobid] != "undefined"
              ? $nicks_list[mobid]
              : mobid,
          color: "#212121",
          fontSize: "13px",
          fontWeight: "bold",
          className: "custom-label",
        },
      });
    }

    let coordenada_ruta = [];
    zIndex++;
    zIndex++;
    zIndex++;
    bc_route.postMessage({
      clean: true,
    });
    post_mapping(mobid);

    let coordenada = [];
    for (let x in $travels[mobid].travel) {
      if (typeof $travels[mobid].travel[x].p != "undefined") {
        for (let y in $travels[mobid].travel[x].p) {
          let lat =
            ($travels[mobid].travel[x]["ps"][0] -
              $travels[mobid].travel[x]["p"][y][0]) /
            10000;
          let lng =
            ($travels[mobid].travel[x]["ps"][1] -
              $travels[mobid].travel[x]["p"][y][1]) /
            10000;
          coordenada.push({ lat: lat, lng: lng });
          bounds.extend({ lat: lat, lng: lng });
        }
      }
    }
    if (coordenada.length > 3) osrm(coordenada, zIndex, mobid);

    zIndex++;
    coordenada.push({ lat: $live[mobid].lat, lng: $live[mobid].lon });
    for (let x in recorrido) {
      if (typeof recorrido[x] != "undefined") {
        recorrido[x].setMap(null);
      }
    }
    recorrido = [];
    if (coordenada.length > 0) {
      recorrido.push(
        new google.maps.Polyline({
          path: coordenada,
          geodesic: true,
          strokeColor: "#FF0000",
          strokeOpacity: 1.0,
          strokeWeight: 2.5,
          map: map,
          zIndex: zIndex,
          icons: [
            {
              icon: {
                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                strokeColor: "#b71c1c",
              },
              offset: "100px",
              repeat: "100px",
            },
          ],
        })
      );
    }
    if (
      coordenada.length > 3 &&
      $live[mobid].vel > 9 &&
      window.localStorage.getItem("real_time_icon") == 1
    ) {
      move_mark(
        m_fin,
        coordenada[coordenada.length - 3],
        coordenada[coordenada.length - 1]
      );
    } else {
      try {
        clearInterval(task_move);
      } catch (e) {}
    }

    let geo_end = [];
    for (let x in circles) {
      circles[x].setMap(null);
    }
    for (let x in poligons) {
      poligons[x].setMap(null);
    }
    circles = [];
    poligons = [];
    for (let x in circle_route) {
      circle_route[x].setMap(null);
    }
    circle_route_ = [];
    for (let x in poligon_route) {
      poligon_route[x].setMap(null);
    }
    poligon_route_ = [];
    if (typeof $travels[mobid].monitor_crtl.destino != "undefined") {
      if ($travels[mobid].monitor_crtl.destino != "") {
        if ($geos_full[$travels[mobid].monitor_crtl.destino] != null) {
          var geo = $geos_full[$travels[mobid].monitor_crtl.destino];
          let anti_f = 10;
          let last_join = "";
          while (typeof geo.join != "undefined" || anti_f == 0) {
            last_join = geo.join;
            geo = $geos_full[geo.join];
            anti_f--;
          }
          for (let y in geo["pos"]) {
            let lat = geo["pos"][y][0];
            let lng = geo["pos"][y][1];
            circles.push(
              new google.maps.Circle({
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
                map: map,
                center: { lat: lat, lng: lng },
                radius: 100,
                zIndex: 3,
              })
            );
          }
          bc_route.postMessage({
            circles: geo["pos"],
          });
          if (
            $travels[mobid].monitor_crtl.follow == 1 &&
            (typeof $travels[mobid].monitor_crtl.ruta == "undefined" ||
              $travels[mobid].monitor_crtl.ruta == "")
          ) {
            osrm_destino(geo["pos"][0][0], geo["pos"][0][1], zIndex, mobid);
            if (typeof m_fin_ruta != "undefined") {
              m_fin_ruta.setMap(null);
            }
            m_fin_ruta = new google.maps.Marker({
              position: { lat: geo["pos"][0][0], lng: geo["pos"][0][1] },
              map: map,
              animation: google.maps.Animation.DROP,
              icon: "img/markerB.png",
              zIndex: 0,
            });
            bc_route.postMessage({
              m_fin_ruta: { lat: geo["pos"][0][0], lng: geo["pos"][0][1] },
              m_fin: { lat: $live[mobid].lat, lng: $live[mobid].lon },
              recorrido_ruta: "",
              m_inicio_ruta: "",
            });
          }
        } else if ($poli[$travels[mobid].monitor_crtl.destino] != null) {
          let poli_points = [];
          for (let x in $poli[$travels[mobid].monitor_crtl.destino][0]) {
            poli_points.push({
              lat: $poli[$travels[mobid].monitor_crtl.destino][0][x][0],
              lng: $poli[$travels[mobid].monitor_crtl.destino][0][x][1],
            });
          }
          poligons.push(
            new google.maps.Polygon({
              paths: poli_points,
              strokeColor: "#FF0000",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#FF0000",
              fillOpacity: 0.35,
              map: map,
              zIndex: 5,
            })
          );
          bc_route.postMessage({
            poligons: poli_points,
          });
          if (
            $travels[mobid].monitor_crtl.follow == 1 &&
            (typeof $travels[mobid].monitor_crtl.ruta == "undefined" ||
              $travels[mobid].monitor_crtl.ruta == "")
          ) {
            osrm_destino(poli_points[0].lat, poli_points[0].lng, zIndex, mobid);
            if (typeof m_fin_ruta != "undefined") {
              m_fin_ruta.setMap(null);
            }
            m_fin_ruta = new google.maps.Marker({
              position: { lat: poli_points[0].lat, lng: poli_points[0].lng },
              map: map,
              animation: google.maps.Animation.DROP,
              icon: "img/markerB.png",
              zIndex: 0,
            });
            bc_route.postMessage({
              m_fin_ruta: { lat: poli_points[0].lat, lng: poli_points[0].lng },
              m_fin: { lat: $live[mobid].lat, lng: $live[mobid].lon },
              recorrido_ruta: "",
              m_inicio_ruta: "",
            });
          }
        }
      }
    }

    if (!on_map && typeof map != "undefined") {
      if (
        coordenada.length > 3 &&
        $live[mobid].vel > 9 &&
        window.localStorage.getItem("real_time_icon") == 1
      ) {
        bounds = new google.maps.LatLngBounds();
        bounds.extend(coordenada[coordenada.length - 3]);
        bounds.extend(coordenada[coordenada.length - 1]);
        map.fitBounds(bounds);
      } else {
        map.setZoom(14);
        map.panTo({ lat: $live[mobid].lat, lng: $live[mobid].lon });
      }
    }

    if (selected == mobid && selected_ != mobid) {
      if (coordenada.length > 1 && show_drivers != mobid) {
        map.fitBounds(bounds);
      }
      selected_ = mobid;
    } else if (selected == mobid && selected_ == mobid) {
      selected_ = -1;
    }

    selected = mobid;
    live_ = $live[mobid];

    bc.postMessage({
      selected_: selected_,
      panTo: { lat: $live[mobid].lat, lng: $live[mobid].lon },
      recorrido: coordenada,
      m_fin_ruta:
        coordenada_ruta.length > 0
          ? coordenada_ruta[coordenada_ruta.length - 1]
          : "",
      m_inicio_ruta: coordenada_ruta.length > 0 ? coordenada_ruta[0] : "",
      recorrido_ruta: coordenada_ruta,
      m_inicio:
        typeof $travels[mobid].travel[0].p != "undefined"
          ? {
              lat: $travels[mobid].travel[0]["ps"][0] / 10000,
              lng: $travels[mobid].travel[0]["ps"][1] / 10000,
            }
          : "",
      m_fin: {
        lat: $live[mobid].lat,
        lng: $live[mobid].lon,
        heading: $live[mobid].heading,
        ingnition: $live[mobid].ingnition,
        vel: $live[mobid].vel,
      },
      image_end: image,
      eco:
        typeof $nicks_list[mobid] != "undefined" ? $nicks_list[mobid] : mobid,
      target: typeof source.target,
      driver_name: $travels[mobid]
        ? $travels[mobid].monitor_crtl
          ? $drivers[$travels[mobid].monitor_crtl.driver]
            ? $drivers[$travels[mobid].monitor_crtl.driver].name
              ? $drivers[$travels[mobid].monitor_crtl.driver].name
              : ""
            : ""
          : ""
        : "",
      destino_name: $travels[mobid]
        ? $travels[mobid].monitor_crtl
          ? $poli_full[$travels[mobid].monitor_crtl.destino]
            ? $poli_full[$travels[mobid].monitor_crtl.destino].name
              ? $poli_full[$travels[mobid].monitor_crtl.destino].name
              : ""
            : $geos_full[$travels[mobid].monitor_crtl.destino]
              ? $geos_full[$travels[mobid].monitor_crtl.destino].name
                ? $geos_full[$travels[mobid].monitor_crtl.destino].name
                : ""
              : ""
          : ""
        : "",
      speed: $live[mobid].vel,
      ign: $live[mobid].ingnition,
    });
  }
  async function post_mapping(mobid) {
    let zIndex = 1;
    let coordenada_ruta = [];
    if (typeof $travels[mobid].monitor_crtl.ruta != "undefined") {
      if ($travels[mobid].monitor_crtl.ruta != "") {
        let route;
        try {
          route = await routes_db.getItem($travels[mobid].monitor_crtl.ruta);
        } catch (e) {
          console.log("Error leyendo routa", e);
        }
        if (route != null) {
          let lat_org = route["pos_start"][0];
          let lng_org = route["pos_start"][1];
          for (let x in route["pos"]) {
            let lat = (lat_org - route["pos"][x][0]) / 10000;
            let lng = (lng_org - route["pos"][x][1]) / 10000;
            coordenada_ruta.push({ lat: lat, lng: lng });
          }
        }
      }
    }

    zIndex++;
    if (typeof l_ruta_estimada != "undefined") {
      l_ruta_estimada.setMap(null);
    }
    if (typeof recorrido_ruta != "undefined") {
      recorrido_ruta.setMap(null);
    }
    if (coordenada_ruta.length > 0) {
      recorrido_ruta = new google.maps.Polyline({
        path: coordenada_ruta,
        geodesic: true,
        strokeColor: "#2196f3",
        strokeOpacity: 1.0,
        strokeWeight: 2.5,
        map: map,
        zIndex: zIndex,
      });
    }
    show_geo(coordenada_ruta);

    zIndex++;
    if (typeof m_inicio_ruta != "undefined") {
      m_inicio_ruta.setMap(null);
    }
    if (coordenada_ruta.length > 0) {
      m_inicio_ruta = new google.maps.Marker({
        position: coordenada_ruta[0],
        map: map,
        animation: google.maps.Animation.DROP,
        icon: "img/markerA.png",
        zIndex: zIndex,
      });
    }

    zIndex++;
    if (typeof m_fin_ruta != "undefined") {
      m_fin_ruta.setMap(null);
    }
    if (coordenada_ruta.length > 0) {
      m_fin_ruta = new google.maps.Marker({
        position: coordenada_ruta[coordenada_ruta.length - 1],
        map: map,
        animation: google.maps.Animation.DROP,
        icon: "img/markerB.png",
        zIndex: zIndex,
      });
      updateMonitorMapEta(mobid, coordenada_ruta[coordenada_ruta.length - 1]);
    } else if (prog_selected == mobid) {
      monitor_map_eta_seconds = -1;
    }
    bc_route.postMessage({
      m_fin_ruta:
        coordenada_ruta.length > 0
          ? coordenada_ruta[coordenada_ruta.length - 1]
          : "",
      m_inicio_ruta: coordenada_ruta.length > 0 ? coordenada_ruta[0] : "",
      recorrido_ruta: coordenada_ruta,
      m_fin: { lat: $live[mobid].lat, lng: $live[mobid].lon },
    });

    driver_on_map = $travels[mobid].monitor_crtl.driver;
    // create a driver marker
    if (driver_markers) {
      driver_markers.setMap(null);
    }

    if (!drivers_[$travels[mobid].monitor_crtl.driver]) return;
    if (drivers_[$travels[mobid].monitor_crtl.driver].pos.status != 1) return;

    driver_markers = new google.maps.Marker({
      position: drivers_[$travels[mobid].monitor_crtl.driver].pos,
      map: map,
      title: "Posición del conductor",
      zIndex: 1,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 8,
        fillColor:
          new Date() / 1000 -
            drivers_[$travels[mobid].monitor_crtl.driver].pos.date <
          10 * 60
            ? "#4285F4"
            : "#FF0000",
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: "#FFFFFF",
        labelOrigin: new google.maps.Point(-3, -3),
      },
      label: {
        text: $drivers[$travels[mobid].monitor_crtl.driver].name,
        color: "#212121",
        fontSize: "13px",
        fontWeight: "bold",
        className: "custom-label",
      },
    });
    bc_route.postMessage({
      driver_markers: drivers_[$travels[mobid].monitor_crtl.driver].pos,
      fillColor:
        new Date() / 1000 -
          drivers_[$travels[mobid].monitor_crtl.driver].pos.date <
        10 * 60
          ? "#4285F4"
          : "#FF0000",
      text: $drivers[$travels[mobid].monitor_crtl.driver].name,
    });
  }
  $: {
    selected;
    alert_reload();
    geo_loc();
  }
  function alert_reload() {
    if (selected != -1) {
      socket_query.emit("alert_reload", selected, 3, (data) => {});
    }
  }
  let alert_reload_interval = setInterval(alert_reload, 60 * 1000);

  let geo_lc;
  function geo_loc() {
    const selected_live = selected != -1 ? $live[selected] : undefined;
    if (
      selected != -1 &&
      selected_live &&
      selected_live.lac != null &&
      selected_live.cellid != 0
    ) {
      socket_query.emit(
        "geo_loc",
        selected_live.lac,
        selected_live.cellid,
        (data) => {
          //console.log("geo_loc",data);
          if (typeof geo_lc != "undefined") {
            geo_lc.setMap(null);
          }
          var antenna_ico = {
            url: "img/antenna.png",
            scaledSize: { width: 32, height: 32 },
          };
          geo_lc = new google.maps.Marker({
            position: { lat: data.lat / 10000, lng: data.lon / 10000 },
            map: map,
            animation: google.maps.Animation.DROP,
            icon: antenna_ico,
            zIndex: 0,
          });
        }
      );
    }
  }

  function ecm_reload() {
    if (selected != -1) {
      socket_query.emit("ecm_reload", selected, 3, (data) => {});
    }
  }

  let f_monitor = localStorage.getItem("f_monitor") == 0 ? 0 : 1,
    f_alertas = localStorage.getItem("f_alertas") == 0 ? 0 : 1,
    f_todas = localStorage.getItem("f_todas") == 0 ? 0 : 1,
    f_viaje = localStorage.getItem("f_viaje") == 0 ? 0 : 1,
    f_sinviaje = localStorage.getItem("f_sinviaje") == 0 ? 0 : 1,
    f_dispositivos = localStorage.getItem("f_dispositivos") == 0 ? 0 : 1,
    f_unidades = localStorage.getItem("f_unidades") == 1 ? 1 : 0,
    f_pag = 0;
  function filtro(i) {
    if (i == 0) {
      f_monitor = f_monitor == 1 ? 0 : 1;
      localStorage.setItem("f_monitor", f_monitor);
    }
    if (i == 1) {
      f_alertas = f_alertas == 1 ? 0 : 1;
      localStorage.setItem("f_alertas", f_alertas);
    }
    if (i == 2) {
      f_todas = f_todas == 1 ? 0 : 1;
      localStorage.setItem("f_todas", f_todas);
    }
    if (i == 3) {
      f_viaje = f_viaje == 1 ? 0 : 1;
      f_sinviaje = f_viaje == 0 && f_sinviaje == 0 ? 1 : f_sinviaje;
      localStorage.setItem("f_viaje", f_viaje);
      localStorage.setItem("f_sinviaje", f_sinviaje);
    }
    if (i == 4) {
      f_sinviaje = f_sinviaje == 1 ? 0 : 1;
      f_viaje = f_sinviaje == 0 && f_viaje == 0 ? 1 : f_viaje;
      localStorage.setItem("f_sinviaje", f_sinviaje);
      localStorage.setItem("f_viaje", f_viaje);
    }
    if (i == 5) {
      f_dispositivos = 1;
      f_unidades = 0;
      localStorage.setItem("f_dispositivos", f_dispositivos);
      localStorage.setItem("f_unidades", f_unidades);
    }
    if (i == 6) {
      f_dispositivos = 0;
      f_unidades = 1;
      localStorage.setItem("f_dispositivos", f_dispositivos);
      localStorage.setItem("f_unidades", f_unidades);
    }

    if (i == 7) {
      f_pag = 0;
    }
    if (i == 8) {
      f_pag = 1;
    }
    if (i == 9) {
      f_pag = 2;
    }
    if (i == 10) {
      f_pag = 3;
    }
    if (i == 11) {
      f_pag = 4;
    }
    if (i == 12) {
      f_pag = 5;
    }
    if (i == 13) {
      f_pag = 6;
    }
    if (i == 14) {
      f_pag = 7;
    }
    if (i == 15) {
      f_pag = 8;
    }
    if (i == 16) {
      f_pag = 9;
    }
  }

  function matchesMonitorUnitPage(item) {
    return (f_pag == item.page && f_todas == 1) || f_todas == 0;
  }

  function matchesMonitorUnitFilters(item) {
    const travelState = travels_fz[item.id];
    if (!travelState) {
      return false;
    }

    const matchesStatus =
      (f_monitor == 1 && travelState.oper != "Desconocido") ||
      (f_todas == 1 && travelState.oper == "Desconocido") ||
      (f_alertas == 1 &&
        ((travelState.alerts_list.length > 0 &&
          travelState.monitor_crtl.follow == 1) ||
          travelState.alerts_now > 0));
    const unitTravelTime = travelState.org ? travelState.org.time : "";
    const matchesTravelState =
      (f_viaje == 1 && unitTravelTime != "") ||
      (f_sinviaje == 1 && unitTravelTime == "");
    const matchesType =
      (f_unidades == 1 && typeof future_travel_master[item.id] != "undefined") ||
      f_dispositivos == 1;

    return matchesStatus && matchesTravelState && matchesType;
  }

  function isVisibleMonitorUnit(item, includeAllPages = false) {
    if (!matchesMonitorUnitFilters(item)) {
      return false;
    }

    return includeAllPages ? true : matchesMonitorUnitPage(item);
  }

  function getMonitorSelectorLabel(unitId) {
    return getMonitorSelectorNick(unitId);
  }

  function getMonitorSelectorNick(unitId) {
    return typeof $nicks_list[unitId] != "undefined" ? $nicks_list[unitId] : unitId;
  }

  function normalizeMonitorUnitSearchValue(value) {
    return String(value == null ? "" : value)
      .toLowerCase()
      .trim();
  }

  function getMonitorSelectorSearchHaystack(unitId) {
    return normalizeMonitorUnitSearchValue(
      [unitId, getMonitorSelectorNick(unitId), getMonitorSelectorLabel(unitId)].join(
        " "
      )
    );
  }

  function setMonitorUnitsPanelCollapsed(value) {
    monitor_units_panel_collapsed = value;
    localStorage.setItem("monitor_units_panel_collapsed", value);
    if (value) {
      if (selected == -1 && filtered_monitor_units.length > 0) {
        const initialUnitId = filtered_monitor_units[0].id;
        selectMonitorUnit(initialUnitId);
        syncCollapsedMonitorSelectedUnit(initialUnitId);
      } else {
        syncCollapsedMonitorSelectedUnit(selected);
      }
    } else {
      collapsed_monitor_search_open = false;
      collapsed_monitor_search_query = "";
    }
  }

  function toggleMonitorUnitsPanel() {
    setMonitorUnitsPanelCollapsed(!monitor_units_panel_collapsed);
  }

  function syncMonitorUnitPage(unitId) {
    for (let item of travels_fh) {
      if (item.id != unitId) {
        continue;
      }
      if (f_pag != item.page) {
        f_pag = item.page;
        return true;
      }
      break;
    }
    return false;
  }

  function syncCollapsedMonitorSelectedUnit(unitId) {
    collapsed_monitor_search_editing = false;
    collapsed_monitor_search_query = unitId
      ? getMonitorSelectorLabel(unitId)
      : "";
    collapsed_monitor_search_open = false;
  }

  function selectMonitorUnit(unitId, source = {}) {
    if (!unitId) {
      return;
    }
    selected = unitId;
    syncMonitorUnitPage(unitId);
    prog_selected_future = -1;
    select_prog(unitId);
    setMonitorMapEtaContext(unitId, -1);
    maping(unitId, source);
  }

  function handleCollapsedMonitorSelectorChange(event) {
    collapsed_monitor_search_query = event.target.value;
    collapsed_monitor_search_open = true;
  }

  function openCollapsedMonitorSearch() {
    if (filtered_monitor_units.length > 0) {
      collapsed_monitor_search_open = true;
    }
  }

  function beginCollapsedMonitorSearchEditing() {
    if (filtered_monitor_units.length == 0) {
      return;
    }
    collapsed_monitor_search_editing = true;
    collapsed_monitor_search_open = true;
    if (collapsed_monitor_search_query == collapsed_monitor_active_label) {
      collapsed_monitor_search_query = "";
    }
  }

  function handleCollapsedMonitorSearchFocusOut(event) {
    const nextFocused = event.relatedTarget;
    if (nextFocused && event.currentTarget.contains(nextFocused)) {
      return;
    }
    collapsed_monitor_search_editing = false;
    collapsed_monitor_search_query = collapsed_monitor_active_label;
    collapsed_monitor_search_open = false;
  }

  function selectCollapsedMonitorSearchUnit(unitId) {
    if (!unitId) {
      return;
    }
    selectMonitorUnit(unitId);
    syncCollapsedMonitorSelectedUnit(unitId);
  }

  async function clearCollapsedMonitorSearch() {
    collapsed_monitor_search_editing = true;
    collapsed_monitor_search_query = "";
    collapsed_monitor_search_open = true;
    await tick();
    if (collapsed_monitor_search_input) {
      collapsed_monitor_search_input.focus();
    }
  }

  function handleCollapsedMonitorSearchKeydown(event) {
    if (event.key == "Escape") {
      collapsed_monitor_search_editing = false;
      collapsed_monitor_search_open = false;
      collapsed_monitor_search_query = collapsed_monitor_active_label;
      return;
    }

    if (event.key != "Enter") {
      return;
    }

    event.preventDefault();
    const query = normalizeMonitorUnitSearchValue(collapsed_monitor_search_query);
    if (query == "") {
      if (collapsed_monitor_search_results.length == 1) {
        selectCollapsedMonitorSearchUnit(collapsed_monitor_search_results[0].id);
      }
      return;
    }

    const exactMatch = collapsed_monitor_search_results.find(
      (unit) =>
        normalizeMonitorUnitSearchValue(unit.id) == query ||
        normalizeMonitorUnitSearchValue(getMonitorSelectorNick(unit.id)) == query ||
        normalizeMonitorUnitSearchValue(getMonitorSelectorLabel(unit.id)) == query
    );
    if (exactMatch) {
      selectCollapsedMonitorSearchUnit(exactMatch.id);
      return;
    }

    if (collapsed_monitor_search_results.length == 1) {
      selectCollapsedMonitorSearchUnit(collapsed_monitor_search_results[0].id);
    }
  }

  $: {
    travels_fh;
    travels_fz;
    future_travel_master;
    f_monitor;
    f_alertas;
    f_todas;
    f_viaje;
    f_sinviaje;
    f_dispositivos;
    f_unidades;
    f_pag;

    filtered_monitor_units = Array.isArray(travels_fh)
      ? travels_fh.filter((item) => matchesMonitorUnitFilters(item))
      : [];
    visible_monitor_units =
      f_todas == 1
        ? filtered_monitor_units.filter((item) => matchesMonitorUnitPage(item))
        : filtered_monitor_units;
  }
  $: {
    filtered_monitor_units;
    collapsed_monitor_search_query;

    const searchValue = normalizeMonitorUnitSearchValue(
      collapsed_monitor_search_query
    );
    collapsed_monitor_search_results = filtered_monitor_units
      .filter((item) => {
        if (searchValue == "") {
          return true;
        }
        return getMonitorSelectorSearchHaystack(item.id).includes(searchValue);
      })
      .slice(0, 8);
  }
  $: collapsed_monitor_active_label =
    selected != -1 ? getMonitorSelectorLabel(selected) : "";
  $: {
    monitor_units_panel_collapsed;
    selected;
    collapsed_monitor_active_label;

    if (monitor_units_panel_collapsed && !collapsed_monitor_search_editing) {
      collapsed_monitor_search_query = collapsed_monitor_active_label;
    }
  }
  $: {
    monitor_units_panel_collapsed;
    filtered_monitor_units;
    selected;

    if (
      monitor_units_panel_collapsed &&
      selected == -1 &&
      filtered_monitor_units.length > 0
    ) {
      const initialUnitId = filtered_monitor_units[0].id;
      selectMonitorUnit(initialUnitId);
      syncCollapsedMonitorSelectedUnit(initialUnitId);
    }
  }

  let future_travel = [];
  let future_travel_r = [{ route_m: [] }];
  $: {
    future_travel;
    schedule_monitor2_now();
  }
  // --- Travel panel pagination (DOM optimization) ---
  const TRAVEL_PAGE_SIZE = 20;
  let future_travel_visible_count = 0;
  let future_travel_visible = [];
  $: future_travel_visible_count = future_travel.length;
  $: future_travel_visible = future_travel;
  function loadMoreTravels() {
    if (future_travel_visible_count < future_travel.length) {
      future_travel_visible_count = Math.min(
        future_travel_visible_count + TRAVEL_PAGE_SIZE,
        future_travel.length
      );
    }
  }
  // --- Lazy datalist filtering (DOM optimization) ---
  const DATALIST_MAX_OPTIONS = 50;
  let datalist_query = "";
  let datalist_options = [];
  let datalist_show_defaults = false;
  function primeUnitDatalist(value = "") {
    datalist_query = value || "";
    datalist_show_defaults = String(value || "").trim().length < 2;
  }
  function updateUnitDatalist(value = "") {
    datalist_query = value || "";
    datalist_show_defaults = false;
  }
  function clearUnitDatalist() {
    datalist_query = "";
    datalist_show_defaults = false;
  }
  function resolveUnitIdFromLabel(label) {
    for (let unitId in $nicks_list) {
      if ($nicks_list[unitId] == label) {
        return unitId;
      }
    }
    return "";
  }
  $: {
    const q = datalist_query.toLowerCase().trim();
    const shouldShowDefaults = datalist_show_defaults && q.length < 2;
    if (!shouldShowDefaults && q.length < 2) {
      datalist_options = [];
    } else {
      const matched = [];
      for (let k = 0; k < units_list_p.length && matched.length < DATALIST_MAX_OPTIONS; k++) {
        const uid = units_list_p[k];
        const nick = $nicks_list[uid];
        const label = typeof nick !== "undefined" ? nick : uid;
        if (
          shouldShowDefaults ||
          String(label).toLowerCase().includes(q) ||
          String(uid).includes(q)
        ) {
          matched.push(label);
        }
      }
      datalist_options = matched;
    }
  }
  let eco_selected = "",
    org_selected = "",
    dest_selected = "",
    oper_selected = "",
    id_travel_selected = "",
    route_f_selected = "",
    fechas = [],
    fecha_v,
    hora_v;
  let eco_add_selected = [];
  let horas = [];
  let new_travel_s = false;
  function new_travel() {
    if (!new_travel_s) {
      expand_map = false;
      localStorage.setItem("expand_map", expand_map);
      eco_add_selected = [];
      let lista_viajes_prog = document.getElementById("lista_viajes_prog");
      lista_viajes_prog.scrollTop = 0;
      new_travel_s = true;
      fechas = [];
      horas = [];
      for (let x = 0; x < 3; x++) {
        fechas.push([
          moment().startOf("day").add(x, "days").valueOf() / 1000,
          moment().startOf("day").add(x, "days").format("DD-MM-YY"),
        ]);
      }
      for (let x = 0; x < 48; x++) {
        horas.push([
          x * 30 * 60,
          moment()
            .startOf("day")
            .add(x * 30, "minutes")
            .format("HH:mm"),
        ]);
      }
      future_travel.unshift({
        id: "",
        date_ini: "",
        org: { name: "" },
        dest: { name: "" },
        dest_m: [],
        route: { name: "" },
        route_m: [],
        oper: "",
        sec_dests: [],
        sec_routes: [],
      });
      future_travel_r = [{ route_m: [] }];
      //future_travel = [...future_travel];
    } else {
      new_travel_s = false;
      future_travel.splice(0, 1);
      //future_travel = [...future_travel];
      eco_selected = "";
      org_selected = "";
      dest_selected = "";
      oper_selected = "";
      route_f_selected = "";
      fecha_v = "";
      hora_v = "";
      eco_add_selected = [];
    }
  }
  let saved_ok = false;
  let saved_type, saved_text;
  function save_travel(id, date_ini) {
    if (new_travel_s) {
      // Guardar Viaje
      let future_travel_ex = true;

      let sec_dests = [];
      let sec_routes = [];
      for (let z in future_travel_r[0].route_m) {
        sec_routes.push(future_travel_r[0].route_m[z].name);
      }
      for (let z in future_travel[0].dest_m) {
        if (future_travel[0].dest_m[z].name == "") {
          future_travel_ex = false;
        }
        sec_dests.push(future_travel[0].dest_m[z].name);
      }

      if (
        eco_selected != "" &&
        org_selected != "" &&
        dest_selected != "" &&
        oper_selected != "" &&
        fecha_v != "" &&
        hora_v !== "" &&
        future_travel_ex &&
        eco_add_selected[eco_add_selected.length - 1] != ""
      ) {
        for (let f in $unit_groups) {
          if ($unit_groups[f][0] == eco_selected) {
            console.log("found group");
            for (let p in $unit_groups[f][1]) {
              let eco_add_selected_found = false;
              for (let g in eco_add_selected) {
                if (eco_add_selected[g] == $unit_groups[f][1][p]) {
                  eco_add_selected_found = true;
                }
              }
              if (!eco_add_selected_found) {
                eco_add_selected.push($unit_groups[f][1][p]);
              }
            }
          }
        }

        let fecha_total = fecha_v + hora_v;
        socket_query.emit(
          "travel_save",
          eco_selected,
          org_selected,
          dest_selected,
          oper_selected,
          route_f_selected,
          fecha_total,
          sec_dests,
          sec_routes,
          eco_add_selected,
          id_travel_selected,
          (data) => {
            if (data == "ok") {
              new_travel();
              saved_ok = true;
              saved_text = "Viaje guardado";
              saved_type = "alert-success";
              setTimeout(function () {
                saved_ok = false;
              }, 3000);
            } else {
              saved_ok = true;
              saved_text = "Error en cargar viaje";
              saved_type = "alert-danger";
              setTimeout(function () {
                saved_ok = false;
              }, 3000);
            }
          }
        );
      } else {
        saved_ok = true;
        saved_text = "Completa todos los datos";
        saved_type = "alert-danger";
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
      }
    } // Borrar Viaje
    else {
      e_selected = -1;
      socket_query.emit("travel_delete", id, date_ini, (data) => {
        if (data == "ok") {
          saved_ok = true;
          saved_text = "Viaje borrado";
          saved_type = "alert-success";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        }
      });
    }
  }
  let edit_mode = -1;
  let travel_toe = {};
  let travel_toe_ = {};
  let future_travel_backup = {};
  let con_init_travel_modal = false;
  let con_init_travel_modal_backup = [];
  function edit_travel(i, w) {
    if (edit_mode == -1) {
      edit_mode = i;
      travel_toe.sec_dests = [...future_travel[w].sec_dests];
      travel_toe_.sec_dests = [...future_travel[w].sec_dests];
      travel_toe.sec_routes = [...future_travel[w].sec_routes];
      travel_toe_.sec_routes = [...future_travel[w].sec_routes];
      future_travel_backup.sec_dests = [...future_travel[w].sec_dests];
      future_travel_backup.sec_routes = [...future_travel[w].sec_routes];
      org_selected = future_travel[w].org;
      dest_selected = future_travel[w].dest;
      route_f_selected = future_travel[w].route;
      extra_selected(i);
    } else {
      edit_mode = -1;
      future_travel[w].sec_dests = [...future_travel_backup.sec_dests];
      future_travel[w].sec_routes = [...future_travel_backup.sec_routes];
      org_selected = "";
      dest_selected = "";
      route_f_selected = "";
    }
  }
  function save_edit_travel(id, date_ini) {
    console.log(travel_toe, org_selected, dest_selected, route_f_selected);
    let dest_c = travel_toe.sec_dests.length;
    for (let x in travel_toe.sec_dests) {
      if (travel_toe.sec_dests[x] != "") {
        dest_c--;
      }
    }
    if (org_selected != "" && dest_selected != "" && dest_c == 0) {
      socket_query.emit(
        "travel_update",
        id,
        date_ini,
        org_selected,
        dest_selected,
        route_f_selected,
        travel_toe.sec_dests,
        travel_toe.sec_routes,
        (data) => {
          if (data == "ok") {
            org_selected = "";
            dest_selected = "";
            route_f_selected = "";
            edit_mode = -1;
            saved_ok = true;
            saved_text = "Viaje actualizado";
            saved_type = "alert-success";
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
          } else {
            saved_ok = true;
            saved_text = "Error en actualizar viaje";
            saved_type = "alert-danger";
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
          }
        }
      );
      // Save comments
      socket_query.emit(
        "travel_update_comment",
        change_travel_modal_uuid,
        change_travel_modal_comment,
        parseInt(change_travel_modal_reason),
        (data) => {
          if (data == "ok") {
          }
        }
      );
    } else {
      saved_ok = true;
      saved_text = "Completa todos los datos";
      saved_type = "alert-danger";
      setTimeout(function () {
        saved_ok = false;
      }, 3000);
    }
    change_travel_modal = false;
    change_travel_modal_reason = 0;
    change_travel_modal_comment = "";
    change_travel_modal_uuid = "";
  }
  function add_destino(id, date_ini) {
    future_travel[0].dest_m.push({ name: "" });
    future_travel[0].route_m.push({ name: "" });
    future_travel_r[0].route_m.push({ name: "" });
    future_travel = [...future_travel];
    //console.log(future_travel[0]);
  }
  function launch_travel(
    id,
    date_ini,
    des,
    oper,
    route,
    id_add,
    org = "",
    disable_pos = false
  ) {
    // Check if unit is on origin
    let org_pos = [0, 0];
    if ($geos_full[org] != null) {
      var geo = $geos_full[org];
      let anti_f = 10;
      let last_join = "";
      while (typeof geo.join != "undefined" || anti_f == 0) {
        last_join = geo.join;
        geo = $geos_full[geo.join];
        anti_f--;
      }
      org_pos = [geo["pos"][0][0], geo["pos"][0][1]];
    } else if ($poli[org] != null) {
      let poli_points = [];
      for (let x in $poli[org][0]) {
        poli_points.push({
          lat: $poli[org][0][x][0],
          lng: $poli[org][0][x][1],
        });
      }
      org_pos = [poli_points[0].lat, poli_points[0].lng];
    }
    console.log("org_pos", org_pos);
    let actual_geo = geo_search($live[id].lat, $live[id].lon);
    if (
      org != actual_geo[2] &&
      get_km(org_pos[0], org_pos[1], $live[id].lat, $live[id].lon) > 1 &&
      !disable_pos
    ) {
      con_init_travel_modal_backup = [
        id,
        date_ini,
        des,
        oper,
        route,
        id_add,
        org,
      ];
      con_init_travel_modal = true;
      return;
    }
    con_init_travel_modal_backup = [];

    socket_query.emit(
      "travel_launch",
      id,
      date_ini,
      des,
      oper,
      route,
      id_add,
      (data) => {
        if (data == "ok") {
          saved_ok = true;
          saved_text = "Viaje iniciado";
          saved_type = "alert-success";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        } else if (data == "error1") {
          saved_ok = true;
          saved_text = "Error, Unidad con viaje en proceso";
          saved_type = "alert-danger";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        }
      }
    );
  }
  let units_list_p;
  $: {
    units_list_p = [...$units_list];
    $nicks_list;
    units_list_p.sort(units_order);
  }
  function units_order(a, b) {
    if ($nicks_list[b] < $nicks_list[a]) {
      return 1;
    } else {
      return -1;
    }
    return 0;
  }
  let future_travel_p = [];
  $: {
    future_travel_p = [...$travel_crtl];
    if (new_travel_s) {
      future_travel_p.unshift(future_travel[0]);
    }
    for (let x in future_travel_p) {
      // Normaliza payload legado/incompleto para evitar crashes por `undefined.length`.
      if (!Array.isArray(future_travel_p[x].sec_dests)) {
        future_travel_p[x].sec_dests = [];
      }
      if (!Array.isArray(future_travel_p[x].sec_routes)) {
        future_travel_p[x].sec_routes = [];
      }
      future_travel_p[x].id_add = normalizeTravelIdAdd(future_travel_p[x].id_add);
      if (typeof future_travel_p[x].step !== "number") {
        future_travel_p[x].step = Number(future_travel_p[x].step) || 0;
      }
      if (future_travel_p[x].step != 0) {
        if ($poli_full[future_travel_p[x].dest])
          future_travel_p[x].dest_pos =
            $poli_full[future_travel_p[x].dest].pos[0];
        else if ($geos_full[future_travel_p[x].dest]) {
          if (!$geos_full[future_travel_p[x].dest].join)
            future_travel_p[x].dest_pos =
              $geos_full[future_travel_p[x].dest].pos[0];
          else {
            let geo = $geos_full[future_travel_p[x].dest];
            let anti_f = 10;
            while (typeof geo.join != "undefined" || anti_f == 0) {
              geo = $geos_full[geo.join];
              anti_f--;
            }
            future_travel_p[x].dest_pos = geo["pos"] ? geo["pos"][0] : [0, 0];
          }
        }
      }
    }
    // order future travels_p with future_travel_dist
    future_travel_p.sort((a, b) => {
      if (b.id == "" && a.id != "") return 1;
      if (a.id == "" && b.id != "") return -1;
      if (future_travel_dist[a.id] && future_travel_dist[b.id]) {
        if (
          future_travel_dist[a.id] == "llego" &&
          future_travel_dist[b.id] != "llego"
        )
          return 1;
        if (
          future_travel_dist[a.id] != "llego" &&
          future_travel_dist[b.id] == "llego"
        )
          return -1;
        return 0;
      }

      if (future_travel_dist[a.id] && !future_travel_dist[b.id]) {
        return -1;
      } else if (!future_travel_dist[a.id] && future_travel_dist[b.id]) {
        return 1;
      }
      return 0;
    });
    // Filter with  unit_list_ws_real
    if ($unit_list_ws_real.length > 0) {
      future_travel_p = future_travel_p.filter((x) => {
        return $unit_list_ws_real.includes(x.id) || x.id == "";
      });
    }
    // mark first future travel
    for (let x in future_travel_p) {
      if (future_travel_p[x].step == 0) {
        future_travel_p[x].first_programed = true;
        break;
      }
    }
    // mark first first dist
    for (let x in future_travel_p) {
      if (future_travel_dist[future_travel_p[x].id]) {
        future_travel_p[x].first_dist = true;
        future_travel_p[x].first_no_dist = false;
        break;
      }
    }
    // mart first no dist
    for (let x in future_travel_p) {
      if (
        !future_travel_dist[future_travel_p[x].id] &&
        future_travel_p[x].step != 0 &&
        future_travel_p[x].first_dist != true
      ) {
        future_travel_p[x].first_no_dist = true;
        break;
      }
    }
    future_travel = [...future_travel_p];
    future_travel_visible_count = future_travel.length;
  }
  let route_list_ = [];
  $: {
    let route_list_p = [];
    $geos_class;
    $geos;
    $poli;
    for (let x in $route_list) {
      route_list_p.push($route_list[x]);
      let geo = geo_search(
        $route_list[x][2][0] / 10000,
        $route_list[x][2][1] / 10000
      );
      route_list_p[x][2][2] = geo[2];
      geo = geo_search(
        $route_list[x][3][0] / 10000,
        $route_list[x][3][1] / 10000
      );
      route_list_p[x][3][2] = geo[2];
    }
    route_list_ = [...route_list_p];
  }
  let e_selected = -1;
  function extra_selected(i) {
    e_selected = i;
  }
  function end_travel(id, date_ini, id_add) {
    socket_query.emit("end_travel", id, date_ini, id_add, (data) => {
      if (data == "ok") {
        saved_ok = true;
        saved_text = "Viaje Cerrado";
        saved_type = "alert-success";
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
        close_travel_modal = true;
      } else if (data == "error1") {
        saved_ok = true;
        saved_text =
          "Error, el viaje fue cerrado manualmente, asigne de nuevo al operador para cerrar correctamente.";
        saved_type = "alert-danger";
        setTimeout(function () {
          saved_ok = false;
        }, 5000);
      }
    });
  }
  let route_modal = false;
  let route_name;
  let route_modal_org = 0;
  let route_modal_edit = false;
  function route_options(i, edit) {
    console.log("route_modal_org", route_modal_org);
    route_modal_org = i;
    route_modal_edit = edit;
    let con_s = false;

    if (route_modal_org == 0) {
      if (org_selected != "" && dest_selected != "") con_s = true;
    } else if (route_modal_org == 1) {
      if (edit) {
        if (
          dest_selected != "" &&
          travel_toe.sec_dests[route_modal_org - 1] != ""
        )
          con_s = true;
        console.log(travel_toe.sec_dests[route_modal_org - 1]);
      } else {
        if (
          dest_selected != "" &&
          future_travel[0].dest_m[route_modal_org - 1].name != ""
        )
          con_s = true;
      }
    } else {
      if (edit) {
        if (
          travel_toe.sec_dests[route_modal_org - 2] != "" &&
          travel_toe.sec_dests[route_modal_org - 1] != ""
        )
          con_s = true;
      } else {
        if (
          future_travel[0].dest_m[route_modal_org - 2].name != "" &&
          future_travel[0].dest_m[route_modal_org - 1].name != ""
        )
          con_s = true;
      }
    }

    if (con_s) {
      new Contextual({
        isSticky: false,
        items: [
          {
            label: "Generar nueva ruta",
            onClick: () => {
              route_modal = true;
            },
          },
          { label: "Cancelar", onClick: () => {} },
        ],
      });
    }
  }
  let map_routes;
  let all_steps;
  var directionsService;
  var directionsRenderer;
  let geocoder;
  function show_route_map() {
    let org_pos = "",
      dest_pos = "";
    let org_selected_, dest_selected_;
    for (let x in $geos_class_list) {
      if (route_modal_org == 0) {
        if ($geos_class_list[x][0] == org_selected) {
          org_selected_ = $geos_class_list[x][3];
        }
        if ($geos_class_list[x][0] == dest_selected) {
          dest_selected_ = $geos_class_list[x][3];
        }
      } else if (route_modal_org == 1) {
        if ($geos_class_list[x][0] == dest_selected) {
          org_selected_ = $geos_class_list[x][3];
        }
        if (route_modal_edit) {
          if (
            $geos_class_list[x][0] == travel_toe.sec_dests[route_modal_org - 1]
          ) {
            dest_selected_ = $geos_class_list[x][3];
          }
        } else {
          if (
            $geos_class_list[x][0] ==
            future_travel[0].dest_m[route_modal_org - 1].name
          ) {
            dest_selected_ = $geos_class_list[x][3];
          }
        }
      } else {
        if (route_modal_edit) {
          if (
            $geos_class_list[x][0] == travel_toe.sec_dests[route_modal_org - 2]
          ) {
            org_selected_ = $geos_class_list[x][3];
          }
          if (
            $geos_class_list[x][0] == travel_toe.sec_dests[route_modal_org - 1]
          ) {
            dest_selected_ = $geos_class_list[x][3];
          }
        } else {
          if (
            $geos_class_list[x][0] ==
            future_travel[0].dest_m[route_modal_org - 2].name
          ) {
            org_selected_ = $geos_class_list[x][3];
          }
          if (
            $geos_class_list[x][0] ==
            future_travel[0].dest_m[route_modal_org - 1].name
          ) {
            dest_selected_ = $geos_class_list[x][3];
          }
        }
      }
    }
    for (let x in $geos) {
      if ($geos[x][0] == org_selected_) {
        org_pos = { lat: $geos[x][1][0][0], lng: $geos[x][1][0][1] };
      }
      if ($geos[x][0] == dest_selected_) {
        dest_pos = { lat: $geos[x][1][0][0], lng: $geos[x][1][0][1] };
      }
      if (org_pos != "" && dest_pos != "") {
        break;
      }
    }
    if (org_pos == "") {
      if (route_modal_org == 0) {
        let c_ = centro($poli[org_selected][0]);
        org_pos = { lat: c_[0], lng: c_[1] };
      } else if (route_modal_org == 1) {
        let c_ = centro($poli[dest_selected][0]);
        org_pos = { lat: c_[0], lng: c_[1] };
      } else {
        if (route_modal_edit) {
          let c_ = centro($poli[travel_toe.sec_dests[route_modal_org - 2]][0]);
          org_pos = { lat: c_[0], lng: c_[1] };
        } else {
          let c_ = centro(
            $poli[future_travel[0].dest_m[route_modal_org - 2].name][0]
          );
          org_pos = { lat: c_[0], lng: c_[1] };
        }
      }
    }
    if (dest_pos == "") {
      if (route_modal_org == 0) {
        let c_ = centro($poli[dest_selected][0]);
        dest_pos = { lat: c_[0], lng: c_[1] };
      } else if (route_modal_org == 1) {
        if (route_modal_edit) {
          let c_ = centro($poli[travel_toe.sec_dests[route_modal_org - 1]][0]);
          dest_pos = { lat: c_[0], lng: c_[1] };
        } else {
          let c_ = centro(
            $poli[future_travel[0].dest_m[route_modal_org - 1].name][0]
          );
          dest_pos = { lat: c_[0], lng: c_[1] };
        }
      } else {
        if (route_modal_edit) {
          let c_ = centro($poli[travel_toe.sec_dests[route_modal_org - 1]][0]);
          dest_pos = { lat: c_[0], lng: c_[1] };
        } else {
          let c_ = centro(
            $poli[future_travel[0].dest_m[route_modal_org - 1].name][0]
          );
          dest_pos = { lat: c_[0], lng: c_[1] };
        }
      }
    }

    tick().then(() => {
      map_routes = acquirePooledMap(
        MAP_POOL_SLOTS.ROUTE_DETAIL,
        "monitor-route-detail",
        route_detail_map_host,
        {
          mapOptions: createVectorMapOptions(),
          resetView: MAP_RESET_VIEW.MEXICO_BOUNDS,
          cleanup: cleanup_monitor_route_detail_map,
          recreateOnRelease: true,
        }
      );

      if (!map_routes) {
        return;
      }

      cancelPooledMapReset(MAP_POOL_SLOTS.ROUTE_DETAIL, "monitor-route-detail");

      directionsService = new google.maps.DirectionsService();
      directionsRenderer = new google.maps.DirectionsRenderer({
        draggable: true,
        map: map_routes,
      });

      directionsRenderer.addListener("directions_changed", function () {
        cancelPooledMapReset(MAP_POOL_SLOTS.ROUTE_DETAIL, "monitor-route-detail");
        directionsRenderer.setMap(map_routes);
        console.log(
          directionsRenderer.getDirections().routes[0].legs[0].distance.text
        );
        console.log(
          directionsRenderer.getDirections().routes[0].legs[0].duration.text
        );
        focus_monitor_route_bounds(
          directionsRenderer.getDirections().routes[0].bounds
        );
        let steps = directionsRenderer.getDirections().routes[0].legs[0].steps;
        all_steps = [];
        for (let z in steps) {
          for (let w in steps[z].lat_lngs) {
            all_steps.push([
              steps[z].lat_lngs[w].lat(),
              steps[z].lat_lngs[w].lng(),
            ]);
          }
        }
        if (all_steps.length > 0) {
          all_steps.unshift([org_pos.lat, org_pos.lng]);
          all_steps.push([dest_pos.lat, dest_pos.lng]);
        }
      });

      if (org_pos != "" && dest_pos != "") {
        displayRoute(org_pos, dest_pos, directionsService, directionsRenderer);
      }
    });
    //map_routes.fitBounds(bounds);
  }
  function displayRoute(origin, destination, service, display) {
    console.log("displayRoute", "origin", origin, "destination", destination);
    service.route(
      {
        origin: origin,
        destination: destination,
        waypoints: [],
        travelMode: "DRIVING",
        avoidTolls: false,
      },
      function (response, status) {
        if (status === "OK") {
          //console.log("Servicio ok ",response);
          cancelPooledMapReset(MAP_POOL_SLOTS.ROUTE_DETAIL, "monitor-route-detail");
          display.setDirections(response);
          focus_monitor_route_bounds(response.routes[0].bounds);
        } else {
          saved_ok = true;
          saved_text = "Ruta no disponible";
          saved_type = "alert-danger";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        }
      }
    );
  }
  function save_new_route() {
    route_modal = false;
    let out_vector = [];
    if (all_steps.length > 0) {
      let lat_start = Math.round(all_steps[0][0] * 10000);
      let lng_start = Math.round(all_steps[0][1] * 10000);
      out_vector.push({
        pos_start: [lat_start, lng_start],
        pos: [[0, 0]],
        stops: [],
      });
      for (let x in all_steps) {
        let lat_ = Math.round(all_steps[x][0] * 10000);
        let lng_ = Math.round(all_steps[x][1] * 10000);
        if (
          lat_start != lat_ &&
          lng_start != lng_ &&
          (out_vector[0].pos[out_vector[0].pos.length - 1][0] !=
            lat_start - lat_ ||
            out_vector[0].pos[out_vector[0].pos.length - 1][1] !=
              lng_start - lng_)
        ) {
          out_vector[0].pos.push([lat_start - lat_, lng_start - lng_]);
        }
      }
      console.log(out_vector[0]);

      socket_query.emit(
        "route_save",
        route_name.value,
        out_vector[0],
        1,
        (data) => {
          if (data == "ok") {
            saved_type = "alert-success";
            saved_text = "Ruta Guardada";
            saved_ok = true;
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
          }
        }
      );
    }
  }
  function cancel_new_route() {
    route_modal = false;
  }
  $: {
    if ($internal_com != null) {
      if (typeof $internal_com["monitor_set"] != "undefined")
        auto_select($internal_com["monitor_set"]);
    }
  }
  function auto_select(id) {
    if (selected != id) {
      prog_selected_future = -1;
      select_prog(id);
      setMonitorMapEtaContext(id, -1);
      maping(id, {});
    }
    let unit_seg = document.getElementById("seg_" + id);
    if (unit_seg != null) {
      unit_seg.scrollIntoView();
    }
  }
  let total_terminado = 0;
  let total_en_proceso = 0;
  let future_travel_master = {};
  $: {
    let total_terminado_ = 0,
      total_en_proceso_ = 0;
    let future_travel_master_ = {};
    for (let x in future_travel) {
      if (future_travel[x].step - 2 == future_travel[x].sec_dests.length) {
        total_terminado_++;
      } else if (future_travel[x].step > 0) {
        total_en_proceso_++;
      }
      if (future_travel[x].step > 0) {
        future_travel_master_[future_travel[x].id] = normalizeTravelIdAdd(
          future_travel[x].id_add
        );
      }
    }
    total_terminado = total_terminado_;
    total_en_proceso = total_en_proceso_;
    future_travel_master = future_travel_master_;
  }
  let mapa_ex_mode = $monitor_extra_map;
  if (!mapa_ex_mode) bc_control.postMessage({ close: true });
  else bc_control.postMessage({ suspended: false });
  let external_map;
  let external_map_checker;
  function mapa_ex() {
    mapa_ex_mode = mapa_ex_mode ? false : true;
    if (mapa_ex_mode) {
      expand_map = false;
      external_map = window.open(
        "/mapa.html",
        "_blank",
        `width=${screen.width},height=${screen.height},top=0,left=0`
      );
      window.focus();
      monitor_extra_map.set(true);
      clearInterval(external_map_checker);
      external_map_checker = setInterval(function () {
        if (external_map.closed && mapa_ex_mode) {
          mapa_ex();
          clearInterval(external_map_checker);
        }
      }, 5000);
    } else {
      monitor_extra_map.set(false);
      try {
        external_map.close();
      } catch (e) {}
      bc_control.postMessage({ close: true });
    }
  }
  $: {
    mapa_ex_mode = $monitor_extra_map;
  }

  let observer_ops = {
    root: document.getElementById("followed_travel_list"),
    rootMargin: "0px",
    threshold: 0,
  };
  /*
    let observer_ctl = {};
    var observer = new IntersectionObserver(observer_func, observer_ops);
    async function observer_func(event)
    {
        for(let x in event)
        {
            observer_ctl[event[x].target.id.split("seg_")[1]]=event[x].isIntersecting;
            //console.log(observer_ctl);
        }
    }
  */
  function obs_travel(i) {
    //console.log(i.getAttribute("id"));
    //observer.observe(i);
  }

  let prog_selected = -1;
  let prog_selected_future = -1;
  function select_prog(id) {
    let found = false;
    for (let x = 0; x < future_travel.length; x++) {
      if (future_travel[x].step > 0 && future_travel[x].id == id) {
        prog_selected = id;
        found = true;
        // Expand visible travel list if needed so the card is in the DOM
        const idx = parseInt(x) + 1;
        if (idx > future_travel_visible_count) {
          future_travel_visible_count = Math.min(idx + TRAVEL_PAGE_SIZE, future_travel.length);
        }
        const dateIni = future_travel[x].date_ini;
        // Double tick: first for reactive update, second for DOM render
        tick().then(() => tick()).then(() => {
          let unit_prog = document.getElementById("prog_" + id + dateIni);
          if (unit_prog != null) {
            unit_prog.scrollIntoView({ block: "center" });
          }
        });
        break;
      }
    }
    if (!found) prog_selected = -1;
  }
  let close_travel_modal = false;
  function send_travel_modal() {
    socket_query.emit(
      "travel_comment",
      c_travel_uuid,
      travel_end_comment,
      parseInt(travel_end_reason),
      (data) => {
        if (data == "ok") {
          close_travel_modal = false;
          c_travel_uuid = "";
          travel_end_comment = "";
        }
      }
    );
  }
  let c_travel_uuid = "";
  let travel_end_reason = 0;
  let travel_end_comment = "";
  let travel_modal_id, travel_modal_date_ini, travel_modal_id_add;
  function end_travel_modal(id, date_ini, uuid, id_add) {
    c_travel_uuid = uuid;
    travel_end_reason = 0;
    con_close_travel_modal = true;
    travel_modal_id = id;
    travel_modal_date_ini = date_ini;
    travel_modal_id_add = id_add; //end_travel(id,date_ini,id_add);
  }

  function edit_del_destino(org, i) {
    if (i == 0 && future_travel[org].sec_dests.length > 0) {
      future_travel[org].dest = future_travel[org].sec_dests[0];
      future_travel[org].sec_dests.splice(0, 1);
      dest_selected = future_travel[org].dest;
      travel_toe.sec_dests.splice(0, 1);
      travel_toe_.sec_dests.splice(0, 1);

      future_travel[org].route = future_travel[org].sec_routes[0];
      future_travel[org].sec_routes.splice(0, 1);
      route_f_selected = future_travel[org].route;
      travel_toe.sec_routes.splice(0, 1);
      travel_toe_.sec_routes.splice(0, 1);
    } else {
      future_travel[org].sec_dests.splice(i - 1, 1);
      travel_toe.sec_dests.splice(i - 1, 1);
      travel_toe_.sec_dests.splice(i - 1, 1);

      future_travel[org].sec_routes.splice(i - 1, 1);
      travel_toe.sec_routes.splice(i - 1, 1);
      travel_toe_.sec_routes.splice(i - 1, 1);
    }
    future_travel[org] = future_travel[org];
  }
  function edit_add_destino(org, i) {
    future_travel[org].sec_dests.push("");
    travel_toe.sec_dests.push("");
    travel_toe_.sec_dests.push("");

    future_travel[org].sec_routes.push("");
    travel_toe.sec_routes.push("");
    travel_toe_.sec_routes.push("");

    future_travel[org] = future_travel[org];
  }
  let id_add_selected = -1;
  $: {
    if ($recognition == "monitoreadas") {
      filtro(0);
    }
    if ($recognition == "con alertas") {
      filtro(1);
    }
    if ($recognition == "sin monitoreo") {
      filtro(2);
    }
  }
  let eco_f = "",
    eco_f_;
  $: {
    if (eco_f != "") {
      let change_page = false;
      for (let x in travels_fh) {
        if (travels_fh[x].id == eco_f) {
          if (f_pag != travels_fh[x].page) {
            f_pag = travels_fh[x].page;
            change_page = true;
          }
          break;
        }
      }
      buscar_unidad(eco_f, change_page);
      //let unit_seg = document.getElementById("seg_"+eco_f);
      //if(unit_seg!=null){unit_seg.scrollIntoView();maping(eco_f,{});select_prog(eco_f)}
    }
  }
  async function buscar_unidad(eco, change_page) {
    if (change_page) await tick();
    let unit_seg = document.getElementById("seg_" + eco);
    if (unit_seg != null) {
      unit_seg.scrollIntoView();
      prog_selected_future = -1;
      select_prog(eco);
      setMonitorMapEtaContext(eco, -1);
      maping(eco, {});
    }
    eco_f = "";
    eco_f_ = "";
    document.getElementById("eco_f").value = "";
  }

  async function busca_future_travel(eco) {
    let change_page = false;
    for (let x in travels_fh) {
      if (travels_fh[x].id == eco) {
        if (f_pag != travels_fh[x].page) {
          f_pag = travels_fh[x].page;
          change_page = true;
        }
        break;
      }
    }
    if (change_page) await tick();
    if (document.getElementById("seg_" + eco) != null) {
      document.getElementById("seg_" + eco).scrollIntoView();
    }
  }

  let con_close_travel_modal = false;
  let con_delete_travel_modal = false;
  function save_travel_modal(id, date_ini) {
    travel_modal_id = id;
    travel_modal_date_ini = date_ini;
    con_delete_travel_modal = true;
  }
  let caravan_mode = false;
  let caravan_group = [];
  function caravan() {
    console.log(caravan_group);
    if (caravan_mode) {
      if (caravan_group.length > 0) {
        socket_query.emit("travel_caravan", caravan_group, (data) => {
          if (data == "ok") {
            saved_type = "alert-success";
            saved_text = "Caravana creada";
            saved_ok = true;
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
            caravan_mode = false;
            caravan_group = [];
          } else {
            saved_type = "alert-danger";
            saved_text = "Error en crear Caravana";
            saved_ok = true;
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
          }
        });
      }
    } else {
      caravan_group = [];
      caravan_mode = true;
    }
  }
  let actual_name = "";
  let last_geocode = "";
  let last_geocode_pos = "";
  $: {
    last_geocode;
    schedule_monitor2_now();
  }
  async function geocode(lat, lon, mobid) {
    last_geocode = mobid;
    let next_geocode_pos = lat + "," + lon;

    if (last_geocode_pos != next_geocode_pos) {
      last_geocode_pos = next_geocode_pos;
      // Modo Nominatim
      let dir_ = await fetchJsonSafe(
        EXT_OMNI_GEOC_URL + "/reverse?lat=" +
          lat +
          "&lon=" +
          lon +
          "&format=json&polygon_text=1",
        { fallback: null, logLabel: "monitor geocode" }
      );
      if (!dir_) {
        actual_name = "";
        return;
      }
      //console.log(dir_);
      if (
        typeof dir_.display_name != "undefined" &&
        typeof travels_fz[mobid].geo_stay[0] != "undefined"
      ) {
        //console.log(dir_.display_name);
        actual_name = dir_.display_name;
        if (
          travels_fz[mobid].geo_stay[0].split("-")[0] ==
            "Geocerca_automatica" ||
          travels_fz[mobid].geo_stay[0] == ""
        ) {
          travels_fz[mobid].geo_stay[0] = actual_name;
        }
      } else {
        console.log("error en geocode");
        actual_name = "";
      }
    }
  }
  function truncate_monitor_text(value, maxLength = 45) {
    if (typeof value != "string") return "";
    if (value.length <= maxLength) return value;
    if (maxLength <= 3) return value.slice(0, maxLength);
    return value.slice(0, maxLength - 3) + "...";
  }
  // Prototipo
  let coordenada_key = [];
  let coordenada_ruta_key = [];
  let last_estimado = "";
  async function ruta_estimada(mobid) {
    if (typeof l_ruta_estimada != "undefined") {
      l_ruta_estimada.setMap(null);
    }
    if (true) {
      //(last_estimado!=mobid)
      coordenada_key = [];
      let rec_p = JSON.parse(await units_travel_db.getItem(mobid));
      for (var x in rec_p) {
        if (typeof rec_p[x].p != "undefined") {
          let lat, lng;
          for (let y in rec_p[x].p) {
            lat = (rec_p[x]["ps"][0] - rec_p[x]["p"][y][0]) / 10000;
            lng = (rec_p[x]["ps"][1] - rec_p[x]["p"][y][1]) / 10000;
            coordenada_key.push([lat, lng]);
          }
          coordenada_key[coordenada_key.length - 1] = [lat, lng, 0];
        }
      }
      coordenada_ruta_key = [];
      if (typeof $travels[mobid] != "undefined") {
        for (let x in $travels[mobid].travel) {
          if (typeof $travels[mobid].travel[x].p != "undefined") {
            for (let y in $travels[mobid].travel[x].p) {
              let lat =
                ($travels[mobid].travel[x]["ps"][0] -
                  $travels[mobid].travel[x]["p"][y][0]) /
                10000;
              let lng =
                ($travels[mobid].travel[x]["ps"][1] -
                  $travels[mobid].travel[x]["p"][y][1]) /
                10000;
              coordenada_ruta_key.push([lat, lng]);
            }
          }
        }
      }
    }
    last_estimado = mobid;
    if (coordenada_ruta_key.length > 4) {
      let env = [];
      for (
        let x = coordenada_ruta_key.length - 4;
        x < coordenada_ruta_key.length;
        x++
      ) {
        env.push(coordenada_ruta_key[x]);
      }
      //console.log(env)
      ruta_comp3(env, coordenada_key, mobid);
    }
  }
  var error = 0.01; //1000 metros
  function ruta_comp3(ruta_ev, ruta_org, mobid) {
    let org_pos = 0;
    let x1, y1, x2, y2, x, y, m, b, p_rec, x_rec, y_rec, dentro_x, dentro_y;

    let change = 0;

    let z = 0; // Punto acutual
    //console.log("ruta total",ruta_ev.length);
    let ruta_rest = [];
    for (var w = org_pos; w < ruta_org.length - 1; w++) {
      // Carga de puntos
      x = ruta_ev[z][0];
      y = ruta_ev[z][1];

      // Carga de la recta de la ruta madre
      x1 = ruta_org[w][0];
      y1 = ruta_org[w][1];
      x2 = ruta_org[w + 1][0];
      y2 = ruta_org[w + 1][1];
      m = (y2 - y1) / (x2 - x1);

      if (isFinite(m)) {
        b = y1 - m * x1;
        p_rec = Math.abs(m * x - y + b) / Math.sqrt(Math.pow(m, 2) + 1);
        x_rec = (x + m * y - b * m) / (Math.pow(m, 2) + 1);
        y_rec = (Math.pow(m, 2) * y + m * x + b) / (Math.pow(m, 2) + 1);
      } else {
        p_rec = Math.abs(x1 - x);
        x_rec = x1;
        y_rec = y;
      }
      dentro_x =
        x1 > x2
          ? x_rec <= x1 + error && x_rec >= x2 - error
            ? true
            : false
          : x1 < x2
            ? x_rec >= x1 - error && x_rec <= x2 + error
              ? true
              : false
            : true;
      dentro_y =
        y1 > y2
          ? y_rec <= y1 + error && y_rec >= y2 - error
            ? true
            : false
          : y1 < y2
            ? y_rec >= y1 - error && y_rec <= y2 + error
              ? true
              : false
            : true;
      p_rec = ((p_rec * Math.PI) / 180) * 6371;

      let d1 = Math.sqrt(Math.pow(y2 - y, 2) + Math.pow(x2 - x, 2)); // Distancia a puntos.
      d1 = ((d1 * Math.PI) / 180) * 6371;

      let d2 = Math.sqrt(Math.pow(y1 - y, 2) + Math.pow(x1 - x, 2));
      d2 = ((d2 * Math.PI) / 180) * 6371;

      if ((dentro_x && dentro_y && p_rec < 1) || d1 < 1 || d2 < 1) {
        // Distancia con punto central
        //console.log("distancia central",p_rec,w,z);
        z++;
      } else if (d1 > 10 && d2 > 10) {
        // Supera distancia de apego
        //if(z>0) console.log("ruta se aleja",z,w,d1,d2,p_rec);
        z = 0;
      }

      if (z >= ruta_ev.length - 1) {
        //console.log("flujo terminado");
        ruta_rest.push([{ lat: $live[mobid].lat, lng: $live[mobid].lon }]);
        for (let f = w + 3; f < ruta_org.length - 1; f++) {
          if (typeof ruta_org[f][2] == "undefined") {
            ruta_rest[ruta_rest.length - 1].push({
              lat: ruta_org[f][0],
              lng: ruta_org[f][1],
            });
          } else {
            break;
          }
        }
        z = 0;
      }
    }
    //console.log(ruta_rest)
    if (ruta_rest.length > 0) {
      let lineSymbol = {
        path: "M 0,-1 0,1",
        strokeOpacity: 1,
        scale: 4,
      };
      if (typeof l_ruta_estimada != "undefined") {
        l_ruta_estimada.setMap(null);
      }
      if (ruta_rest.length > 0) {
        l_ruta_estimada = new google.maps.Polyline({
          path: ruta_rest[0],
          geodesic: true,
          strokeColor: "#2f21f3",
          strokeOpacity: 0,
          strokeWeight: 2.5,
          map: map,
          icons: [
            {
              icon: lineSymbol,
              offset: "0",
              repeat: "20px",
            },
          ],
        });
        if (ruta_rest[0].length > 3) osrm_future(ruta_rest[0]);
      }
    }
  }
  async function osrm_destino(lat, lon, zIndex, mobid) {
    // OSRM
    let coordenada_osrm = "";
    coordenada_osrm =
      $live[mobid].lon + "," + $live[mobid].lat + ";" + lon + "," + lat;

    let osrm_r = await fetchJsonSafe(
      EXT_OMNI_ROUTE_URL + "/route/v1/driving/" +
        coordenada_osrm +
        "?geometries=geojson&generate_hints=false&skip_waypoints=true&overview=full",
      { fallback: null, logLabel: "monitor osrm route" }
    );
    if (monitor_map_eta_unit !== mobid || !has_monitor_map_eta_context) {
      return;
    }
    if (!osrm_r) {
      monitor_map_eta_seconds = -1;
      return;
    }
    if (osrm_r.code == "Ok") {
      monitor_map_eta_seconds = osrm_r.routes[0].duration;
      let coordenada = [];
      for (let t in osrm_r.routes) {
        for (let y in osrm_r.routes[t].geometry.coordinates) {
          coordenada.push({
            lat: osrm_r.routes[t].geometry.coordinates[y][1],
            lng: osrm_r.routes[t].geometry.coordinates[y][0],
          });
        }
      }
      let lineSymbol = {
        path: "M 0,-1 0,1",
        strokeOpacity: 1,
        scale: 4,
      };
      if (typeof l_ruta_estimada != "undefined") {
        l_ruta_estimada.setMap(null);
      }
      l_ruta_estimada = new google.maps.Polyline({
        path: coordenada,
        geodesic: true,
        strokeColor: "#2f21f3",
        strokeOpacity: 0,
        strokeWeight: 2.5,
        map: map,
        icons: [
          {
            icon: lineSymbol,
            offset: "0",
            repeat: "20px",
          },
        ],
      });
      bc_route.postMessage({ ruta_estimada: coordenada });
      show_geo(coordenada);
      return;
    }

    monitor_map_eta_seconds = -1;
  }
  let circle_route = [];
  let circle_route_ = [];
  let poligon_route = [];
  let poligon_route_ = [];
  let last_route_coordenada = [];
  async function show_geo(coordenada) {
    last_route_coordenada = coordenada;
    if (!map_geofence) return;
    monitorWorker.postMessage({
      fun: "get_geos_map",
      coordenada: coordenada,
      geos_full: $geos_full,
      poli_full: $poli_full,
    });
  }
  let colors_line = [
    "#2196f3",
    "#e91e63",
    "#03a9f4",
    "#9c27b0",
    "#00bcd4",
    "#673ab7",
    "#009688",
    "#3f51b5",
    "#4caf50",
    "#ff5722",
    "#8bc34a",
    "#ff9800",
    "#cddc39",
    "#ffc107",
    "#607d8b",
    "#ffeb3b",
    "#9e9e9e",
    "#212121",
    "#f44336",
  ];
  async function osrm(coordenada, zIndex, mobid) {
    // OSRM
    let coordenada_osrm = "";
    let radius_osrm = "";
    for (let t in coordenada) {
      coordenada_osrm =
        coordenada_osrm + coordenada[t].lng + "," + coordenada[t].lat + ";";
    }
    coordenada_osrm =
      coordenada_osrm + $live[mobid].lon + "," + $live[mobid].lat + ";";
    coordenada_osrm =
      coordenada_osrm + $live[mobid].lon + "," + $live[mobid].lat + ";";
    radius_osrm = radius_osrm + "20%3B";
    radius_osrm = radius_osrm + "20%3B";
    for (let t in coordenada) {
      radius_osrm = radius_osrm + "20%3B";
    }

    coordenada_osrm = coordenada_osrm.slice(0, -1);
    radius_osrm = radius_osrm.slice(0, -3);
    let osrm_r = await fetchJsonSafe(
      EXT_OMNI_ROUTE_URL + "/match/v1/driving/" +
        coordenada_osrm +
        "?geometries=geojson&generate_hints=false&skip_waypoints=true&overview=full&radiuses=" +
        radius_osrm,
      { fallback: null, logLabel: "monitor osrm match" }
    );
    if (!osrm_r) {
      return;
    }
    if (osrm_r.code == "Ok") {
      if (osrm_r.matchings[0].confidence > $route_confidence) {
        coordenada = [];
        for (let t in osrm_r.matchings) {
          for (let y in osrm_r.matchings[t].geometry.coordinates) {
            coordenada.push({
              lat: osrm_r.matchings[t].geometry.coordinates[y][1],
              lng: osrm_r.matchings[t].geometry.coordinates[y][0],
            });
          }
        }
      }
      //console.log("confidence",osrm_r.matchings[0].confidence);
    }
    //---------

    zIndex++;
    coordenada.push({ lat: $live[mobid].lat, lng: $live[mobid].lon });

    let color_change = linesNeedColorChange(coordenada);
    let color_change_c = 0;
    //console.log("color_change", color_change, coordenada.length);
    // delete color change for last three points
    color_change = color_change.filter((x) => x < coordenada.length - 3);

    for (let x in recorrido) {
      if (typeof recorrido[x] != "undefined") {
        recorrido[x].setMap(null);
      }
    }
    recorrido = [];
    if (coordenada.length > 0) {
      recorrido.push(
        new google.maps.Polyline({
          path: [coordenada[0]],
          geodesic: true,
          strokeColor: "#FF0000",
          strokeOpacity: 1.0,
          strokeWeight: 2.5,
          map: map,
          zIndex: zIndex,
          icons: [
            {
              icon: {
                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                strokeColor: "#b71c1c",
              },
              offset: "100px",
              repeat: "100px",
            },
          ],
        })
      );
      for (let x in coordenada) {
        if (color_change.includes(parseInt(x))) {
          recorrido.push(
            new google.maps.Polyline({
              path: [
                new google.maps.LatLng(
                  coordenada[x - 1].lat,
                  coordenada[x - 1].lng
                ),
                new google.maps.LatLng(coordenada[x].lat, coordenada[x].lng),
              ],
              geodesic: true,
              strokeColor:
                color_change_c < colors_line.length
                  ? colors_line[color_change_c]
                  : colors_line[color_change_c % colors_line.length],
              strokeOpacity: 1.0,
              strokeWeight: 2.5,
              map: map,
              zIndex: zIndex,
              icons: [
                {
                  icon: {
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    strokeColor:
                      color_change_c < colors_line.length
                        ? colors_line[color_change_c]
                        : colors_line[color_change_c % colors_line.length],
                  },
                  offset: "100px",
                  repeat: "100px",
                },
              ],
            })
          );
          color_change_c++;
          zIndex++;
        } else {
          recorrido[recorrido.length - 1]
            .getPath()
            .push(new google.maps.LatLng(coordenada[x].lat, coordenada[x].lng));
        }
      }
      bc_coordenadas.postMessage({
        recorrido: coordenada,
        color_change: color_change,
      });
    }
  }
  async function osrm_future(coordenada) {
    // OSRM
    let coordenada_osrm = "";
    let radius_osrm = "";
    for (let t in coordenada) {
      coordenada_osrm =
        coordenada_osrm + coordenada[t].lng + "," + coordenada[t].lat + ";";
    }
    for (let t in coordenada) {
      radius_osrm = radius_osrm + "20%3B";
    }

    coordenada_osrm = coordenada_osrm.slice(0, -1);
    radius_osrm = radius_osrm.slice(0, -3);
    let osrm_r = await fetchJsonSafe(
      EXT_OMNI_ROUTE_URL + "/match/v1/driving/" +
        coordenada_osrm +
        "?geometries=geojson&generate_hints=false&skip_waypoints=true&overview=full&radiuses=" +
        radius_osrm,
      { fallback: null, logLabel: "monitor osrm future" }
    );
    if (!osrm_r) {
      return;
    }
    if (osrm_r.code == "Ok") {
      if (osrm_r.matchings[0].confidence > $route_confidence) {
        coordenada = [];
        for (let t in osrm_r.matchings) {
          for (let y in osrm_r.matchings[t].geometry.coordinates) {
            coordenada.push({
              lat: osrm_r.matchings[t].geometry.coordinates[y][1],
              lng: osrm_r.matchings[t].geometry.coordinates[y][0],
            });
          }
        }
      }
      //console.log("confidence future",osrm_r.matchings[0].confidence);
    }
    //---------
    let lineSymbol = {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      scale: 4,
    };
    if (typeof l_ruta_estimada != "undefined") {
      l_ruta_estimada.setMap(null);
    }
    l_ruta_estimada = new google.maps.Polyline({
      path: coordenada,
      geodesic: true,
      strokeColor: "#2f21f3",
      strokeOpacity: 0,
      strokeWeight: 2.5,
      map: map,
      icons: [
        {
          icon: lineSymbol,
          offset: "0",
          repeat: "20px",
        },
      ],
    });
  }
  function travel_link(id) {
    new Contextual({
      isSticky: false,
      items: [
        {
          label: "Copiar link de viaje",
          onClick: () => {
            req_travel_link(id);
          },
        },
      ],
    });
  }
  function req_travel_link(id) {
    socket_query.emit("travel_link", id, (data) => {
      if (data != "error") {
        var el = document.createElement("textarea");
        el.value = "https://" + window.location.hostname + data;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        saved_type = "alert-success";
        saved_text = "Link de viaje copiado";
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
      }
    });
  }
  function options_units(id, follow) {
    if (follow == 1) {
      new Contextual({
        isSticky: false,
        items: [
          {
            label: "Generar alerta manual",
            onClick: () => {
              manual_alert(id);
            },
          },
          {
            label: "Crear Geocerca",
            onClick: () => {
              geo_new(id);
            },
          },
        ],
      });
    } else {
      new Contextual({
        isSticky: false,
        items: [
          {
            label: "Crear Geocerca",
            onClick: () => {
              geo_new(id);
            },
          },
        ],
      });
    }
  }
  function manual_alert(id) {
    socket_query.emit("alert_service", id, (data) => {
      if (data != "error") {
        saved_type = "alert-success";
        saved_text = "Alerta manual OK";
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 1000);
      }
    });
  }
  let geo_modal = false;
  let map_geo = 0;
  let geo_new_pos = {};
  let circles_new = [];
  let type_geo_new = -1;
  let actual_geo = "";
  let actual_geo_name = "";
  let geo_data;
  function geo_new(id) {
    if (typeof $live[id] != "undefined") {
      geo_new_pos = { lat: $live[id].lat, lng: $live[id].lon };
      let geo_s = geo_search(geo_new_pos.lat, geo_new_pos.lng);
      console.log(geo_s);
      if (geo_s[1] == 1) {
        if (geo_s[2] == "") {
          // Geo completamente nueva
          type_geo_new = 0;

          type_geo_new = -1;
          saved_type = "alert-danger";
          saved_text = "La unidad debe estar detenida.";
          saved_ok = true;
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        } // Geo ya existente sin nombre
        else {
          actual_geo = geo_s[2];
          actual_geo_name = geo_s[0];
          geo_c_sel = 2;
          type_geo_new = 1;

          geo_modal = true;
        }
      } else {
        type_geo_new = -1;
        saved_type = "alert-success";
        saved_text = "La geocerca ya existe, se llama " + geo_s[0];
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
      }
    }
  }
  let geo_c_sel = 2;
  function show_geo_fence() {
    tick().then(() => {
      map_geo = acquirePooledMap(
        MAP_POOL_SLOTS.GEO_DETAIL,
        "monitor-geo-detail",
        geo_detail_map_host,
        {
          mapOptions: {
            center: geo_new_pos,
            zoom: 17,
          },
          resetView: {
            center: geo_new_pos,
            zoom: 17,
          },
        }
      );

      if (!map_geo) {
        return;
      }

      if (type_geo_new == 0) {
        new_geo();
      } else if (type_geo_new == 1) {
        autom_geo(actual_geo);
      }
    });
  }
  function autom_geo(geo_s) {
    let bounds = new google.maps.LatLngBounds();
    var geo = $geos_full[geo_s];
    geo_data = geo;
    for (let x in circles_new) {
      circles_new[x].setMap(null);
    }
    circles_new = [];
    if (geo != null) {
      let anti_f = 10;
      let last_join = "";
      while (typeof geo.join != "undefined" || anti_f == 0) {
        last_join = geo.join;
        geo = $geos_full[geo.join];
        anti_f--;
      }
      for (let y in geo["pos"]) {
        let lat = geo["pos"][y][0];
        let lng = geo["pos"][y][1];

        bounds.extend({ lat: lat + 0.000898, lng: lng });
        bounds.extend({ lat: lat, lng: lng + 0.000898 });
        bounds.extend({ lat: lat - 0.000898, lng: lng });
        bounds.extend({ lat: lat, lng: lng - 0.000898 });

        circles_new.push(
          new google.maps.Circle({
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
            map: map_geo,
            center: { lat: lat, lng: lng },
            radius: 100,
            zIndex: 3,
          })
        );
      }
      map_geo.fitBounds(bounds);
    }
  }
  function new_geo() {
    for (let x in circles_new) {
      circles_new[x].setMap(null);
    }
    circles_new = [];
    circles_new.push(
      new google.maps.Circle({
        strokeColor: "#3f51b5",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#3f51b5",
        fillOpacity: 0.35,
        map: map_geo,
        center: map.getCenter(),
        radius: 100,
        draggable: true,
        zIndex: 4,
      })
    );
  }
  function save_geo() {
    socket_query.emit(
      "geo_save",
      actual_geo,
      actual_geo_name,
      geo_c_sel,
      geo_data,
      (data) => {
        if (data == "ok") {
          map_geo = 0;
          geo_modal = false;
          saved_ok = true;
          saved_text = "Geocerca guardada";
          saved_type = "alert-success";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        }
      }
    );
  }
  // Centroide
  function centro(pts) {
    let first = pts[0],
      last = pts[pts.length - 1];
    if (first[0] != last[0] || first[1] != last[1]) pts.push(first);
    let twicearea = 0,
      x = 0,
      y = 0,
      nPts = pts.length,
      p1,
      p2,
      f;
    for (let i = 0, j = nPts - 1; i < nPts; j = i++) {
      p1 = pts[i];
      p2 = pts[j];
      f = p1[0] * p2[1] - p2[0] * p1[1];
      twicearea += f;
      x += (p1[0] + p2[0]) * f;
      y += (p1[1] + p2[1]) * f;
    }
    f = twicearea * 3;
    return [x / f, y / f];
  }

  // Remote functions
  $: {
    $cc_monitor;
    if ($cc_monitor.length > 0 && $map_ready == 1 && mount_complete) {
      if ($cc_monitor[0].type == "select_unit") {
        for (let x in $nicks_list) {
          if (
            sanitizeText($nicks_list[x].toLowerCase()) == $cc_monitor[0].name
          ) {
            auto_select(x);
            let estado =
              travels_fz[x].org.time != "" ||
              travels_fz[x].oper != "Desconocido"
                ? "en viaje"
                : "estacionada, sin viaje asignado";
            let last = travels_fz[x].gsm.text.includes("min")
              ? travels_fz[x].gsm.text.replace("min", " minutos")
              : travels_fz[x].gsm.text.replace("m", " minutos");
            speaking_list.set([
              "La unidad se encuentra " +
                (travels_fz[x].ign == 1 ? "encendida" : "apagada") +
                " y su última posición fue hace " +
                last +
                ", se encuentra " +
                estado,
            ]);
            break;
          }
        }
      }
      cc_monitor.set([]);
    }
  }
  function sanitizeText(text) {
    const accentsMap = {
      á: "a",
      é: "e",
      í: "i",
      ó: "o",
      ú: "u",
      Á: "A",
      É: "E",
      Í: "I",
      Ó: "O",
      Ú: "U",
      ñ: "n",
      Ñ: "N",
      ü: "u",
      Ü: "U",
    };
    const removeAccents = (str) => {
      return str
        .split("")
        .map((char) => accentsMap[char] || char)
        .join("");
    };
    const removeSpecialChars = (str) => {
      return str.replace(/[^a-zA-Z0-9]/g, "");
    };
    const lowerCaseText = text.toLowerCase();
    const textWithoutAccents = removeAccents(lowerCaseText);
    const sanitizedText = removeSpecialChars(textWithoutAccents);

    return sanitizedText;
  }

  // WebRTC
  const turnConfig = {
    iceServers: [
      { urls: "stun:stun.l.google.com:19302" },
      {
        urls: "turn:portainer.sub.omnitracs.online:3478",
        username: "alfa",
        credential: "js1ma",
      },
    ],
  };
  let peerConnection;
  let driver_video = null;
  let last_video = 1;
  let audioStream1;
  async function rtc_offer(data) {
    if (!close_video_modal && !show_audio_status) return;
    console.log("Recibida oferta:", data);
    video.srcObject = null;
    video2.srcObject = null;

    if (peerConnection) {
      peerConnection.close();
    }
    peerConnection = new RTCPeerConnection(turnConfig);

    peerConnection.ontrack = (event) => {
      if (event.track.kind == "video") {
        const video = document.getElementById("video");
        const video2 = document.getElementById("video2");
        if (!video.srcObject) {
          //(last_video == 2) {
          //last_video = 1;
          console.log("Video 1");
          video.srcObject = event.streams[0];
          video.autoplay = true;
          video.playsInline = true;
        } else {
          //last_video = 2;
          console.log("Video 2");
          video2.srcObject = event.streams[0];
          video2.autoplay = true;
          video2.playsInline = true;
        }
        // Auto record
        if (video.srcObject && !mediaRecorder) {
          const videoStream = video.captureStream(); //ORIGINAL
          mediaRecorder = new MediaRecorder(videoStream);
          recordedChunks = [];
          mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              recordedChunks.push(event.data);
            }
          };
          mediaRecorder.start();
          console.log("Recording started 1");
        }
        if (video2.srcObject && !mediaRecorder2) {
          const videoStream2 = video2.captureStream();
          mediaRecorder2 = new MediaRecorder(videoStream2);
          recordedChunks2 = [];
          mediaRecorder2.ondataavailable = (event) => {
            if (event.data.size > 0) {
              recordedChunks2.push(event.data);
            }
          };
          mediaRecorder2.start();
          console.log("Recording started 2");
        }
      }
      if (event.track.kind == "audio") {
        const audio = document.getElementById("audio");
        audio.srcObject = event.streams[0];
        audio.autoplay = true;
        audio.playsInline = true;
        console.log("Audio Call");
      }
    };

    async function getStreamAudio(deviceId) {
      const constraints = {
        audio: {
          deviceId: deviceId ? { exact: deviceId } : undefined,
        },
      };
      try {
        let stream = await navigator.mediaDevices.getUserMedia(constraints);
        return stream;
      } catch (error) {
        console.error("Error al obtener el stream de audio:", error);
        return null;
      }
    }
    let medias = await navigator.mediaDevices.enumerateDevices();
    let microphones = medias.filter((device) => device.kind === "audioinput");
    if (microphones.length > 0 && show_audio_status) {
      console.log("microphones", microphones);
      audioStream1 = await getStreamAudio(microphones[0].deviceId);
    }

    if (audioStream1) {
      audioStream1.getTracks().forEach((track) => {
        console.log("audioStream1", track);
        peerConnection.addTrack(track, audioStream1);
      });
    }

    peerConnection.onicecandidate = (event) => {
      if (event.candidate) {
        console.log("Enviando candidato ICE:", event.candidate);
        socket_query.emit("rtc_candidate_admin", driver_video, event.candidate);
      }
    };

    peerConnection.oniceconnectionstatechange = () => {
      console.log(
        "ICE connection state change:",
        peerConnection.iceConnectionState
      );
      if (peerConnection.iceConnectionState === "connected") {
      }
    };

    await peerConnection.setRemoteDescription(new RTCSessionDescription(data));
    const answer = await peerConnection.createAnswer();
    await peerConnection.setLocalDescription(answer);

    console.log("Enviando respuesta:", answer);
    socket_query.emit(
      "rtc_answer",
      driver_video,
      peerConnection.localDescription
    );
  }
  socket_query.on("rtc_offer", rtc_offer);
  async function rtc_candidate(data) {
    if (!close_video_modal && !show_audio_status) return;
    console.log("Recibido candidato ICE:", data);
    if (peerConnection.remoteDescription)
      await peerConnection.addIceCandidate(new RTCIceCandidate(data));
  }
  socket_query.on("rtc_candidate", rtc_candidate);
  let close_video_modal = false;
  let cargando_video = true;
  let cargando_video2 = true;
  function show_video(id) {
    const video = document.getElementById("video");
    const video2 = document.getElementById("video2");
    video.srcObject = null;
    video2.srcObject = null;
    driver_video = id;
    close_video_modal = true;
    socket_query.emit("rtc_requestOffer", id, "video");
    video.onloadedmetadata = () => {
      cargando_video = false;
    };
    video2.onloadedmetadata = () => {
      cargando_video2 = false;
    };
  }
  let drivers_ = {};
  let driver_markers;
  let driver_on_map;
  $: {
    $drivers;
    drivers_ = $drivers;
    if (drivers_[driver_on_map]) {
      if (drivers_[driver_on_map].status != 1) {
        if (driver_markers) {
          driver_markers.setMap(null);
        }
      }
    }
  }
  socket_query.on("driver_position", async function (data) {
    if (typeof drivers_[data.driver] != "undefined") {
      drivers_[data.driver].pos = data.pos;

      if (driver_on_map != data.driver) return;

      // create a driver marker
      if (driver_markers) {
        driver_markers.setMap(null);
      }
      if (drivers_[data.driver].pos.status != 1) return;

      driver_markers = new google.maps.Marker({
        position: data.pos,
        map: map,
        title: "Mi posición",
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: "#4285F4",
          fillOpacity: 1,
          strokeWeight: 2,
          strokeColor: "#FFFFFF",
          labelOrigin: new google.maps.Point(-3, -3),
        },
        label: {
          text: $drivers[data.driver].name,
          color: "#212121",
          fontSize: "13px",
          fontWeight: "bold",
          className: "custom-label",
        },
      });
    }
  });
  let mediaRecorder, mediaRecorder2;
  let recordedChunks = [],
    recordedChunks2 = [];

  let monitor_outputs = localStorage.getItem("monitor_outputs")
    ? JSON.parse(localStorage.getItem("monitor_outputs"))
    : [];

  let expand_map = localStorage.getItem("expand_map") == "true" ? true : false;
  let total_filters = 0;
  $: total_filters = visible_monitor_units.length;
  let show_audio_status = false;
  function show_audio(id) {
    show_audio_status = true;
    driver_video = id;
    socket_query.emit("rtc_requestOffer", id, "audio");
  }
  function linesNeedColorChange(points, threshold = 0.01) {
    let last_point = 0;
    let result = [];
    for (let x = 0; x < points.length - 1; x++) {
      if (x > 1) {
        for (let y = last_point; y < x - 1; y++) {
          let distance = puntoLinea(points[y], points[y + 1], points[x]);
          if (distance < threshold && distance != null) {
            result.push(x);
            last_point = x;
          }
        }
      }
    }
    return result;
  }
  function puntoLinea(a, b, p) {
    const l = { lat: b.lat - a.lat, lng: b.lng - a.lng };
    const t =
      ((p.lat - a.lat) * l.lat + (p.lng - a.lng) * l.lng) /
      (l.lat ** 2 + l.lng ** 2);
    if (t < 0 || t > 1) return null;
    let p2 = { lat: a.lat + t * l.lat, lng: a.lng + t * l.lng };
    return get_km(p.lat, p.lng, p2.lat, p2.lng);
  }
  let con_hos_travel_modal = false;
  let hos_cron;
  let hos_snapshot = "";
  let hos_group_ready = "";
  let hos_cache_ready = false;
  let drivers_hos = {};
  let drivers_hos_ = {};
  const isEmpty = (val) =>
    (Array.isArray(val) && !val.length) ||
    (Object.prototype.toString.call(val) === "[object Object]" &&
      !Object.keys(val).length);

  function getHosDriverStatus(data) {
    if (!data) return true;

    return !(
      data.cycle &&
      data.break &&
      data.shift &&
      data.drive &&
      (data.cycle.minutes > data.cycle.max * 60 ||
        data.break.minutes > data.break.max * 60 ||
        data.shift.minutes > data.shift.max * 60 ||
        data.drive.minutes > data.drive.max * 60)
    );
  }

  async function loadHosCache() {
    const cachedSnapshot = await hos_list_db.getItem("hos_list");
    if (typeof cachedSnapshot === "string" && cachedSnapshot !== "") {
      applyHosListSnapshot(cachedSnapshot);
    }
  }

  function getHosSyncState() {
    if (typeof window === "undefined") {
      return { in_flight: false, request_hash: "" };
    }

    if (!window.__vectorHosSyncState) {
      window.__vectorHosSyncState = { in_flight: false, request_hash: "" };
    }

    return window.__vectorHosSyncState;
  }

  async function refreshHosStatusList(force = false) {
    if (!$group) return;
    const requestHash = force || !hos_snapshot ? "" : sha1(hos_snapshot);
    const hosSyncState = getHosSyncState();

    if (hosSyncState.in_flight && hosSyncState.request_hash === requestHash) {
      return;
    }

    hosSyncState.in_flight = true;
    hosSyncState.request_hash = requestHash;
    socket_query.emit(
      "hos_list",
      requestHash
    );
  }

  function applyHosListSnapshot(rawSnapshot) {
    try {
      const parsedSnapshot = JSON.parse(rawSnapshot);
      const nextDriversHos = {};

      if (Array.isArray(parsedSnapshot)) {
        for (const item of parsedSnapshot) {
          if (!Array.isArray(item) || item.length < 2) continue;
          nextDriversHos[item[0]] = getHosDriverStatus(item[1]);
        }
      }

      hos_snapshot = rawSnapshot;
      drivers_hos = nextDriversHos;
    } catch (error) {
      console.error("Invalid hos_list snapshot", error);
    }
  }

  async function handleHosList(data) {
    const hosSyncState = getHosSyncState();
    hosSyncState.in_flight = false;
    hosSyncState.request_hash = "";

    if (typeof data === "string") {
      await hos_list_db.setItem("hos_list", data);
      applyHosListSnapshot(data);
    }
  }

  function handleHosListInvalidation() {
    refreshHosStatusList();
  }

  socket_query.on("hos_list", handleHosList);
  socket_query.on("hos_list_", handleHosListInvalidation);

  $: {
    if (hos_cache_ready && $group && hos_group_ready !== $group) {
      hos_group_ready = $group;
      refreshHosStatusList();
    }
  }

  $: {
    if (!isEmpty($travel_crtl)) {
      let drivers_hos_p = {};
      for (let x in $travel_crtl) {
        if ($travel_crtl[x].oper) {
          drivers_hos_p[$travel_crtl[x].oper] = false;
        }
      }
      if (JSON.stringify(drivers_hos_) != JSON.stringify(drivers_hos_p)) {
        drivers_hos_ = JSON.parse(JSON.stringify(drivers_hos_p));
        let filteredDriversHos = {};
        for (let driverId in drivers_hos_) {
          if (typeof drivers_hos[driverId] !== "undefined") {
            filteredDriversHos[driverId] = drivers_hos[driverId];
          }
        }
        drivers_hos = filteredDriversHos;
      }
    }
  }
  let change_travel_modal = false;
  let change_travel_modal_reason = 0;
  let change_travel_modal_comment = "";
  let change_travel_modal_id = 0;
  let change_travel_modal_date = "";
  let change_travel_modal_uuid = "";

  // Automatic Travels System
  let auto_travel_status = localStorage.getItem("auto_travel")
    ? localStorage.getItem("auto_travel") == "true"
      ? true
      : localStorage.getItem("auto_travel") == "clean"
        ? "clean"
        : false
    : false;
  let auto_history_travel = localStorage.getItem("auto_history_travel")
    ? localStorage.getItem("auto_history_travel") == "true"
      ? true
      : false
    : false;
  let auto_history_travel_mode = false;
  let auto_travel_mode = false;
  let auto_travel_running = false;
  async function auto_travel() {
    clearTimeout(auto_travel_timer);
    if (auto_travel_running) return;
    auto_travel_running = true;
    let r = Math.random();
    console.log(new Date().toLocaleString(), "Auto travel running", r);
    // Get a list of units and drivers with active travels
    let units = [];
    let drivers = [];
    let new_travel = [];
    let travel_crtl_ = JSON.parse(JSON.stringify($travel_crtl));
    for (let x in travel_crtl_) {
      units.push(travel_crtl_[x].id);
      drivers.push(travel_crtl_[x].oper);
    }
    // Read units and create travel for units with ingnition on
    for (let x in $units_list) {
      if ($live[$units_list[x]] == undefined) {
        console.log("Unit not found", $units_list[x]);
        continue;
      }
      if (auto_travel_status == "clean") continue;
      if (
        !units.includes($units_list[x]) &&
        $live[$units_list[x]].ingnition == 1 &&
        $live[$units_list[x]].last_comm > new Date().getTime() / 1000 - 60 * 60
      ) {
        let unit_new_travel = $units_list[x];
        let driver_new_travel;
        // Chose first driver available who is not in drives variable
        for (let w in $drivers_list) {
          if (!drivers.includes($drivers_list[w][0])) {
            driver_new_travel = $drivers_list[w][0];
            break;
          }
        }
        // Create travel
        if (driver_new_travel) {
          // Select date to the next 30 minutes block 00, 30
          new_travel.push(unit_new_travel);
          let date = new Date();
          let minutes = date.getMinutes();
          let hours = date.getHours();
          if (minutes > 30) {
            date.setHours(hours + 1);
            date.setMinutes(0);
          } else {
            date.setMinutes(30);
          }
          date.setSeconds(0);
          date.setMilliseconds(0);
          let date_unix = Math.round(date.getTime() / 1000);
          let s1 = await emitAsync(
            "travel_save",
            unit_new_travel,
            $geos_class_list[0][0],
            $geos_class_list[1][0],
            driver_new_travel,
            "",
            date_unix,
            [],
            [],
            [],
            "auto-" + new Date().getTime().toString().slice(-4)
          );
          if (s1 == "ok") {
            console.log(
              new Date().toLocaleString(),
              "Auto travel created for unit",
              unit_new_travel
            );
            let s2 = await emitAsync(
              "travel_launch",
              unit_new_travel,
              date_unix,
              $geos_class_list[1][0],
              driver_new_travel,
              "",
              []
            );
            if (s2 == "ok") {
              console.log(
                new Date().toLocaleString(),
                "Auto travel launched for unit",
                unit_new_travel
              );
              units.push($units_list[x]);
              drivers.push(driver_new_travel);
            }
          }
        }
      }
    }
    // Close travels for units with ingnition off
    for (let x in travel_crtl_) {
      if (travel_crtl_[x] == undefined) {
        console.log("Travel not found", x);
        continue;
      }
      if (
        ($live[travel_crtl_[x].id].ingnition == 0 &&
          !new_travel.includes(travel_crtl_[x].id)) ||
        auto_travel_status == "clean"
      ) {
        let s1 = await emitAsync(
          "end_travel",
          travel_crtl_[x].id,
          travel_crtl_[x].date_ini,
          []
        );
        if (s1 == "ok") {
          console.log(
            new Date().toLocaleString(),
            "Auto travel closed for unit",
            travel_crtl_[x].id
          );
          let s2 = await emitAsync(
            "travel_comment",
            travel_crtl_[x].uuid,
            "Viaje Automático",
            0
          );
          if (s2 == "ok") {
            console.log(
              new Date().toLocaleString(),
              "Auto travel comment added for unit"
            );
          }
        }
      }
    }
    // Run pending travels
    for (let x in travel_crtl_) {
      if (travel_crtl_[x].step == 0) {
        let s1 = await emitAsync(
          "travel_launch",
          travel_crtl_[x].id,
          travel_crtl_[x].date_ini,
          travel_crtl_[x].dest,
          travel_crtl_[x].oper,
          "",
          []
        );
        if (s1 == "ok") {
          console.log(
            new Date().toLocaleString(),
            "Auto travel launched for unit",
            travel_crtl_[x].id
          );
        }
      }
    }
    auto_travel_timer = setTimeout(auto_travel, 1 * 60 * 1000);
    setTimeout(() => {
      auto_travel_running = false;
    }, 39 * 1000);
    console.log(new Date().toLocaleString(), "Auto travel finished", r);
  }
  async function auto_history() {
    let org = $geos_class_list[0][0];
    let dest = $geos_class_list[1][0];

    for (let x in $drivers_list) {
      if ($units_list[x]) {
        let unit = $units_list[x];
        let oper = $drivers_list[x][0];
        let s2 = await emitAsync("travel_art", unit, org, dest, oper);
        console.log(
          new Date().toLocaleString(),
          "Auto history travel launched for unit",
          unit,
          s2
        );
      }
    }
    localStorage.setItem("auto_history_travel", false);
  }
  let auto_travel_timer;
  $: {
    if (
      !auto_travel_mode &&
      auto_travel_status &&
      Object.keys($live).length > 0 &&
      $units_list.length > 0 &&
      $geos_class_list.length > 1
    ) {
      auto_travel_mode = true;
      setTimeout(auto_travel, 10 * 1000);
    }
  }
  $: {
    if (
      !auto_history_travel_mode &&
      auto_history_travel &&
      Object.keys($live).length > 0 &&
      $units_list.length > 0 &&
      $geos_class_list.length > 1
    ) {
      auto_history_travel_mode = true;
      setTimeout(auto_history, 10 * 1000);
    }
  }
  document.addEventListener("visibilitychange", handleVisibilityChange);
  function handleVisibilityChange() {
    if (lightmetrics_stream_modal_open && document.hidden) {
      closeLightmetricsStream("hidden", true);
    }
    if (auto_travel_mode) {
      if (document.hidden) {
        clearTimeout(auto_travel_timer);
        console.log(new Date().toLocaleString(), "Auto travel paused");
      } else {
        auto_travel_timer = setTimeout(auto_travel, 1 * 60 * 1000);
        console.log(new Date().toLocaleString(), "Auto travel resumed");
      }
    }
    if (alert_reload_interval) {
      if (document.hidden) {
        clearInterval(alert_reload_interval);
      } else {
        alert_reload_interval = setInterval(alert_reload, 60 * 1000);
      }
    }
  }
  function emitAsync(event, ...args) {
    return new Promise((resolve, reject) => {
      let attempt = 1; // Número de intentos
      let resolved = false; // Para saber si ya se resolvió o rechazó
      const tryEmit = () => {
        // Iniciamos un temporizador de 10 segundos
        const timer = setTimeout(() => {
          // Si pasa el tiempo y no se ha resuelto, consideramos que falló
          if (attempt < 2) {
            attempt++;
            tryEmit(); // Hacemos el segundo intento
          } else {
            if (!resolved) {
              resolved = true;
              resolve("error");
            }
          }
        }, 10000);
        socket_query.emit(event, ...args, (data) => {
          // Si la promesa no se ha resuelto todavía
          if (!resolved) {
            clearTimeout(timer); // Limpiamos el timer
            if (data === "ok") {
              resolved = true;
              resolve(data);
            } else {
              // Si llega un error y todavía nos queda un intento, lo reintentamos
              if (attempt < 2) {
                attempt++;
                tryEmit();
              } else {
                resolved = true;
                resolve("error");
              }
            }
          }
        });
      };
      tryEmit();
    });
  }
</script>

<audio id="audio" autoplay playsinline kind="audio"> </audio>

{#if saved_ok}
  <div class="alert-top alert {saved_type} mb-0 text-center" role="alert">
    <strong>{saved_text}</strong>
  </div>
{/if}

{#if geo_modal}
  <div
    class="modal fade {geo_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    style="padding-right: 17px; display: {geo_modal
      ? 'block'
      : 'none'}; z-index:1039;"
    use:show_geo_fence
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
      role="document"
      style="min-width: 95%"
    >
      <div class="modal-content" style="min-height: 99%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">directions</i> Nueva geocerca
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-0">
          <div class="h-100" bind:this={geo_detail_map_host} />
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <label for="geo_name" class="col col-form-label">Nombre</label>
              <input
                type="text"
                class="form-control"
                id="geo_name"
                placeholder=""
                bind:value={actual_geo_name}
                size="30"
              />
            </div>
            <div class="d-flex">
              <label for="geo_class" class="col col-form-label"
                >Clasificación</label
              >
              <div class="btn-group btn-group-toggle ml-2" id="geo_class">
                <label class="btn btn-secondary" class:active={geo_c_sel == 2}>
                  <input
                    type="radio"
                    bind:group={geo_c_sel}
                    value={2}
                    name="geo_c_sel"
                    autocomplete="off"
                  /> Inicio/Fin de Viaje
                </label>
                <label class="btn btn-secondary" class:active={geo_c_sel == 3}>
                  <input
                    type="radio"
                    bind:group={geo_c_sel}
                    value={3}
                    name="geo_c_sel"
                    autocomplete="off"
                  /> Parada Autorizada
                </label>
                <label class="btn btn-secondary" class:active={geo_c_sel == 4}>
                  <input
                    type="radio"
                    bind:group={geo_c_sel}
                    value={4}
                    name="geo_c_sel"
                    autocomplete="off"
                  /> Parada No Autorizada
                </label>
              </div>
            </div>
            <div class="d-flex">
              <div>
                <button
                  on:click={() => {
                    save_geo();
                  }}
                  class="btn btn-success big"
                  type="button"
                >
                  <i class="material-icons md-85">save</i>
                  Guardar geocerca
                </button>
                <button
                  on:click={() => {
                    map_geo = 0;
                    geo_modal = false;
                  }}
                  class="btn btn-danger big"
                  type="button"
                >
                  <i class="material-icons md-85">clear</i>
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if route_modal}
  <div
    class="modal fade {route_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    style="padding-right: 17px; display: {route_modal
      ? 'block'
      : 'none'}; z-index:1039;"
    use:show_route_map
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
      role="document"
      style="min-width: 95%"
    >
      <div class="modal-content" style="min-height: 99%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">directions</i> Ruta nueva
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-0">
          <div class="h-100" bind:this={route_detail_map_host} />
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-end">
            <div>
              {#if route_modal_edit}
                <input
                  class="form-con"
                  type="text"
                  value="{route_modal_org == 0
                    ? typeof $geos_class[org_selected] != 'undefined'
                      ? $geos_class[org_selected][0]
                      : $poli[org_selected][0]
                    : route_modal_org == 1
                      ? typeof $geos_class[dest_selected] != 'undefined'
                        ? $geos_class[dest_selected][0]
                        : $poli[dest_selected][0]
                      : typeof $geos_class[
                            travel_toe.sec_dests[route_modal_org - 2]
                          ] != 'undefined'
                        ? $geos_class[
                            travel_toe.sec_dests[route_modal_org - 2]
                          ][0]
                        : $poli[
                            travel_toe.sec_dests[route_modal_org - 2]
                          ][0]} a {route_modal_org == 0
                    ? typeof $geos_class[dest_selected] != 'undefined'
                      ? $geos_class[dest_selected][0]
                      : $poli[dest_selected][0]
                    : typeof $geos_class[
                          travel_toe.sec_dests[route_modal_org - 1]
                        ] != 'undefined'
                      ? $geos_class[
                          travel_toe.sec_dests[route_modal_org - 1]
                        ][0]
                      : $poli[travel_toe.sec_dests[route_modal_org - 1]][0]}"
                  bind:this={route_name}
                  size="60"
                />
              {:else}
                <input
                  class="form-con"
                  type="text"
                  value="{route_modal_org == 0
                    ? typeof $geos_class[org_selected] != 'undefined'
                      ? $geos_class[org_selected][0]
                      : $poli[org_selected][1]
                    : route_modal_org == 1
                      ? typeof $geos_class[dest_selected] != 'undefined'
                        ? $geos_class[dest_selected][0]
                        : $poli[dest_selected][1]
                      : typeof $geos_class[
                            future_travel[0].dest_m[route_modal_org - 2].name
                          ] != 'undefined'
                        ? $geos_class[
                            future_travel[0].dest_m[route_modal_org - 2].name
                          ][0]
                        : $poli[
                            future_travel[0].dest_m[route_modal_org - 2].name
                          ][1]} a {route_modal_org == 0
                    ? typeof $geos_class[dest_selected] != 'undefined'
                      ? $geos_class[dest_selected][0]
                      : $poli[dest_selected][1]
                    : typeof $geos_class[
                          future_travel[0].dest_m[route_modal_org - 1].name
                        ][0] != 'undefined'
                      ? $geos_class[
                          future_travel[0].dest_m[route_modal_org - 1].name
                        ]
                      : $poli[
                          future_travel[0].dest_m[route_modal_org - 1].name
                        ][1]}"
                  bind:this={route_name}
                  size="60"
                />
              {/if}

              <button
                on:click={save_new_route}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">save</i>
                Guardar ruta
              </button>
              <button
                on:click={cancel_new_route}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">clear</i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if con_delete_travel_modal}
  <div
    class="modal fade {con_delete_travel_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    style="padding-right: 17px; display: {con_delete_travel_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
      style="min-width: 20%"
    >
      <div class="modal-content" style="min-height: 30%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons red md-2">warning</i> Confirmar borrado de
            viaje de la unidad {typeof $nicks_list[travel_modal_id] !=
            "undefined"
              ? $nicks_list[travel_modal_id]
              : travel_modal_id}<strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <div class="d-flex flex-column">
            Esta accion borrará el viaje de la unidad.
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <div>
              <button
                on:click={() => {
                  con_delete_travel_modal = false;
                  save_travel(travel_modal_id, travel_modal_date_ini);
                }}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">done_outline</i>
                Confirmar
              </button>
            </div>
            <div>
              <button
                on:click={() => {
                  con_delete_travel_modal = false;
                }}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">not_interested</i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if con_init_travel_modal}
  <!--modal to confirm run route outside or origin-->
  <div
    class="modal fade {con_init_travel_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    style="padding-right: 17px; display: {con_init_travel_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
      style="min-width: 20%"
    >
      <div class="modal-content" style="min-height: 30%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons red md-2">warning</i>
            Unidad fuera de origen
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <div class="d-flex flex-column">
            Confirma inicio de viaje con la unidad fuera de origen.
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <div>
              <button
                on:click={() => {
                  launch_travel(...con_init_travel_modal_backup, true);
                  con_init_travel_modal = false;
                }}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">done_outline</i>
                Confirmar
              </button>
            </div>
            <div>
              <button
                on:click={() => {
                  con_init_travel_modal = false;
                }}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">not_interested</i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if con_hos_travel_modal}
  <!--modal to confirm run route outside or origin-->
  <div
    class="modal fade {con_hos_travel_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    style="padding-right: 17px; display: {con_hos_travel_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
      style="min-width: 20%"
    >
      <div class="modal-content" style="min-height: 30%;border: 5px solid red;">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons red md-2" style="font-size:35px;"
              >traffic</i
            >
            Conductor sin Horas de Servicio Disponibles
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <div class="d-flex flex-column">
            Esta seguro de iniciar el viaje con los conductor fuera de HOS.
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <div>
              <button
                on:click={() => {
                  launch_travel(...con_init_travel_modal_backup);
                  con_hos_travel_modal = false;
                }}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">done_outline</i>
                Confirmar
              </button>
            </div>
            <div>
              <button
                on:click={() => {
                  con_hos_travel_modal = false;
                }}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">not_interested</i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if con_close_travel_modal}
  <div
    class="modal fade {con_close_travel_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    style="padding-right: 17px; display: {con_close_travel_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
      style="min-width: 20%"
    >
      <div class="modal-content" style="min-height: 30%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons red md-2">warning</i> Confirmar cierre de
            viaje de la unidad {typeof $nicks_list[travel_modal_id] !=
            "undefined"
              ? $nicks_list[travel_modal_id]
              : travel_modal_id}<strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <div class="d-flex flex-column">
            Esta accion terminara con el viaje de la unidad.
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <div>
              <button
                on:click={() => {
                  con_close_travel_modal = false;
                  end_travel(
                    travel_modal_id,
                    travel_modal_date_ini,
                    travel_modal_id_add
                  );
                }}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">done_outline</i>
                Confirmar
              </button>
            </div>
            <div>
              <button
                on:click={() => {
                  con_close_travel_modal = false;
                }}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">not_interested</i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if close_travel_modal}
  <div
    class="modal fade {close_travel_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    style="padding-right: 17px; display: {close_travel_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
      style="min-width: 20%"
    >
      <div class="modal-content" style="min-height: 30%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">directions</i> Comentario
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <div class="d-flex flex-column">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Razón</label>
              <select
                class="form-control"
                id="exampleFormControlSelect1"
                bind:value={travel_end_reason}
              >
                <option value="0">Unidad terminó viaje</option>
                <option value="1">Unidad canceló viaje</option>
                <option value="2">Unidad no inició viaje</option>
              </select>
            </div>
            <textarea
              class="form-control"
              placeholder="Escribe un comentario..."
              style="width:100%;"
              bind:value={travel_end_comment}
            />
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-end">
            <div>
              <button
                on:click={send_travel_modal}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">save</i>
                Enviar Comentario
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if change_travel_modal}
  <div
    class="modal fade {change_travel_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    style="padding-right: 17px; display: {change_travel_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
      style="min-width: 20%"
    >
      <div class="modal-content" style="min-height: 30%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">directions</i> Comentario
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <div class="d-flex flex-column">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Razón del cambio</label>
              <select
                class="form-control"
                id="exampleFormControlSelect1"
                bind:value={change_travel_modal_reason}
              >
                <option value="0">Camino cerrado</option>
                <option value="1">Cambio de plan logístico</option>
                <option value="2">Emergencia</option>
                <option value="3">Otro</option>
              </select>
            </div>
            <textarea
              class="form-control"
              placeholder="Escribe un comentario..."
              style="width:100%;"
              bind:value={change_travel_modal_comment}
            />
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-end">
            <div>
              <button
                on:click={() => {
                  save_edit_travel(
                    change_travel_modal_id,
                    change_travel_modal_date
                  );
                }}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">save</i>
                Enviar Comentario
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

<!-- Modal Video -->
<div
  class="modal fade {!close_video_modal ? '' : 'show'}"
  id="videoModal"
  tabindex="-1"
  style="display: {!close_video_modal
    ? 'none'
    : 'block'}; background-color: rgba(0, 0, 0, 0.8);"
  aria-labelledby="videoModalLabel"
>
  <div
    class="modal-dialog"
    role="document"
    style="max-width: 90%; height: 90%;"
  >
    <div class="modal-content" style="height: 100%;">
      <div class="modal-header">
        <h5
          class="modal-title"
          id="videoModalLabel"
          style="font-weight: bold; text-align: center; width: 100%;"
        >
          Video en vivo de {driver_video && $drivers
            ? $drivers[driver_video].name
            : ""}
          {mediaRecorder || mediaRecorder2 ? " - Grabando" : ""}
          {#if mediaRecorder || mediaRecorder2}
            <i class="material-icons md-2" style="color: red;"
              >fiber_manual_record</i
            >
          {/if}
        </h5>
        <button
          type="button"
          class="close"
          on:click={() => {
            const video = document.getElementById("video");
            const video2 = document.getElementById("video2");
            video.style.display = "none";
            video2.style.display = "none";
            video.srcObject = null;
            video2.srcObject = null;
            close_video_modal = false;
            socket_query.emit("rtc_disconnect", driver_video);
            cargando_video = true;
            cargando_video2 = true;
            mediaRecorder = null;
            mediaRecorder2 = null;
            // Detener la transmisión de audio
            if (audioStream1) {
              audioStream1.getTracks().forEach((track) => track.stop());
              audioStream1 = null;
            }
          }}
          aria-label="Close"
        >
          <span>&times;</span>
        </button>
      </div>
      <div
        class="modal-body"
        style="position: relative; display:flex; justify-content: center; overflow: auto;"
      >
        <div
          id="loading-message"
          style="text-align: center; margin-top: 20px; display: {cargando_video &&
          cargando_video2
            ? 'block'
            : 'none'}; font-size: 18px; color: #555;"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <p>Cargando video...</p>
        </div>
        <video
          id="video"
          autoplay
          playsinline
          muted
          style="width: 50%; display: {!cargando_video
            ? 'block'
            : 'none'}; border-radius: 8px;"
        >
        </video>
        <video
          id="video2"
          autoplay
          playsinline
          muted
          style="width: 50%; display: {!cargando_video2
            ? 'block'
            : 'none'}; border-radius: 8px;"
        >
        </video>
      </div>
      <div
        class="modal-footer"
        style="justify-content: {cargando_video || cargando_video2
          ? 'space-between'
          : 'flex-end'}"
      >
        {#if cargando_video || cargando_video2}
          <button
            type="button"
            class="btn btn-primary"
            on:click={() => {
              //const video = document.getElementById("video");
              //const video2 = document.getElementById("video2");
              //video.style.display = "none";
              //video2.style.display = "none";
              //video.srcObject = null;
              //video2.srcObject = null;
              //socket_query.emit("rtc_disconnect", driver_video);
              //cargando_video = true;
              //cargando_video2 = true;
              //mediaRecorder = null;
              //mediaRecorder2 = null;
              setTimeout(() => {
                //show_video(driver_video);
              }, 1000);
              socket_query.emit("rtc_changeCamera", driver_video, last_video);
              last_video = last_video == 0 ? 1 : 0;
            }}
          >
            <i class="material-icons md-2">refresh</i>
            Cambiar cámara
          </button>
        {/if}
        {#if !cargando_video || !cargando_video2}
          <button
            type="button"
            class="btn btn-success"
            on:click={() => {
              const video = document.getElementById("video");
              const video2 = document.getElementById("video2");
              if (video.srcObject) {
                video.requestPictureInPicture();
                const modal = document.getElementById("videoModal");
                modal.style["z-index"] = 0;
                video.onleavepictureinpicture = () => {
                  modal.style["z-index"] = 1050;
                };
              } else if (video2.srcObject) {
                video2.requestPictureInPicture();
                const modal = document.getElementById("videoModal");
                modal.style["z-index"] = 0;
                video2.onleavepictureinpicture = () => {
                  modal.style["z-index"] = 1050;
                };
              }
            }}
          >
            <i class="material-icons md-2">picture_in_picture_alt</i>
            Extraer video
          </button>
        {/if}
        {#if mediaRecorder || mediaRecorder2}
          <button
            type="button"
            class="btn btn-warning"
            on:click={() => {
              if (mediaRecorder) {
                mediaRecorder.stop();
                mediaRecorder.onstop = () => {
                  const blob = new Blob(recordedChunks, { type: "video/webm" });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download =
                    (driver_video && $drivers
                      ? $drivers[driver_video].name
                      : "") +
                    " " +
                    new Date().toLocaleDateString().replace(/\//g, "-") +
                    " " +
                    new Date().toLocaleTimeString() +
                    "_1.webm";
                  a.click();
                  console.log("Recording stopped and downloaded");
                  mediaRecorder = null;
                };
              }
              if (mediaRecorder2) {
                mediaRecorder2.stop();
                mediaRecorder2.onstop = () => {
                  const blob = new Blob(recordedChunks2, {
                    type: "video/webm",
                  });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download =
                    (driver_video && $drivers
                      ? $drivers[driver_video].name
                      : "") +
                    " " +
                    new Date().toLocaleDateString().replace(/\//g, "-") +
                    " " +
                    new Date().toLocaleTimeString() +
                    "_2.webm";
                  a.click();
                  console.log("Recording stopped and downloaded");
                  mediaRecorder2 = null;
                };
              }
            }}
          >
            <i class="material-icons md-2">stop</i>
            Guardar Grabación
          </button>
        {/if}
        <button
          type="button"
          class="btn btn-secondary"
          on:click={() => {
            const video = document.getElementById("video");
            const video2 = document.getElementById("video2");
            video.style.display = "none";
            video2.style.display = "none";
            video.srcObject = null;
            video2.srcObject = null;
            close_video_modal = false;
            socket_query.emit("rtc_disconnect", driver_video);
            cargando_video = true;
            cargando_video2 = true;
            mediaRecorder = null;
            mediaRecorder2 = null;
            // Detener la transmisión de audio
            if (audioStream1) {
              audioStream1.getTracks().forEach((track) => track.stop());
              audioStream1 = null;
            }
          }}
        >
          <i class="material-icons md-2">close</i>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

<datalist id="lista_unidades">
  {#each datalist_options as opt (opt)}
    <option value={opt} />
  {/each}
</datalist>

<main
  role="main"
  class="container-fluid h-100 pl-0 pr-0 mdc-top-app-bar--dense-fixed-adjust mdc-typography"
>
  <div class="row h-100 no-gutters monitor-shell">
    {#if monitor_units_panel_collapsed}
      <button
        type="button"
        class="monitor-units-restore-tab"
        on:click={() => setMonitorUnitsPanelCollapsed(false)}
        aria-label="Mostrar panel de unidades"
        title="Mostrar panel de unidades"
      >
        <span class="material-icons md-85">last_page</span>
        <span>Unidades</span>
      </button>
    {/if}
    <div
      class="{monitor_units_panel_collapsed ? 'd-none' : 'col-md-6'} h-100 monitor-units-column"
    >
      <div class="row h-100 no-gutters">
        <div class="col-12 h-100">
          <div class="card h-100 card-b monitor-panel">
            <div class="d-flex flex-column h-100">
              <div
                class="card-header b-0 bg-dark text-white monitor-panel-header"
                style="line-height: 1.2"
              >
                <div class="d-flex monitor-panel-toolbar">
                  <div class="flex-grow-1">
                    <i class="material-icons md-85">verified_user</i> Unidades
                    <span
                      tooltip="Unidades Totales"
                      class="badge badge-pill badge-primary"
                      >{Object.keys(travels_fz).length}</span
                    >
                    <span
                      tooltip="Unidades con alertas"
                      class="badge badge-pill badge-danger">{total_alerts}</span
                    >
                    <span
                      tooltip="Unidades con monitor"
                      class="badge badge-pill badge-success"
                      >{total_follow}</span
                    >
                    <span
                      tooltip="Alertas en espera"
                      class="badge badge-pill badge-warning"
                      >{total_wating}</span
                    >
                  </div>
                  {#if f_todas == 1 && paginas_l.length > 1}
                    <div>
                      Páginas
                      <div class="btn-group mx-2" role="group">
                        {#each paginas_l as pag_n}
                          <button
                            on:click|preventDefault={() => filtro(7 + pag_n)}
                            type="button"
                            class="btn {f_pag == pag_n
                              ? 'btn-info'
                              : 'btn-outline-info'}">{pag_n + 1}</button
                          >
                        {/each}
                      </div>
                    </div>
                  {/if}
                  <div class="d-flex justify-content-end monitor-search-wrap">
                    <input
                      class="monitor-search-input"
                      on:click={(event) => {
                        eco_f_ = "";
                        primeUnitDatalist(event.target.value);
                      }}
                      on:focus={(event) => {
                        primeUnitDatalist(event.target.value);
                      }}
                      list="lista_unidades"
                      placeholder="Buscar Unidad"
                      size="20"
                      id="eco_f"
                      on:input={(event) => {
                        updateUnitDatalist(event.target.value);
                      }}
                      on:change={(event) => {
                        eco_f = resolveUnitIdFromLabel(event.target.value);
                        clearUnitDatalist();
                      }}
                    />
                    <button
                      type="button"
                      class="monitor-panel-collapse-btn"
                      on:click={toggleMonitorUnitsPanel}
                      aria-label="Ocultar panel de unidades"
                      title="Ocultar panel de unidades"
                    >
                      <span class="material-icons md-85">first_page</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-row-reverse align-items-center my-1 monitor-filter-bar">
                <div class="btn-group mx-2" role="group">
                  <button
                    on:click|preventDefault={() => filtro(0)}
                    type="button"
                    class="btn {f_monitor == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">Monitoreadas</button
                  >
                  <button
                    on:click|preventDefault={() => filtro(1)}
                    type="button"
                    class="btn {f_alertas == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">Con alertas</button
                  >
                  <button
                    on:click|preventDefault={() => filtro(2)}
                    type="button"
                    class="btn {f_todas == 1 ? 'btn-info' : 'btn-outline-info'}"
                    >Sin monitoreo</button
                  >
                </div>
                <div class="btn-group mx-2" role="group">
                  <button
                    on:click|preventDefault={() => filtro(3)}
                    type="button"
                    class="btn {f_viaje == 1 ? 'btn-info' : 'btn-outline-info'}"
                    >En movimiento</button
                  >
                  <button
                    on:click|preventDefault={() => filtro(4)}
                    type="button"
                    class="btn {f_sinviaje == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">Estacionadas</button
                  >
                </div>
                <div class="btn-group mx-2" role="group">
                  <button
                    on:click|preventDefault={() => filtro(5)}
                    type="button"
                    class="btn {f_dispositivos == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">Dispositivos</button
                  >
                  <button
                    on:click|preventDefault={() => filtro(6)}
                    type="button"
                    class="btn {f_unidades == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">Unidades</button
                  >
                </div>
              </div>
              <div
                class="card-body flex-grow-1 overflow-auto monitor-panel-body monitor-list-scroll"
                style="overflow-x: hidden;"
                id="followed_travel_list"
              >
                {#if total_filters == 0}
                  <div
                    class="d-flex justify-content-center"
                    style="height: 100%; flex-direction: column; align-items: center;"
                  >
                    <div class="alert" role="alert" style="width: 40%;">
                      <i class="material-icons md-2">info</i>
                      No hay unidades con el filtro seleccionado
                    </div>
                  </div>
                {/if}
                {#each visible_monitor_units as item, i (item.id)}
                    <div
                      id="seg_{item.id}"
                      class="card mb-1 mx-2 monitor-list-card {travels_fz[item.id].state == 'OK'
                        ? ''
                        : 'big-border border-danger'} {selected == item.id
                        ? 'med-border border-info'
                        : ''}"
                      style="font-size:0.78rem;cursor:pointer;"
                      use:monitor_v
                      on:contextmenu|preventDefault={() =>
                        options_units(
                          item.id,
                          travels_fz[item.id].monitor_crtl.follow
                        )}
                    >
                      <div
                        on:click={(s) => selectMonitorUnit(item.id, s)}
                        class="card-header b-0 monitor-list-card-header"
                      >
                        <div class="d-flex monitor-unit-card-layout">
                          <div class="d-flex flex-column flex-grow-1 mb-0 monitor-unit-main-column">
                            <div class="monitor-unit-summary-line">
                              <i
                                tooltip={item.id}
                                class="material-icons"
                                style="color:{travels_fz[item.id].monitor_crtl
                                  .follow == 0
                                  ? '#78909c'
                                  : travels_fz[item.id].alerts_now > 0
                                    ? '#df1616'
                                    : travels_fz[item.id].alerts_list.length > 0
                                      ? '#df1616'
                                      : 'rgb(24, 179, 45)'}">verified_user</i
                              >
                              <strong class="monitor-unit-identity">
                                {typeof $nicks_list[item.id] != "undefined"
                                  ? $nicks_list[item.id]
                                  : item.id}
                                {#if f_unidades == 1 && typeof future_travel_master[item.id] != "undefined"}
                                  {#each future_travel_master[item.id] as id_ex, i (id_ex)}
                                    <span style="color:#607D8B;"
                                      >,{typeof $nicks_list[id_ex] !=
                                      "undefined"
                                        ? $nicks_list[id_ex]
                                        : id_ex}</span
                                    >
                                  {/each}
                                {/if}
                              </strong>
                              {#if hasLightmetricsMonitorTrip(item.id)}
                                <button
                                  type="button"
                                  class="btn btn-link p-0 monitor-lightmetrics-stream-button"
                                  tooltip={lightmetricsMonitorIconTooltip(item.id)}
                                  aria-label="Abrir stream Protect"
                                  on:click={(event) =>
                                    openLightmetricsStream(item.id, event)}
                                >
                                  <i
                                    class="material-icons md-90"
                                    style="color:{lightmetricsMonitorIconColor(item.id)}"
                                    >videocam</i
                                  >
                                </button>
                              {/if}
                              <!-- Reparación requerida -->
                              {#if $input_self_test[item.id]}
                                {#if $input_self_test[item.id].includes(1)}
                                  <!-- Icono de reparación -->
                                  <i
                                    tooltip="Reparación requerida"
                                    class="material-icons md-90"
                                    style="color:#a30000">build</i
                                  >
                                {/if}
                              {/if}
                              <!-- Salidas digitales -->
                              {#each monitor_outputs as out, i (out.name)}
                                {#if out.enabled && travels_fz[item.id].outputs}
                                  <span tooltip={out.name}>
                                    <i
                                      class="material-icons md-85"
                                      style="color:{travels_fz[item.id].outputs[
                                        7 - i
                                      ] == '1'
                                        ? 'green'
                                        : 'red'}">radio_button_checked</i
                                    >
                                  </span>
                                {/if}
                              {/each}
                              <span
                                class="monitor-unit-geocode"
                                tooltip={travels_fz[item.id].geo_stay[0]}
                                >{typeof travels_fz[item.id].geo_stay[0] !=
                                "undefined"
                                  ? truncate_monitor_text(
                                      travels_fz[item.id].geo_stay[0],
                                      45
                                    )
                                  : ""}</span
                              >
                              {#if travels_fz[item.id].alerts_list.length > 0}
                                {#each travels_fz[item.id].alerts_list as alerts (alerts[3])}
                                  <i
                                    tooltip="{alerts[0]} {moment(
                                      new Date(alerts[2] * 1000)
                                    ).format('DD/MM/YY HH:mm')}"
                                    class="material-icons md-90"
                                    style="color:#a30000">{alerts[1]}</i
                                  >
                                {/each}
                              {/if}
                            </div>
                            <div class="monitor-unit-detail-line">
                              {#if travels_fz[item.id].org.time != "" || travels_fz[item.id].oper != "Desconocido"}
                                <i
                                  tooltip="Origen"
                                  class="material-icons md-90"
                                  style="color:#26a69a"
                                  >{travels_fz[item.id].org.time != ""
                                    ? "play_circle_outline"
                                    : "change_history"}</i
                                >
                                <strong class="monitor-unit-detail-prefix"
                                  >{travels_fz[item.id].org.time} |
                                </strong><span
                                  class="monitor-unit-detail-text"
                                  style={false ? "color:#2196f3" : ""}
                                  ><strong
                                    >{travels_fz[item.id].org.name !=
                                    "Desconocido"
                                      ? travels_fz[item.id].org.name
                                      : travels_fz[item.id].geo_stay[0]
                                        ? travels_fz[item.id].geo_stay[0]
                                        : ""}</strong
                                  ></span
                                >
                              {:else}
                                <i
                                  class="material-icons md-90"
                                  style="color:#26a69a">change_history</i
                                >
                                <strong>
                                  Estacionada, sin viaje asignado</strong
                                >
                              {/if}
                            </div>
                            <div class="monitor-unit-detail-line">
                              {#if travels_fz[item.id].org.time != "" || travels_fz[item.id].oper != "Desconocido"}
                                <i
                                  tooltip="Destino"
                                  class="material-icons md-90"
                                  style="color:#26a69a">stop</i
                                >
                                {#if show_destinos != item.id}
                                  <span
                                    class="monitor-unit-detail-text"
                                  >
                                    <span
                                      class="monitor-unit-click-text"
                                      on:click={() => {
                                        destino_edit(item.id);
                                      }}
                                      style={travels_fz[item.id].dest.name ==
                                      "Desconocido"
                                        ? "color:#2196f3"
                                        : ""}
                                    ><strong id="change_destino"
                                        >{typeof $geos_class[
                                          travels_fz[item.id].dest.name
                                        ] != "undefined"
                                          ? $geos_class[
                                              travels_fz[item.id].dest.name
                                            ][0]
                                          : typeof $poli[
                                                travels_fz[item.id].dest.name
                                              ] != "undefined"
                                            ? $poli[
                                                travels_fz[item.id].dest.name
                                              ][1]
                                            : travels_fz[item.id].dest
                                                .name}</strong
                                      ></span
                                    ></span
                                  >
                                {:else}
                                  <div class="monitor-unit-edit-inline">
                                    <select
                                      id="destino_list"
                                      class="monitor-unit-edit-select"
                                      bind:value={destino_selected}
                                    >
                                      <option value="">Desconocido</option>
                                      {#each $geos_class_list as item, i}
                                        <option value={item[0]}>{item[1]}</option>
                                      {/each}
                                      {#each $poli_list as item, i}
                                        <option value={item[0]}>{item[2]}</option>
                                      {/each}
                                    </select>
                                    <button
                                      id="save_destino"
                                      on:click={() => {
                                        save_destino(item.id, destino_selected);
                                      }}
                                      type="button"
                                      class="btn btn-success monitor-unit-edit-button">Guardar</button
                                    >
                                    <button
                                      id="cancel_save_destino"
                                      on:click={() => {
                                        show_destinos = -1;
                                      }}
                                      type="button"
                                      class="btn btn-danger monitor-unit-edit-button">Cancelar</button
                                    >
                                  </div>
                                {/if}
                              {/if}
                            </div>
                            <div class="monitor-unit-detail-line">
                              {#if travels_fz[item.id].org.time != "" || travels_fz[item.id].oper != "Desconocido"}
                                <i
                                  tooltip="Ruta"
                                  class="material-icons md-90"
                                  style="color:#26a69a">directions</i
                                >
                                {#if show_rutas != item.id}
                                  <span
                                    class="monitor-unit-detail-text"
                                  >
                                    <span
                                      class="monitor-unit-click-text"
                                      on:click={() => {
                                        ruta_edit(item.id);
                                      }}
                                      style={travels_fz[item.id].ruta.name ==
                                      "Desconocida"
                                        ? "color:#2196f3"
                                        : ""}
                                    ><strong id="change_ruta"
                                        >{typeof $route_list_d[
                                          travels_fz[item.id].ruta.name
                                        ] != "undefined"
                                          ? $route_list_d[
                                              travels_fz[item.id].ruta.name
                                            ]
                                          : "Nombre no disponible"}</strong
                                      ></span
                                    ></span
                                  >
                                {:else}
                                  <div class="monitor-unit-edit-inline">
                                    <select
                                      id="ruta_list"
                                      class="monitor-unit-edit-select"
                                      bind:value={ruta_selected}
                                    >
                                      <option value="">Desconocida</option>
                                      {#each route_list_ as item_, i}
                                        {#if travels_fz[item.id].dest.name == "Desconocido" || travels_fz[item.id].dest.name == item_[3][2]}
                                          <option value={item_[0]}
                                            >{item_[1]}</option
                                          >
                                        {:else if $geos_class_join[travels_fz[item.id].dest.name]}
                                          {#if $geos_class_join[travels_fz[item.id].dest.name][2] == item_[3][2]}
                                            <option value={item_[0]}
                                              >{item_[1]}</option
                                            >
                                          {/if}
                                        {/if}
                                      {/each}
                                    </select>
                                    <button
                                      id="save_ruta"
                                      on:click={() => {
                                        save_ruta(item.id, ruta_selected);
                                      }}
                                      type="button"
                                      class="btn btn-success monitor-unit-edit-button">Guardar</button
                                    >
                                    <button
                                      id="cancel_save_ruta"
                                      on:click={() => {
                                        show_rutas = -1;
                                      }}
                                      type="button"
                                      class="btn btn-danger monitor-unit-edit-button">Cancelar</button
                                    >
                                  </div>
                                {/if}
                              {/if}
                            </div>
                          </div>
                          <div class="d-flex flex-column monitor-unit-side-column">
                            <div class="d-flex justify-content-end mb-1">
                              <div class="p-1">
                                <strong>GPS</strong>
                                <i
                                  tooltip={isMonitorNumber(
                                    travels_fz[item.id].gps.level
                                  )
                                    ? travels_fz[item.id].gps.level
                                    : "Sin dato"}
                                  class="material-icons {travels_fz[item.id].gps
                                    .level == null
                                    ? 'gray'
                                    : travels_fz[item.id].gps.level < 1.5
                                      ? 'green'
                                      : 'red'}"
                                  >{!isMonitorNumber(
                                    travels_fz[item.id].gps.level
                                  )
                                    ? "location_searching"
                                    : travels_fz[item.id].gps.level < 1.5
                                      ? "location_on"
                                      : "location_off"}</i
                                >
                              </div>

                              <div class="p-1">
                                <strong
                                  >{typeof travels_fz[item.id].gsm.net !=
                                  "undefined"
                                    ? getMonitorMetricText(
                                        travels_fz[item.id].gsm.net,
                                        "GSM"
                                      )
                                    : "GSM"}</strong
                                ><i
                                  tooltip={isMonitorNumber(
                                    travels_fz[item.id].gsm.level
                                  )
                                    ? `-${travels_fz[item.id].gsm.level}`
                                    : "Sin dato"}
                                  class="material-icons {travels_fz[item.id].gsm
                                    .level == null
                                    ? 'gray'
                                    : travels_fz[item.id].gsm.level < 90
                                      ? 'green'
                                      : 'red'}"
                                  >{!isMonitorNumber(
                                    travels_fz[item.id].gsm.level
                                  )
                                    ? "signal_cellular_off"
                                    : travels_fz[item.id].gsm.level < 90
                                      ? "signal_cellular_alt"
                                      : "signal_cellular_connected_no_internet_4_bar"}</i
                                >
                              </div>

                              <div class="p-1">
                                <i
                                  tooltip="Última comunicación"
                                  class="material-icons {travels_fz[item.id].gsm
                                    .last == null
                                    ? 'gray'
                                    : travels_fz[item.id].gsm.last
                                      ? 'green'
                                      : 'red'}"
                                  >{travels_fz[item.id].gsm.last == null
                                    ? "sync_disabled"
                                    : travels_fz[item.id].gsm.last
                                      ? "sync"
                                      : "sync_problem"}</i
                                >
                                <strong
                                  >{getMonitorMetricText(
                                    travels_fz[item.id].gsm.text
                                  )}<strong
                                  /></strong
                                >
                              </div>

                              {#if travels_fz[item.id].alerts_now > 0}
                                <div class="p-1">
                                  <a href="/" on:click|preventDefault
                                    ><i
                                      mobid={item.id}
                                      id="alerts_box"
                                      tooltip="Alertas"
                                      class="material-icons {travels_fz[item.id]
                                        .proto_status == ''
                                        ? 'red'
                                        : 'yei'}">warning</i
                                    >
                                  </a>
                                  <strong
                                    >{travels_fz[item.id].alerts_now}</strong
                                  >
                                </div>
                              {/if}
                              {#if f_unidades == 1 && typeof future_travel_master[item.id] != "undefined"}
                                {#each future_travel_master[item.id] as id_ex, i (id_ex)}
                                  {#if typeof travels_fz[id_ex] != "undefined"}
                                    {#if travels_fz[id_ex].alerts_now > 0}
                                      <div class="p-1">
                                        <a href="/" on:click|preventDefault
                                          ><i
                                            mobid={id_ex}
                                            id="alerts_box"
                                            tooltip="Alertas"
                                            class="material-icons {travels_fz[
                                              id_ex
                                            ].proto_status == ''
                                              ? 'red'
                                              : 'yei'}">warning</i
                                          >
                                        </a>
                                        <strong
                                          >{travels_fz[id_ex]
                                            .alerts_now}</strong
                                        >
                                      </div>
                                    {/if}
                                  {/if}
                                {/each}
                              {/if}
                            </div>
                            <div class="d-flex justify-content-end mb-1">
                              <div class="p-1">
                                <i
                                  tooltip="Velocidad"
                                  class="material-icons {isMonitorNumber(
                                    travels_fz[item.id].mov.speed
                                  )
                                    ? 'green'
                                    : 'gray'}">speed</i
                                >
                                <strong
                                  >{isMonitorNumber(
                                    travels_fz[item.id].mov.speed
                                  )
                                    ? `${travels_fz[item.id].mov.speed} Km/hr`
                                    : "--"}</strong
                                >
                              </div>
                              <div class="p-1">
                                <i
                                  tooltip="Tiempo detenida {travels_fz[item.id]
                                    .mov.time_stop}min"
                                  class="material-icons {travels_fz[item.id]
                                    .ign == 0
                                    ? 'gray'
                                    : travels_fz[item.id].mov.time_stop > 3
                                      ? 'yei'
                                      : 'green'}">pause_presentation</i
                                >
                                <strong
                                  >{time_code(
                                    travels_fz[item.id].mov.time_stop
                                  )}</strong
                                >
                              </div>
                              <div class="p-1">
                                <i
                                  tooltip="Ignición {travels_fz[item.id].ign ==
                                  1
                                    ? 'On'
                                    : travels_fz[item.id].ign == 0
                                      ? 'Off'
                                      : 'Sin dato'}"
                                  class="material-icons {travels_fz[item.id]
                                    .ign == null
                                    ? 'gray'
                                    : travels_fz[item.id].ign == 1
                                      ? 'green'
                                      : 'gray'}">vpn_key</i
                                >
                              </div>
                            </div>
                            <div
                              class="d-flex justify-content-end align-items-center"
                            >
                              <i
                                tooltip="Operador"
                                class="material-icons md-90"
                                style="color:#26a69a">person</i
                              >
                              {#if show_drivers != item.id}
                                <span
                                  on:click={() => {
                                    drivers_edit(item.id);
                                  }}
                                  style={travels_fz[item.id].oper ==
                                    "Desconocido" ||
                                  travels_fz[item.id].oper == ""
                                    ? "color:#2196f3"
                                    : ""}
                                  ><strong id="change_driver"
                                    >{typeof $drivers[
                                      travels_fz[item.id].oper
                                    ] != "undefined"
                                      ? $drivers[travels_fz[item.id].oper].name
                                      : travels_fz[item.id].oper}</strong
                                  ></span
                                >
                              {:else}
                                <select
                                  id="driver_list"
                                  bind:value={driver_selected}
                                >
                                  <option value="">Desconocido</option>
                                  {#each $drivers_list as item, i}
                                    <option value={item[0]}
                                      >{item[1]["name"]}</option
                                    >
                                  {/each}
                                </select>
                                <button
                                  id="save_driver"
                                  on:click={() => {
                                    save_driver(item.id, driver_selected);
                                  }}
                                  type="button"
                                  class="btn btn-success mx-1">Guardar</button
                                >
                                <button
                                  id="cancel_save_driver"
                                  on:click={() => {
                                    show_drivers = -1;
                                  }}
                                  type="button"
                                  class="btn btn-danger mx-1">Cancelar</button
                                >
                              {/if}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                {/each}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="{monitor_units_panel_collapsed ? 'col-12' : 'col-md-6'} h-100 monitor-main-column"
      style="display: flex; flex-direction: column;"
    >
      <div
        class="row no-gutters"
        style="height:{expand_map
          ? 'unset'
          : mapa_ex_mode
            ? '0%'
            : 'unset'}; flex-grow: 1;"
      >
        <div class="col-12 h-100">
          <div class="monitor-map-host-wrap {mapa_ex_mode ? 'is-extracted' : ''}">
            <div class="monitor-map-canvas" bind:this={map_host} />
            {#if !mapa_ex_mode && monitor_units_panel_collapsed}
              <div class="monitor-map-unit-selector" aria-live="polite">
                <div
                  class="monitor-map-unit-search"
                  on:focusin={openCollapsedMonitorSearch}
                  on:focusout={handleCollapsedMonitorSearchFocusOut}
                >
                  <label
                    class="monitor-map-unit-selector-field {collapsed_monitor_active_label != '' && collapsed_monitor_search_query == collapsed_monitor_active_label
                      ? 'is-active'
                      : ''}"
                  >
                    <span class="material-icons md-85"
                      >{collapsed_monitor_active_label != '' && collapsed_monitor_search_query == collapsed_monitor_active_label
                        ? 'gps_fixed'
                        : 'search'}</span
                    >
                    <input
                      bind:this={collapsed_monitor_search_input}
                      class="monitor-map-unit-search-input"
                      type="text"
                      bind:value={collapsed_monitor_search_query}
                      on:focus={beginCollapsedMonitorSearchEditing}
                      on:click={beginCollapsedMonitorSearchEditing}
                      on:input={handleCollapsedMonitorSelectorChange}
                      on:keydown={handleCollapsedMonitorSearchKeydown}
                      placeholder={filtered_monitor_units.length == 0
                        ? 'Sin unidades disponibles'
                        : 'Unidad seleccionada'}
                      disabled={filtered_monitor_units.length == 0}
                      autocomplete="off"
                      spellcheck="false"
                    />
                    {#if collapsed_monitor_active_label != '' && collapsed_monitor_search_query == collapsed_monitor_active_label}
                      <span class="monitor-map-unit-active-pill">Activa</span>
                    {/if}
                    {#if collapsed_monitor_search_query != ""}
                      <button
                        type="button"
                        class="monitor-map-unit-search-clear"
                        on:click={clearCollapsedMonitorSearch}
                        aria-label="Limpiar búsqueda de unidad"
                        title="Limpiar búsqueda"
                      >
                        <span class="material-icons md-85">close</span>
                      </button>
                    {/if}
                  </label>
                  {#if collapsed_monitor_search_open && filtered_monitor_units.length > 0}
                    <div class="monitor-map-unit-results" role="listbox">
                      {#if collapsed_monitor_search_results.length == 0}
                        <div class="monitor-map-unit-empty">
                          <span class="material-icons md-85">search_off</span>
                          <span>No hay coincidencias</span>
                        </div>
                      {:else}
                        {#each collapsed_monitor_search_results as unit (unit.id)}
                          <button
                            type="button"
                            class="monitor-map-unit-result {selected == unit.id
                              ? 'is-active'
                              : ''}"
                            on:mousedown|preventDefault
                            on:click={() =>
                              selectCollapsedMonitorSearchUnit(unit.id)}
                          >
                            <span class="material-icons md-85">directions_car</span>
                            <span class="monitor-map-unit-result-copy">
                              <strong>{getMonitorSelectorNick(unit.id)}</strong>
                            </span>
                          </button>
                        {/each}
                      {/if}
                    </div>
                  {/if}
                </div>
              </div>
            {/if}
            {#if !mapa_ex_mode && has_monitor_map_eta_context && monitor_map_eta_seconds >= 0}
              <div
                class="monitor-map-eta-pill {monitor_units_panel_collapsed && selected != -1
                  ? 'is-shifted'
                  : ''}"
                aria-live="polite"
              >
                <span class="material-icons md-85 monitor-map-eta-icon"
                  >schedule</span
                >
                <div class="monitor-map-eta-copy">
                  <span class="monitor-map-eta-label">ETA</span>
                  <strong>{formatMonitorMapEta(monitor_map_eta_seconds)}</strong>
                </div>
              </div>
            {/if}
            {#if !mapa_ex_mode}
              <div class="monitor-map-overlay">
                <div class="monitor-map-bottom-controls">
                  <div
                    class="monitor-map-layer-menu {map_layer_menu_visible
                      ? 'is-open'
                      : 'is-collapsed'}"
                    on:mouseenter={holdMapLayerMenu}
                    on:mouseleave={releaseMapLayerMenu}
                    on:focusin={holdMapLayerMenu}
                    on:focusout={releaseMapLayerMenu}
                  >
                    <div class="monitor-map-layer-panel">
                      <div class="monitor-map-layer-header">
                        <span class="monitor-map-layer-kicker">Mapa</span>
                        <strong>Capas rapidas</strong>
                        <small>Se ocultan automaticamente para limpiar la vista.</small>
                      </div>

                      <button
                        type="button"
                        class="monitor-map-layer-btn {map_cover ? 'is-active' : ''}"
                        on:click={toggleMapCoverage}
                        disabled={!map}
                        aria-pressed={map_cover}
                      >
                        <span class="material-icons md-85">network_cell</span>
                        <span class="monitor-map-layer-copy">
                          <span>Cobertura</span>
                          <small>{map_cover ? 'Visible' : 'Oculta'}</small>
                        </span>
                      </button>

                      <button
                        type="button"
                        class="monitor-map-layer-btn {map_traffic ? 'is-active' : ''}"
                        on:click={toggleMapTraffic}
                        disabled={!map}
                        aria-pressed={map_traffic}
                      >
                        <span class="material-icons md-85">traffic</span>
                        <span class="monitor-map-layer-copy">
                          <span>Trafico</span>
                          <small>{map_traffic ? 'Visible' : 'Oculto'}</small>
                        </span>
                      </button>

                      <button
                        type="button"
                        class="monitor-map-layer-btn {map_geofence ? 'is-active' : ''}"
                        on:click={toggleMapGeofence}
                        disabled={!map}
                        aria-pressed={map_geofence}
                      >
                        <span class="material-icons md-85">place</span>
                        <span class="monitor-map-layer-copy">
                          <span>Geocercas</span>
                          <small>{map_geofence ? 'Visibles' : 'Ocultas'}</small>
                        </span>
                      </button>
                    </div>

                    <button
                      type="button"
                      class="monitor-map-layer-toggle"
                      on:click={toggleMapLayerMenu}
                      aria-label={map_layer_menu_visible
                        ? 'Ocultar panel de capas del mapa'
                        : 'Mostrar panel de capas del mapa'}
                      title={map_layer_menu_visible
                        ? 'Ocultar capas del mapa'
                        : 'Mostrar capas del mapa'}
                    >
                      <span class="material-icons md-85"
                        >{map_layer_menu_visible ? 'chevron_left' : 'chevron_right'}</span
                      >
                    </button>
                  </div>
                </div>
              </div>
              <div class="monitor-map-primary-controls">
                <div class="monitor-map-type-controls" aria-label="Tipo de mapa">
                  {#each MONITOR_MAP_TYPE_OPTIONS as option (option.id)}
                    <button
                      type="button"
                      class="monitor-map-type-btn {monitor_map_type == option.id
                        ? 'is-active'
                        : ''}"
                      on:click={() => setMonitorMapType(option.id)}
                      disabled={!map}
                      aria-pressed={monitor_map_type == option.id}
                      title={option.label}
                    >
                      <span class="material-icons md-85">{option.icon}</span>
                      <span>{option.label}</span>
                    </button>
                  {/each}
                </div>
              </div>
              <div class="monitor-map-zoom-controls" aria-label="Zoom del mapa">
                <button
                  type="button"
                  class="monitor-map-zoom-btn"
                  on:click={() => changeMonitorMapZoom(1)}
                  disabled={!map || monitor_map_zoom >= getMonitorMapZoomLimit('maxZoom', 22)}
                  aria-label="Acercar mapa"
                  title="Acercar"
                >
                  <span class="material-icons md-85">add</span>
                </button>
                <button
                  type="button"
                  class="monitor-map-zoom-btn"
                  on:click={() => changeMonitorMapZoom(-1)}
                  disabled={!map || monitor_map_zoom <= getMonitorMapZoomLimit('minZoom', 0)}
                  aria-label="Alejar mapa"
                  title="Alejar"
                >
                  <span class="material-icons md-85">remove</span>
                </button>
              </div>
            {/if}
          </div>
        </div>
      </div>
      <div
        class="row no-gutters"
        style="max-height:{mapa_ex_mode ? '100%' : '50%'}; height:{expand_map
          ? 'unset'
          : mapa_ex_mode
            ? '100%'
            : 'unset'};"
      >
        <div class="col-12 h-100">
          <div class="card h-100 card-b monitor-panel">
            <div class="d-flex flex-column h-100">
              <div
                class="card-header b-0 bg-dark text-white monitor-panel-header"
                style="line-height: 1.2; padding-right: 10px;"
              >
                <div class="d-flex monitor-panel-toolbar">
                  <div class="d-flex flex-column flex-grow-1">
                    <div>
                      <i class="material-icons md-85">alarm</i> Viajes
                      programados
                      <span
                        tooltip="Viajes programados"
                        class="badge badge-pill badge-primary"
                        >{future_travel.length}</span
                      >
                      <span
                        tooltip="Viajes en proceso"
                        class="badge badge-pill badge-warning"
                        >{total_en_proceso}</span
                      >
                      <span
                        tooltip="Viajes terminados"
                        class="badge badge-pill badge-success"
                        >{total_terminado}</span
                      >
                      {#if !caravan_mode}
                        <button
                          on:click={mapa_ex}
                          id="mapa_ex"
                          type="button"
                          class="btn btn-{mapa_ex_mode ? 'warning' : 'info'}"
                          style="margin-left: 0.75rem;"
                          >{mapa_ex_mode
                            ? "Mostrar mapa"
                            : "Extraer Mapa"}</button
                        >
                      {/if}
                      {#if !new_travel_s && edit_mode == -1}
                        <button
                          on:click={caravan}
                          id="mapa_ex_caravan"
                          type="button"
                          class="btn btn-{caravan_mode ? 'warning' : 'success'}"
                          style="margin-left: 0.75rem;"
                          disabled={user_level < 1}
                          >{!caravan_mode
                            ? "Crear caravana"
                            : "Crear caravana"}</button
                        >
                        {#if caravan_mode}
                          <button
                            on:click={() => {
                              caravan_mode = false;
                            }}
                            id="mapa_ex"
                            type="button"
                            class="btn btn-danger">Cancelar</button
                          >
                        {/if}
                      {/if}
                    </div>
                  </div>
                  {#if edit_mode == -1}
                    <div class="d-flex flex-column">
                      <div class="d-flex justify-content-end">
                        <button
                          on:click={new_travel}
                          id="edit_prog"
                          type="button"
                          class="btn btn-{new_travel_s ? 'warning' : 'success'}"
                          disabled={user_level < 1}
                          >{new_travel_s ? "Cancelar Viaje" : "Nuevo Viaje"}
                        </button>
                      </div>
                    </div>
                  {/if}
                  <i
                    on:click={() => {
                      expand_map = !expand_map;
                      localStorage.setItem("expand_map", expand_map);
                      if (mapa_ex_mode) mapa_ex();
                    }}
                    class="material-icons md-85"
                    style="margin-left: 0.75rem; cursor: pointer;"
                  >
                    {!expand_map ? "expand_more" : "expand_less"}
                  </i>
                </div>
              </div>
              <div
                class="card-body flex-grow-1 overflow-auto pt-2 pb-2 monitor-panel-body monitor-program-list"
                style="z-index:4; {expand_map
                  ? 'display: none;'
                  : ''} {!expand_map && future_travel.length == 0
                  ? 'display: flex; flex-direction: column; justify-content: center; align-items: center;'
                  : ''}"
                id="lista_viajes_prog"
              >
                {#if future_travel.length == 0}
                  <div class="alert" role="alert">
                    <i class="material-icons md-85">info</i>
                    No hay viajes programados
                  </div>
                {/if}
                {#each future_travel_visible as item, i (item.id + item.date_ini)}
                  <!--Indicador de viajes programados -->
                  {#if item.first_programed}
                    <div
                      style="margin-left:10px; margin-right: 10px;display: flex;align-items: center;margin-bottom: 5px;"
                    >
                      <hr
                        style="flex-grow: 1;margin-left: 5px;margin-right: 10px;margin-top: 0.5rem;margin-bottom: 0.5rem;border-top: 1px solid rgb(0 139 139 / 35%"
                      />
                      <i
                        class="material-icons"
                        style="margin-right: 10px;font-size: 1.2rem;color: darkcyan;"
                      >
                        pending_actions
                      </i>
                      Viajes no iniciados
                      <hr
                        style="flex-grow: 1;margin-left: 10px;margin-right: 5px;margin-top: 0.5rem;margin-bottom: 0.5rem;border-top: 1px solid rgb(0 139 139 / 35%"
                      />
                    </div>
                  {/if}
                  <!-- first dist -->
                  {#if item.first_dist}
                    <div
                      style="margin-left:10px; margin-right: 10px;display: flex;align-items: center;margin-bottom: 5px;"
                    >
                      <hr
                        style="flex-grow: 1;margin-left: 5px;margin-right: 10px;margin-top: 0.5rem;margin-bottom: 0.5rem;border-top: 1px solid rgb(0 139 139 / 35%"
                      />
                      <i
                        class="material-icons"
                        style="margin-right: 10px;font-size: 1.2rem;color: darkcyan;"
                      >
                        flag
                      </i>
                      Viajes proximos a terminar
                      <hr
                        style="flex-grow: 1;margin-left: 10px;margin-right: 5px;margin-top: 0.5rem;margin-bottom: 0.5rem;border-top: 1px solid rgb(0 139 139 / 35%"
                      />
                    </div>
                  {/if}
                  <!-- first no dist -->
                  {#if item.first_no_dist}
                    <div
                      style="margin-left:10px; margin-right: 10px;display: flex;align-items: center;margin-bottom: 5px;"
                    >
                      <hr
                        style="flex-grow: 1;margin-left: 5px;margin-right: 10px;margin-top: 0.5rem;margin-bottom: 0.5rem;border-top: 1px solid rgb(0 139 139 / 35%"
                      />
                      <i
                        class="material-icons"
                        style="margin-right: 10px;font-size: 1.2rem;color: darkcyan;"
                      >
                        directions_bus
                      </i>
                      Viajes en proceso
                      <hr
                        style="flex-grow: 1;margin-left: 10px;margin-right: 5px;margin-top: 0.5rem;margin-bottom: 0.5rem;border-top: 1px solid rgb(0 139 139 / 35%"
                      />
                    </div>
                  {/if}
                  <div
                    class="card pt-0 mx-2 monitor-program-card {prog_selected == item.id &&
                    (prog_selected_future == item.date_ini ||
                      (prog_selected_future == -1 && item.step != 0))
                      ? 'med-border border-info'
                      : ''}"
                    style="font-size:0.78rem; margin-bottom: 5px;cursor:pointer;"
                    id="prog_{item.id + item.date_ini}"
                    on:contextmenu|preventDefault={() => travel_link(item.uuid)}
                  >
                    <div
                      on:click|preventDefault={(event) => {
                        if (item.id != "") {
                          //console.log("click", event);
                          prog_selected = item.id;
                          prog_selected_future = item.date_ini;
                          setMonitorMapEtaContext(item.id, item.date_ini);
                          maping(item.id, {});
                          busca_future_travel(item.id);
                        }
                      }}
                      class="card-header b-0 monitor-program-card-header"
                    >
                      <div class="d-flex">
                        <div
                          class="d-flex flex-column flex-grow-1 {item.id == ''
                            ? 'monitor-new-travel-form'
                            : ''}"
                        >
                          {#if item.id == ""}
                            <div>
                              <i
                                tooltip="Unidad"
                                class="material-icons md-90"
                                style="color:#26a69a">directions_car</i
                              >
                              <input
                                list="lista_unidades"
                                placeholder="Unidad"
                                size="8"
                                on:click={(event) => {
                                  primeUnitDatalist(event.target.value);
                                }}
                                on:focus={(event) => {
                                  primeUnitDatalist(event.target.value);
                                }}
                                on:input={(event) => {
                                  updateUnitDatalist(event.target.value);
                                }}
                                on:change={(event) => {
                                  eco_selected = resolveUnitIdFromLabel(
                                    event.target.value
                                  );
                                  clearUnitDatalist();
                                }}
                              />
                              {#each eco_add_selected as item, i}
                                <input
                                  list="lista_unidades"
                                  placeholder="Unidad"
                                  size="8"
                                  on:click={(event) => {
                                    primeUnitDatalist(event.target.value);
                                  }}
                                  on:focus={(event) => {
                                    primeUnitDatalist(event.target.value);
                                  }}
                                  on:input={(event) => {
                                    updateUnitDatalist(event.target.value);
                                  }}
                                  on:change={(event) => {
                                    eco_add_selected[i] = resolveUnitIdFromLabel(
                                      event.target.value
                                    );
                                    clearUnitDatalist();
                                  }}
                                />
                              {/each}
                              {#if eco_selected != "" && (eco_add_selected.length == 0 || eco_add_selected[eco_add_selected.length - 1] != "")}
                                <button
                                  tooltip="Agregar"
                                  type="button"
                                  class="btn btn-link p-0"
                                  on:click={() => {
                                    eco_add_selected.push("");
                                    eco_add_selected = [...eco_add_selected];
                                  }}
                                >
                                  <i
                                    class="material-icons md-85"
                                    style="color:#43a047">add_box</i
                                  >
                                </button>
                              {/if}
                            </div>
                          {/if}
                          <div>
                            {#if caravan_mode && item.step - 2 != item.sec_dests.length && item.step > 0}
                              <span
                                class="monitor-caravan-check"
                                on:click|stopPropagation
                              >
                                <input
                                  type="checkbox"
                                  bind:group={caravan_group}
                                  value={item.uuid}
                                  on:click|stopPropagation
                                />
                              </span>
                            {/if}
                            {#if typeof item.caravan_id != "undefined"}
                              <i
                                tooltip="Caravana {item.caravan_id}"
                                class="material-icons md-90"
                                style="color:{item.caravan_color}"
                                >brightness_1</i
                              >
                            {:else}
                              <i
                                tooltip={drivers_hos[item.oper] != undefined
                                  ? !drivers_hos[item.oper]
                                    ? "Sin tiempo HOS"
                                    : "Viaje"
                                  : "Viaje"}
                                class="material-icons md-90"
                                style="color:{drivers_hos[item.oper] !=
                                undefined
                                  ? !drivers_hos[item.oper]
                                    ? 'rgb(227 24 23)'
                                    : '#26a69a'
                                  : '#26a69a'}"
                                >{drivers_hos[item.oper] != undefined
                                  ? !drivers_hos[item.oper]
                                    ? "timer_off"
                                    : "alarm"
                                  : "alarm"}</i
                              >
                              {#if drivers_hos[item.oper] != undefined && !drivers_hos[item.oper]}
                                <i
                                  tooltip="Sin tiempo HOS"
                                  class="material-icons md-90"
                                  style="color:#d84315">traffic</i
                                >
                              {/if}
                            {/if}
                            {#if item.id != ""}
                              <strong>
                                {typeof $nicks_list[item.id] != "undefined"
                                  ? $nicks_list[item.id]
                                  : item.id}
                                {#if id_add_selected == item.id + item.date_ini}
                                  {#each item.id_add as item, i}
                                    , <span style="color:#607D8B;"
                                      >{typeof $nicks_list[item] != "undefined"
                                        ? $nicks_list[item]
                                        : item}</span
                                    >
                                  {/each}
                                {/if}
                              </strong>
                              {#if typeof item.id_add != "undefined"}
                                {#if item.id_add.length > 0}
                                  <button
                                    style="padding: 1px 1px;"
                                    type="button"
                                    class="btn btn-link"
                                    on:click={() => {
                                      id_add_selected =
                                        id_add_selected ==
                                        item.id + item.date_ini
                                          ? -1
                                          : item.id + item.date_ini;
                                    }}
                                    ><i class="material-icons md-90 green"
                                      >{id_add_selected ==
                                      item.id + item.date_ini
                                        ? "remove_circle_outline"
                                        : "add_circle_outline"}</i
                                    ></button
                                  >
                                {/if}
                              {/if}
                              |
                              <span
                                style="color:{item.step == 0
                                  ? '#ff8f00'
                                  : '#8bc34a'}"
                                ><strong
                                  >{moment(
                                    new Date(item.date_ini * 1000)
                                  ).format("DD/MM/YY HH:mm")}</strong
                                ></span
                              >
                              {#if item.step == 1}
                                | <span style="color:#546e7a"
                                  ><strong>Iniciado</strong></span
                                >
                              {:else if item.step - 2 == item.sec_dests.length}
                                | <span style="color:#d84315"
                                  ><strong>Terminado</strong></span
                                >
                              {:else if item.step > 1}
                                | <span style="color:#546e7a"
                                  ><strong
                                    >{item.step - 1} de {item.sec_dests.length +
                                      1}</strong
                                  ></span
                                >
                              {/if}
                              {#if item.step > 0}
                                |
                                <button
                                  on:click={() => {
                                    end_travel_modal(
                                      item.id,
                                      item.date_ini,
                                      item.uuid,
                                      item.id_add
                                    );
                                  }}
                                  id="end_travel_{$nicks_list[item.id]}"
                                  type="button"
                                  class="btn btn-info"
                                  disabled={user_level < 1}
                                >
                                  Cerrar viaje
                                </button>
                              {/if}
                              {#if item.step == 0 && edit_mode != item.id + item.date_ini}
                                |
                                <button
                                  on:click={async () => {
                                    let r =
                                      drivers_hos[item.oper] != undefined
                                        ? drivers_hos[item.oper]
                                        : true;
                                    if (r) {
                                      launch_travel(
                                        item.id,
                                        item.date_ini,
                                        item.dest,
                                        item.oper,
                                        item.route,
                                        item.id_add,
                                        item.org
                                      );
                                    } else {
                                      con_init_travel_modal_backup = [
                                        item.id,
                                        item.date_ini,
                                        item.dest,
                                        item.oper,
                                        item.route,
                                        item.id_add,
                                        item.org,
                                      ];
                                      con_hos_travel_modal = true;
                                    }
                                  }}
                                  id="launch_prog_{$nicks_list[item.id]}"
                                  type="button"
                                  class="btn btn-warning"
                                  disabled={user_level < 1}
                                >
                                  Iniciar
                                </button>
                                {#if moment
                                  .unix(item.date_ini)
                                  .diff(moment.unix(now_), "hours") <= 3}
                                  |
                                  <span
                                    style="font-weight: bold;color:{moment
                                      .unix(item.date_ini)
                                      .diff(moment.unix(now_), 'minutes') < 0
                                      ? 'red'
                                      : moment
                                            .unix(item.date_ini)
                                            .diff(
                                              moment.unix(now_),
                                              'minutes'
                                            ) < 60
                                        ? 'orange'
                                        : 'black'}"
                                  >
                                    {moment
                                      .unix(item.date_ini)
                                      .diff(moment.unix(now_), "minutes") < 0
                                      ? "-"
                                      : ""}
                                    {(Math.abs(
                                      moment
                                        .unix(item.date_ini)
                                        .diff(moment.unix(now_), "hours")
                                    ) > 0
                                      ? Math.abs(
                                          moment
                                            .unix(item.date_ini)
                                            .diff(moment.unix(now_), "hours")
                                        ) + "h "
                                      : "") +
                                      (Math.abs(
                                        moment
                                          .unix(item.date_ini)
                                          .diff(moment.unix(now_), "minutes")
                                      ) %
                                        60) +
                                      "m"}
                                  </span>
                                {/if}
                              {/if}
                            {:else}
                              <input
                                list="fecha"
                                placeholder="Fecha"
                                size="10"
                                on:change={(event) => {
                                  fecha_v = "";
                                  for (let w in fechas) {
                                    if (fechas[w][1] == event.target.value) {
                                      fecha_v = fechas[w][0];
                                    }
                                  }
                                }}
                              />
                              <datalist id="fecha">
                                {#each fechas as item, i}
                                  <option value={item[1]} />{/each}
                              </datalist>
                              <input
                                list="hora"
                                placeholder="Hora"
                                size="6"
                                on:change={(event) => {
                                  hora_v = "";
                                  for (let w in horas) {
                                    if (horas[w][1] == event.target.value) {
                                      hora_v = horas[w][0];
                                    }
                                  }
                                }}
                              />
                              <datalist id="hora">
                                {#each horas as item, i}
                                  <option value={item[1]} />{/each}
                              </datalist>
                            {/if}
                          </div>
                          {#if future_travel_dist[item.id]}
                            <div
                              style="display: flex;align-items: center;height: 20px;"
                            >
                              <div class="icon" style="margin-right: 10px;">
                                <div class="wave left"></div>
                                <div class="dot"></div>
                                <div class="wave right"></div>
                              </div>
                              <strong style="color:#b79200;"
                                >{future_travel_dist[item.id].dist == "llego"
                                  ? "En destino"
                                  : "Proximo a destino"}</strong
                              >
                            </div>
                          {/if}
                          <div>
                            <i
                              tooltip="Origen"
                              class="material-icons md-90"
                              style="color:#26a69a">play_circle_outline</i
                            >
                            {#if (item.id != "" && edit_mode != item.id + item.date_ini) || (edit_mode == item.id + item.date_ini && item.step != 0)}
                              <strong
                                >{typeof $geos_class[item.org] != "undefined"
                                  ? $geos_class[item.org][0]
                                  : typeof $poli[item.org] != "undefined"
                                    ? $poli[item.org][1]
                                    : item.org
                                      ? item.org
                                      : "Origen no definido"}</strong
                              >
                              {#if item.step > 0}
                                <i
                                  class="material-icons md-85"
                                  style="color:#aed581">check_circle</i
                                >
                              {/if}
                            {:else if edit_mode == item.id + item.date_ini}
                              <input
                                list="org_list"
                                placeholder="Origen"
                                size="30"
                                on:change={(event) => {
                                  org_selected = "";
                                  for (let x in $geos_class_list) {
                                    if (
                                      $geos_class_list[x][1] ==
                                      event.target.value
                                    ) {
                                      org_selected = $geos_class_list[x][0];
                                    }
                                  }
                                  for (let x in $poli_list) {
                                    if (
                                      $poli_list[x][2] == event.target.value
                                    ) {
                                      org_selected = $poli_list[x][0];
                                    }
                                  }
                                }}
                                value={typeof $geos_class[item.org] !=
                                "undefined"
                                  ? $geos_class[item.org][0]
                                  : typeof $poli[item.org] != "undefined"
                                    ? $poli[item.org][1]
                                    : item.org
                                      ? item.org
                                      : ""}
                              />
                              <datalist id="org_list">
                                {#each $geos_class_list as item, i}
                                  <option value={item[1]} />{/each}
                                {#each $poli_list as item, i}
                                  <option value={item[2]} />{/each}
                              </datalist>
                            {:else}
                              <input
                                list="org_list"
                                placeholder="Origen"
                                size="30"
                                on:change={(event) => {
                                  org_selected = "";
                                  for (let x in $geos_class_list) {
                                    if (
                                      $geos_class_list[x][1] ==
                                      event.target.value
                                    ) {
                                      org_selected = $geos_class_list[x][0];
                                    }
                                  }
                                  for (let x in $poli_list) {
                                    if (
                                      $poli_list[x][2] == event.target.value
                                    ) {
                                      org_selected = $poli_list[x][0];
                                    }
                                  }
                                }}
                              />
                              <datalist id="org_list">
                                {#each $geos_class_list as item, i}
                                  <option value={item[1]} />{/each}
                                {#each $poli_list as item, i}
                                  <option value={item[2]} />{/each}
                              </datalist>
                            {/if}
                          </div>
                          <div>
                            <i
                              tooltip="Destino"
                              class="material-icons md-90"
                              style="color:#26a69a">stop</i
                            >
                            {#if item.id != ""}
                              {#if item.sec_dests.length == 0 || e_selected == item.id + item.date_ini}
                                {#if edit_mode != item.id + item.date_ini || (edit_mode == item.id + item.date_ini && item.step > 1)}
                                  <strong
                                    >{typeof $geos_class[item.dest] !=
                                    "undefined"
                                      ? $geos_class[item.dest][0]
                                      : typeof $poli[item.dest] != "undefined"
                                        ? $poli[item.dest][1]
                                        : item.dest}</strong
                                  >
                                  {#if item.step > 1}
                                    <i
                                      class="material-icons md-85"
                                      style="color:#aed581">check_circle</i
                                    >
                                  {/if}
                                {:else}
                                  <input
                                    list="dest_list"
                                    placeholder="Destino"
                                    size="30"
                                    on:change={(event) => {
                                      dest_selected = "";
                                      for (let x in $geos_class_list) {
                                        if (
                                          $geos_class_list[x][1] ==
                                          event.target.value
                                        ) {
                                          dest_selected =
                                            $geos_class_list[x][0];
                                        }
                                      }
                                      for (let x in $poli_list) {
                                        if (
                                          $poli_list[x][2] == event.target.value
                                        ) {
                                          dest_selected = $poli_list[x][0];
                                        }
                                      }
                                    }}
                                    value={typeof $geos_class[item.dest] !=
                                    "undefined"
                                      ? $geos_class[item.dest][0]
                                      : typeof $poli[item.dest] != "undefined"
                                        ? $poli[item.dest][1]
                                        : item.dest}
                                  />
                                  <button
                                    tooltip="Borrar"
                                    type="button"
                                    class="btn btn-link p-0"
                                    on:click={() => edit_del_destino(i, 0)}
                                  >
                                    <i
                                      class="material-icons md-85"
                                      style="color:#dd2c00">delete</i
                                    >
                                  </button>
                                  {#if 0 == item.sec_dests.length && edit_mode == item.id + item.date_ini}
                                    <button
                                      tooltip="Agregar"
                                      type="button"
                                      class="btn btn-link p-0"
                                      on:click={() => edit_add_destino(i, 0)}
                                    >
                                      <i
                                        class="material-icons md-85"
                                        style="color:#43a047">add_box</i
                                      >
                                    </button>
                                  {/if}
                                  <datalist id="dest_list">
                                    {#each $geos_class_list as item, i}
                                      <option value={item[1]} />{/each}
                                    {#each $poli_list as item, i}
                                      <option value={item[2]} />{/each}
                                  </datalist>
                                {/if}
                              {:else}
                                <span style="color:#ff5722"
                                  ><strong
                                    >{typeof $geos_class[
                                      item.sec_dests[item.sec_dests.length - 1]
                                    ] != "undefined"
                                      ? $geos_class[
                                          item.sec_dests[
                                            item.sec_dests.length - 1
                                          ]
                                        ][0]
                                      : typeof $poli[
                                            item.sec_dests[
                                              item.sec_dests.length - 1
                                            ]
                                          ] != "undefined"
                                        ? $poli[
                                            item.sec_dests[
                                              item.sec_dests.length - 1
                                            ]
                                          ][1]
                                        : item.sec_dests[
                                            item.sec_dests.length - 1
                                          ]}</strong
                                  ></span
                                >
                                {#if item.step == item.sec_dests.length + 2}
                                  <i
                                    class="material-icons md-85"
                                    style="color:#aed581">check_circle</i
                                  >
                                {/if}
                              {/if}
                              {#if item.sec_dests.length > 0 && e_selected != item.id + item.date_ini}
                                <button
                                  id={item.id + item.date_ini}
                                  type="button"
                                  class="btn btn-link"
                                  on:click={() => {
                                    extra_selected(item.id + item.date_ini);
                                  }}
                                  ><i class="material-icons md-90 green"
                                    >add_circle_outline</i
                                  ></button
                                >
                              {/if}
                            {:else}
                              <input
                                list="dest_list"
                                placeholder="Destino"
                                size="30"
                                on:change={(event) => {
                                  dest_selected = "";
                                  for (let x in $geos_class_list) {
                                    if (
                                      $geos_class_list[x][1] ==
                                      event.target.value
                                    ) {
                                      dest_selected = $geos_class_list[x][0];
                                    }
                                  }
                                  for (let x in $poli_list) {
                                    if (
                                      $poli_list[x][2] == event.target.value
                                    ) {
                                      dest_selected = $poli_list[x][0];
                                    }
                                  }
                                }}
                              />
                              <datalist id="dest_list">
                                {#each $geos_class_list as item, i}
                                  <option value={item[1]} />{/each}
                                {#each $poli_list as item, i}
                                  <option value={item[2]} />{/each}
                              </datalist>
                            {/if}
                          </div>
                          {#if e_selected == item.id + item.date_ini}
                            {#each item.sec_dests as sec_dests, j}
                              <div>
                                <i
                                  class="material-icons md-90"
                                  style="color:#26a69a">stop</i
                                >
                                {#if edit_mode != item.id + item.date_ini || (edit_mode == item.id + item.date_ini && item.step > j + 2)}
                                  <strong
                                    >{typeof $geos_class[sec_dests] !=
                                    "undefined"
                                      ? $geos_class[sec_dests][0]
                                      : typeof $poli[sec_dests] != "undefined"
                                        ? $poli[sec_dests][1]
                                        : sec_dests}</strong
                                  >
                                  {#if item.step > j + 2}
                                    <i
                                      class="material-icons md-85"
                                      style="color:#aed581">check_circle</i
                                    >
                                  {/if}
                                {:else}
                                  <input
                                    list="dest_list"
                                    on:change={(event) => {
                                      travel_toe.sec_dests[j] = "";
                                      for (let x in $geos_class_list) {
                                        if (
                                          $geos_class_list[x][1] ==
                                          event.target.value
                                        ) {
                                          travel_toe.sec_dests[j] =
                                            $geos_class_list[x][0];
                                          travel_toe_.sec_dests[j] =
                                            $geos_class_list[x][0];
                                          console.log(travel_toe);
                                        }
                                      }
                                      for (let x in $poli_list) {
                                        if (
                                          $poli_list[x][2] == event.target.value
                                        ) {
                                          travel_toe.sec_dests[j] =
                                            $poli_list[x][0];
                                          travel_toe_.sec_dests[j] =
                                            $poli_list[x][0];
                                          console.log(travel_toe);
                                        }
                                      }
                                    }}
                                    placeholder="Destino"
                                    size="30"
                                    value={typeof $geos_class[sec_dests] !=
                                    "undefined"
                                      ? $geos_class[sec_dests][0]
                                      : typeof $poli[sec_dests] != "undefined"
                                        ? $poli[sec_dests][1]
                                        : sec_dests}
                                  />
                                  <button
                                    tooltip="Borrar"
                                    type="button"
                                    class="btn btn-link p-0"
                                    on:click={() => edit_del_destino(i, j + 1)}
                                  >
                                    <i
                                      class="material-icons md-85"
                                      style="color:#dd2c00">delete</i
                                    >
                                  </button>
                                  <datalist id="dest_list">
                                    {#each $geos_class_list as item, i}
                                      <option value={item[1]} />{/each}
                                    {#each $poli_list as item, i}
                                      <option value={item[2]} />{/each}
                                  </datalist>
                                {/if}
                                {#if j + 1 == item.sec_dests.length && edit_mode != item.id + item.date_ini}
                                  <button
                                    id="{item.id + item.date_ini}_remove"
                                    type="button"
                                    class="btn btn-link"
                                    on:click={() => {
                                      e_selected = -1;
                                    }}
                                    ><i class="material-icons md-90 green"
                                      >remove_circle_outline</i
                                    ></button
                                  >
                                {/if}
                                {#if j + 1 == item.sec_dests.length && edit_mode == item.id + item.date_ini}
                                  <button
                                    tooltip="Agregar"
                                    type="button"
                                    class="btn btn-link p-0"
                                    on:click={() => edit_add_destino(i, j + 1)}
                                  >
                                    <i
                                      class="material-icons md-85"
                                      style="color:#43a047">add_box</i
                                    >
                                  </button>
                                {/if}
                              </div>
                            {/each}
                          {/if}
                          {#if typeof item.dest_m != "undefined"}
                            {#each item.dest_m as dest, j}
                              <div>
                                <i
                                  class="material-icons md-90"
                                  style="color:#26a69a">stop</i
                                >
                                <input
                                  list="dest_list"
                                  on:change={(event) => {
                                    for (let x in $geos_class_list) {
                                      if (
                                        $geos_class_list[x][1] ==
                                        event.target.value
                                      ) {
                                        future_travel[0].dest_m[j] = {
                                          name: $geos_class_list[x][0],
                                        };
                                        console.log(future_travel[0]);
                                      }
                                    }
                                    for (let x in $poli_list) {
                                      if (
                                        $poli_list[x][2] == event.target.value
                                      ) {
                                        future_travel[0].dest_m[j] = {
                                          name: $poli_list[x][0],
                                        };
                                        console.log(future_travel[0]);
                                      }
                                    }
                                  }}
                                  placeholder="Destino"
                                  size="30"
                                />
                                <datalist id="dest_list">
                                  {#each $geos_class_list as item, i}
                                    <option value={item[1]} />{/each}
                                  {#each $poli_list as item, i}
                                    <option value={item[2]} />{/each}
                                </datalist>
                              </div>
                            {/each}
                          {/if}
                        </div>
                        <div
                          class="d-flex flex-column {item.id == ''
                            ? 'monitor-new-travel-form'
                            : ''}"
                        >
                          <div class="d-flex justify-content-end">
                            <div>
                              {#if item.id != "" && $drivers[item.oper]}
                                {#if $drivers[item.oper].status == 1}
                                  <!--GPS Driver-->
                                  <i
                                    on:click|stopPropagation|preventDefault={() => {
                                      // Center map on driver
                                      if (
                                        typeof drivers_[item.oper] !=
                                          "undefined" &&
                                        map
                                      ) {
                                        if (
                                          drivers_[item.oper].pos.status == 1
                                        ) {
                                          map.setCenter({
                                            lat: drivers_[item.oper].pos.lat,
                                            lng: drivers_[item.oper].pos.lng,
                                          });
                                          console.log("map center");
                                          bc_route.postMessage({
                                            center: "driver",
                                            lat: drivers_[item.oper].pos.lat,
                                            lng: drivers_[item.oper].pos.lng,
                                          });
                                        }
                                      }
                                    }}
                                    tooltip={drivers_[item.oper].pos.status == 1
                                      ? "GPS disponible"
                                      : drivers_[item.oper].pos.status == -1
                                        ? "GPS no disponible"
                                        : "Conductor no acepta GPS"}
                                    class="material-icons md-90"
                                    style="z-index: 10;color:{drivers_[
                                      item.oper
                                    ].pos.status == 1
                                      ? '#26a69a'
                                      : drivers_[item.oper].pos.status == -1
                                        ? '#ff8f00'
                                        : 'rgb(166 38 96)'};
                                      cursor:pointer"
                                    >{drivers_[item.oper].pos.status == 1
                                      ? "gps_fixed"
                                      : "gps_off"}</i
                                  >
                                  <!--Show Video live -->
                                  <i
                                    on:click|stopPropagation|preventDefault={() => {
                                      if (
                                        $drivers[item.oper].video_permission ==
                                        "ok"
                                      ) {
                                        if (show_audio_status) {
                                          show_audio_status = false;
                                          socket_query.emit(
                                            "rtc_disconnect",
                                            driver_video
                                          );
                                          // Detener la transmisión de audio
                                          if (audioStream1) {
                                            audioStream1
                                              .getTracks()
                                              .forEach((track) => track.stop());
                                            audioStream1 = null;
                                          }
                                        }
                                        show_video(item.oper);
                                      } else {
                                        saved_ok = true;
                                        saved_text =
                                          "El conductor no dió permisos para ver video en vivo";
                                        saved_type = "alert-danger";
                                        setTimeout(function () {
                                          saved_ok = false;
                                        }, 3000);
                                      }
                                    }}
                                    tooltip="Video"
                                    class="material-icons md-90"
                                    style="z-index: 10;color:{$drivers[
                                      item.oper
                                    ].video_permission == 'ok'
                                      ? '#26a69a'
                                      : 'rgb(166 38 96)'};
                                      cursor:pointer;"
                                    >{$drivers[item.oper].video_permission ==
                                    "ok"
                                      ? "videocam"
                                      : "videocam_off"}</i
                                  >
                                  <!-- Show Audio Live-->
                                  <i
                                    on:click|stopPropagation|preventDefault={() => {
                                      if (
                                        $drivers[item.oper].audio_permission ==
                                        "ok"
                                      ) {
                                        if (!show_audio_status) {
                                          show_audio(item.oper);
                                        } else {
                                          show_audio_status = false;
                                          socket_query.emit(
                                            "rtc_disconnect",
                                            driver_video
                                          );
                                          // Detener la transmisión de audio
                                          if (audioStream1) {
                                            audioStream1
                                              .getTracks()
                                              .forEach((track) => track.stop());
                                            audioStream1 = null;
                                          }
                                        }
                                      } else {
                                        saved_ok = true;
                                        saved_text =
                                          "El conductor no dió permisos para escuchar audio en vivo";
                                        saved_type = "alert-danger";
                                        setTimeout(function () {
                                          saved_ok = false;
                                        }, 3000);
                                      }
                                    }}
                                    tooltip="Audio"
                                    class="material-icons md-90"
                                    style="z-index: 10;color:{$drivers[
                                      item.oper
                                    ].audio_permission == 'ok'
                                      ? !show_audio_status
                                        ? '#26a69a'
                                        : !audioStream1
                                          ? 'rgb(166 38 96)'
                                          : 'rgb(83 231 102)'
                                      : 'rgb(166 38 96)'};
                                      cursor:pointer"
                                    >{$drivers[item.oper].audio_permission ==
                                    "ok"
                                      ? "mic"
                                      : "mic_off"}</i
                                  >
                                  <i
                                    class="material-icons md-90"
                                    tooltip="Conductor en línea"
                                    style="color:rgb(74 205 34)"
                                    >fiber_manual_record
                                  </i>
                                {/if}
                              {/if}
                              <i
                                class="material-icons md-90"
                                style="color:{$drivers[item.oper]
                                  ? $drivers[item.oper].status == 1
                                    ? 'rgb(74 205 34)'
                                    : '#26a69a'
                                  : '#26a69a'}">person</i
                              >
                              {#if item.id != ""}
                                <strong
                                  >{typeof $drivers[item.oper] != "undefined"
                                    ? $drivers[item.oper].name
                                    : item.oper}</strong
                                >
                                {#if item.id_travel}
                                  <i
                                    tooltip="ID de viaje"
                                    class="material-icons md-90"
                                    style="color:#26a69a">label</i
                                  >
                                  <strong>{item.id_travel}</strong>
                                {/if}
                              {:else}
                                <input
                                  list="driver_list"
                                  placeholder="Operador"
                                  size="30"
                                  on:change={(event) => {
                                    oper_selected = "";
                                    for (let x in $drivers_list) {
                                      if (
                                        $drivers_list[x][1]["name"] ==
                                        event.target.value
                                      ) {
                                        oper_selected = $drivers_list[x][0];
                                      }
                                    }
                                  }}
                                />
                                <datalist id="driver_list">
                                  {#each $drivers_list as item, i}
                                    <option value={item[1]["name"]} />{/each}
                                </datalist>
                              {/if}
                            </div>
                          </div>
                          <div class="d-flex justify-content-end">
                            <div>
                              {#if item.id == ""}
                                <i
                                  tooltip="ID de viaje"
                                  class="material-icons md-90"
                                  style="color:#26a69a">label</i
                                >
                                <input
                                  type="text"
                                  placeholder="ID de viaje (opcional)"
                                  size="30"
                                  on:change={(event) => {
                                    id_travel_selected = event.target.value;
                                  }}
                                />
                              {/if}
                            </div>
                          </div>
                          <div class="d-flex justify-content-end">
                            <div>
                              <i
                                tooltip="Ruta"
                                class="material-icons md-90"
                                style="color:#26a69a">directions</i
                              >
                              {#if item.id != ""}
                                {#if item.sec_dests.length == 0 || e_selected == item.id + item.date_ini}
                                  {#if edit_mode != item.id + item.date_ini || (edit_mode == item.id + item.date_ini && item.step > 1)}
                                    <strong
                                      tooltip={typeof $route_list_d[
                                        item.route
                                      ] != "undefined"
                                        ? $route_list_d[item.route]
                                        : "Nombre no disponible"}
                                      >{typeof $route_list_d[item.route] !=
                                      "undefined"
                                        ? $route_list_d[item.route].length > 35
                                          ? $route_list_d[item.route].slice(
                                              0,
                                              35
                                            ) + "..."
                                          : $route_list_d[item.route]
                                        : "Nombre no disponible"}</strong
                                    >
                                  {:else}
                                    <input
                                      list="ruta_list"
                                      placeholder="Ruta"
                                      size="30"
                                      on:change={(event) => {
                                        route_f_selected = "";
                                        for (let x in route_list_) {
                                          if (
                                            route_list_[x][1] ==
                                            event.target.value
                                          ) {
                                            route_f_selected =
                                              route_list_[x][0];
                                          }
                                        }
                                      }}
                                      value={typeof $route_list_d[item.route] !=
                                      "undefined"
                                        ? $route_list_d[item.route]
                                        : ""}
                                      on:contextmenu|preventDefault={() =>
                                        route_options(0, true)}
                                    />
                                    <datalist id="ruta_list">
                                      {#each route_list_ as item, i}
                                        {#if typeof geos_class_join[org_selected] != "undefined"}
                                          {#if (org_selected == "" || org_selected == item[2][2] || $geos_class_join[org_selected][2] == item[2][2]) && (dest_selected == "" || dest_selected == item[3][2] || $geos_class_join[dest_selected][2] == item[3][2])}
                                            <option value={item[1]} />
                                          {/if}
                                        {:else if (org_selected == "" || org_selected == item[2][2]) && (dest_selected == "" || dest_selected == item[3][2])}
                                          <option value={item[1]} />
                                        {/if}
                                      {/each}
                                    </datalist>
                                  {/if}
                                {:else}
                                  <span style="color:#ff5722"
                                    ><strong>{"Multiples rutas"}</strong></span
                                  >
                                {/if}
                              {:else}
                                <input
                                  list="ruta_list_1"
                                  placeholder="Ruta (opcional)"
                                  size="30"
                                  on:change={(event) => {
                                    route_f_selected = "";
                                    for (let x in route_list_) {
                                      if (
                                        route_list_[x][1] == event.target.value
                                      ) {
                                        route_f_selected = route_list_[x][0];
                                      }
                                    }
                                  }}
                                  on:contextmenu|preventDefault={() =>
                                    route_options(0, false)}
                                />
                                <datalist id="ruta_list_1">
                                  {#each route_list_ as item, i}
                                    {#if typeof geos_class_join[org_selected] != "undefined"}
                                      {#if (org_selected == "" || org_selected == item[2][2] || $geos_class_join[org_selected][2] == item[2][2]) && (dest_selected == "" || dest_selected == item[3][2] || $geos_class_join[dest_selected][2] == item[3][2])}
                                        <option value={item[1]} />
                                      {/if}
                                    {:else if (org_selected == "" || org_selected == item[2][2]) && (dest_selected == "" || dest_selected == item[3][2])}
                                      <option value={item[1]} />
                                    {/if}
                                  {/each}
                                </datalist>
                              {/if}
                            </div>
                          </div>
                          {#if e_selected == item.id + item.date_ini}
                            {#each item.sec_routes as sec_routes, j}
                              <div
                                tooltip="Ruta"
                                class="d-flex justify-content-end align-items-center"
                              >
                                <i
                                  class="material-icons md-90"
                                  style="color:#26a69a">directions</i
                                >
                                {#if edit_mode != item.id + item.date_ini || (edit_mode == item.id + item.date_ini && item.step > j + 2)}
                                  <strong
                                    tooltip={typeof $route_list_d[sec_routes] !=
                                    "undefined"
                                      ? $route_list_d[sec_routes]
                                      : "Nombre no disponible"}
                                    >{typeof $route_list_d[sec_routes] !=
                                    "undefined"
                                      ? $route_list_d[sec_routes].length > 35
                                        ? $route_list_d[sec_routes].slice(
                                            0,
                                            35
                                          ) + "..."
                                        : $route_list_d[sec_routes]
                                      : "Nombre no disponible"}</strong
                                  >
                                {:else}
                                  <input
                                    list="ruta_list_{j}a"
                                    placeholder="Ruta"
                                    size="30"
                                    on:change={(event) => {
                                      for (let x in route_list_) {
                                        if (
                                          route_list_[x][1] ==
                                          event.target.value
                                        ) {
                                          travel_toe.sec_routes[j] =
                                            route_list_[x][0];
                                        }
                                      }
                                      console.log(item.sec_dests);
                                    }}
                                    value={typeof $route_list_d[sec_routes] !=
                                    "undefined"
                                      ? $route_list_d[sec_routes]
                                      : ""}
                                    on:contextmenu|preventDefault={() =>
                                      route_options(j + 1, true)}
                                  />
                                  <datalist id="ruta_list_{j}a">
                                    {#each route_list_ as item_, i}
                                      {#if typeof $geos_class_join[dest_selected] != "undefined"}
                                        {#if (j == 0 && (dest_selected == "" || dest_selected == item_[2][2] || $geos_class_join[dest_selected][2] == item_[2][2]) && (travel_toe_.sec_dests[j] == "" || travel_toe_.sec_dests[j] == item_[3][2] || $geos_class_join[travel_toe_.sec_dests[j]][2] == item_[3][2])) || (j != 0 && (travel_toe_.sec_dests[j - 1] == "" || travel_toe_.sec_dests[j - 1] == item_[2][2] || $geos_class_join[travel_toe_.sec_dests[j - 1]][2] == item_[2][2]) && (travel_toe_.sec_dests[j] == "" || travel_toe_.sec_dests[j] == item_[3][2] || $geos_class_join[travel_toe_.sec_dests[j]][2] == item_[3][2]))}
                                          <option value={item_[1]} />{/if}
                                      {:else if (j == 0 && (dest_selected == "" || dest_selected == item_[2][2]) && (travel_toe_.sec_dests[j] == "" || travel_toe_.sec_dests[j] == item_[3][2])) || (j != 0 && (travel_toe_.sec_dests[j - 1] == "" || travel_toe_.sec_dests[j - 1] == item_[2][2]) && (travel_toe_.sec_dests[j] == "" || travel_toe_.sec_dests[j] == item_[3][2]))}
                                        <option value={item_[1]} />
                                      {/if}
                                    {/each}
                                  </datalist>
                                {/if}
                              </div>
                            {/each}
                          {/if}
                          {#if typeof item.route_m != "undefined"}
                            {#each future_travel[0].route_m as route, j}
                              <div class="d-flex justify-content-end">
                                <div>
                                  <i
                                    class="material-icons md-90"
                                    style="color:#26a69a">directions</i
                                  >
                                  <input
                                    list="ruta_list_{j}b"
                                    placeholder="Ruta"
                                    size="30"
                                    on:change={(event) => {
                                      console.log("blur");
                                      for (let x in route_list_) {
                                        if (
                                          route_list_[x][1] ==
                                          event.target.value
                                        ) {
                                          future_travel_r[0].route_m[j] = {
                                            name: route_list_[x][0],
                                          };
                                        }
                                      }
                                    }}
                                    on:contextmenu|preventDefault={() =>
                                      route_options(1 + j, false)}
                                  />
                                  <datalist id="ruta_list_{j}b">
                                    {#each route_list_ as item, i (item[0])}
                                      {#if typeof $geos_class_join[dest_selected] != "undefined"}
                                        {#if (j == 0 && (dest_selected == "" || dest_selected == item[2][2] || $geos_class_join[dest_selected][2] == item[2][2]) && (future_travel[0].dest_m[j].name == "" || future_travel[0].dest_m[j].name == item[3][2] || $geos_class_join[future_travel[0].dest_m[j].name][2] == item[3][2])) || (j != 0 && (future_travel[0].dest_m[j - 1].name == "" || future_travel[0].dest_m[j - 1].name == item[2][2] || $geos_class_join[future_travel[0].dest_m[j - 1].name][2] == item[2][2]) && (future_travel[0].dest_m[j].name == "" || future_travel[0].dest_m[j].name == item[3][2] || $geos_class_join[future_travel[0].dest_m[j].name][2] == item[3][2]))}
                                          <option value={item[1]} />{/if}
                                      {:else if (j == 0 && (dest_selected == "" || dest_selected == item[2][2]) && (future_travel[0].dest_m[j].name == "" || future_travel[0].dest_m[j].name == item[3][2])) || (j != 0 && (future_travel[0].dest_m[j - 1].name == "" || future_travel[0].dest_m[j - 1].name == item[2][2]) && (future_travel[0].dest_m[j].name == "" || future_travel[0].dest_m[j].name == item[3][2]))}
                                        <option value={item[1]} />
                                      {/if}
                                    {/each}
                                  </datalist>
                                </div>
                              </div>
                            {/each}
                          {/if}
                          <div class="d-flex justify-content-end">
                            <div>
                              {#if item.id == "" && dest_selected != "" && org_selected != ""}
                                <button
                                  on:click={() => {
                                    add_destino(item.id, item.date_ini);
                                  }}
                                  id="add_dest_{$nicks_list[item.id]}"
                                  type="button"
                                  class="btn btn-info"
                                >
                                  Agregar destino
                                </button>
                              {/if}
                              {#if item.id != "" && !new_travel_s && item.step - 2 < item.sec_dests.length && (edit_mode == item.id + item.date_ini || edit_mode == -1)}
                                {#if edit_mode == item.id + item.date_ini}
                                  <button
                                    on:click={() => {
                                      //save_edit_travel(item.id, item.date_ini);
                                      change_travel_modal_id = item.id;
                                      change_travel_modal_date = item.date_ini;
                                      change_travel_modal_uuid = item.uuid;
                                      change_travel_modal = true;
                                    }}
                                    id="save_edit_travel_{$nicks_list[item.id]}"
                                    type="button"
                                    class="btn btn-success"
                                  >
                                    Guardar edicion
                                  </button>
                                {/if}
                                <button
                                  on:click={() => {
                                    edit_travel(item.id + item.date_ini, i);
                                  }}
                                  id="pos_edit_travel_{$nicks_list[item.id]}"
                                  type="button"
                                  disabled={user_level < 1}
                                  class="btn btn-{edit_mode ==
                                  item.id + item.date_ini
                                    ? 'danger'
                                    : 'info'}"
                                >
                                  {edit_mode == item.id + item.date_ini
                                    ? "Cancelar edicion"
                                    : "Editar"}
                                </button>
                              {/if}
                              {#if edit_mode != item.id + item.date_ini && (!new_travel_s || i == 0) && (item.step == 0 || item.id == "")}
                                <button
                                  on:click={() => {
                                    item.id != ""
                                      ? save_travel_modal(
                                          item.id,
                                          item.date_ini
                                        )
                                      : save_travel(item.id, item.date_ini);
                                  }}
                                  id="edit_prog_{$nicks_list[item.id]}"
                                  type="button"
                                  disabled={user_level < 1}
                                  class="btn btn-{item.id != ''
                                    ? 'danger'
                                    : 'success'}"
                                >
                                  {item.id != "" ? "Borrar" : "Guardar"}
                                </button>
                              {/if}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                {/each}
                {#if future_travel_visible_count < future_travel.length}
                  <div
                    class="d-flex justify-content-center py-2"
                    use:travelSentinel
                  >
                    <button
                      type="button"
                      class="btn btn-outline-info"
                      on:click={loadMoreTravels}
                    >Mostrar más ({future_travel.length - future_travel_visible_count} restantes)</button>
                  </div>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

{#if lightmetrics_stream_modal_open}
  <div
    class="monitor-lightmetrics-stream-overlay"
    on:click={() => closeLightmetricsStream("overlay_close", true)}
  >
    <div
      class="monitor-lightmetrics-stream-modal shadow-lg"
      role="dialog"
      aria-modal="true"
      aria-label="Stream Protect"
      on:click|stopPropagation
    >
      <div class="monitor-lightmetrics-stream-header">
        <div>
          <div class="monitor-lightmetrics-stream-title">Stream Protect</div>
          <div class="monitor-lightmetrics-stream-subtitle">
            {lightmetricsStreamUnitLabel(lightmetrics_stream_unit_id)}
            {#if lightmetrics_stream_asset_id != ""}
              | Asset {lightmetrics_stream_asset_id}
            {/if}
          </div>
        </div>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          on:click={() => closeLightmetricsStream("manual_close", true)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="monitor-lightmetrics-stream-status-row">
        <div class="monitor-lightmetrics-stream-pill">
          {lightmetricsStreamStatusLabel(lightmetrics_stream_status)}
        </div>
        {#if lightmetrics_stream_message != ""}
          <div class="text-muted small">{lightmetrics_stream_message}</div>
        {/if}
      </div>
      {#if lightmetrics_stream_error != ""}
        <div class="alert alert-warning mb-3">{lightmetrics_stream_error}</div>
      {/if}
      {#if lightmetrics_stream_player_error != ""}
        <div class="alert alert-warning mb-3">
          {lightmetrics_stream_player_error}
        </div>
      {/if}
      <div class="monitor-lightmetrics-stream-video-shell">
        {#if lightmetrics_stream_loading && !lightmetrics_stream_player_ready}
          <div class="monitor-lightmetrics-stream-loading">
            <div class="spinner-border text-light mb-3" role="status"></div>
            <div>Preparando video en vivo...</div>
          </div>
        {/if}
        <video
          bind:this={lightmetrics_stream_video}
          class="monitor-lightmetrics-stream-video"
          controls
          playsinline
          muted
          on:loadedmetadata={() => {
            ensureLightmetricsStreamPlayback("loadedmetadata");
          }}
          on:loadeddata={() => {
            ensureLightmetricsStreamPlayback("loadeddata");
          }}
          on:canplay={() => {
            ensureLightmetricsStreamPlayback("canplay");
          }}
          on:play={() => {
            lightmetrics_stream_message = "Iniciando reproducción...";
          }}
          on:playing={() => {
            markLightmetricsStreamPlayable();
          }}
          on:timeupdate={() => {
            if (hasLightmetricsStreamPlayback()) {
              markLightmetricsStreamPlayable();
            }
          }}
          on:waiting={() => {
            if (!hasLightmetricsStreamPlayback()) {
              lightmetrics_stream_loading = true;
              lightmetrics_stream_message =
                hasLightmetricsStreamMediaReady()
                  ? "El video está listo. Intentando reproducirlo..."
                  : "Esperando que Protect entregue el video";
            }
          }}
          on:error={() => {
            lightmetrics_stream_player_error =
              "El video tardó en responder. Reintentando...";
            requestLightmetricsStreamReload("video_error_event");
          }}
        ></video>
      </div>
      {#if lightmetrics_stream_expires_at > 0}
        <div class="monitor-lightmetrics-stream-footer text-muted small">
          Límite automático:
          {new Date(lightmetrics_stream_expires_at).toLocaleTimeString()}
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .monitor-shell {
    position: relative;
    --monitor-font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
      "Helvetica Neue", Arial, "Noto Sans", sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji";
    --monitor-surface: #ffffff;
    --monitor-surface-soft: #f7fafb;
    --monitor-header-surface: #39434b;
    --monitor-header-surface-bottom: #303841;
    --monitor-border: rgba(80, 104, 120, 0.18);
    --monitor-border-strong: rgba(23, 162, 184, 0.45);
    --monitor-shadow-sm: 0 8px 18px rgba(44, 62, 80, 0.08);
    --monitor-shadow-md: 0 14px 28px rgba(44, 62, 80, 0.12);
    --monitor-shadow-btn: 0 4px 10px rgba(44, 62, 80, 0.08);
    --monitor-radius-xs: 0.3rem;
    --monitor-radius-sm: 0.38rem;
    --monitor-radius-md: 0.58rem;
    --monitor-radius-lg: 0.9rem;
    --monitor-gap-xs: 0.25rem;
    --monitor-gap-sm: 0.5rem;
    --monitor-gap-md: 0.75rem;
    --monitor-gap-lg: 1rem;
    font-family: var(--monitor-font-family);
  }

  .btn {
    vertical-align: middle;
    min-height: 1.72rem;
    padding: 0.16rem 0.62rem;
    font-size: 0.75rem;
    line-height: 1.15;
    border-radius: var(--monitor-radius-sm);
    box-shadow: none;
    transition:
      box-shadow 0.15s ease,
      border-color 0.15s ease,
      background-color 0.15s ease;
  }
  .btn.big {
    vertical-align: middle;
    min-height: 1.95rem;
    padding: 0.22rem 0.74rem;
    font-size: 0.82rem;
  }
  .btn:hover {
    box-shadow: var(--monitor-shadow-btn);
  }
  .btn:focus,
  .btn.focus {
    box-shadow: 0 0 0 0.15rem rgba(38, 166, 154, 0.18);
  }
  .monitor-shell .btn-group .btn {
    min-height: 1.78rem;
    padding-top: 0.16rem;
    padding-bottom: 0.16rem;
    border-radius: 0;
  }
  .monitor-shell .btn-group .btn:first-child {
    border-top-left-radius: var(--monitor-radius-md);
    border-bottom-left-radius: var(--monitor-radius-md);
  }
  .monitor-shell .btn-group .btn:last-child {
    border-top-right-radius: var(--monitor-radius-md);
    border-bottom-right-radius: var(--monitor-radius-md);
  }
  .monitor-shell .btn-link,
  .monitor-shell .btn-link:hover,
  .monitor-shell .btn-link:focus {
    box-shadow: none;
    border-radius: var(--monitor-radius-xs);
  }

  .card.big-border {
    border-width: 2px;
    box-shadow: 0 10px 22px rgba(223, 22, 22, 0.12);
  }
  .card.med-border {
    border-width: 2px;
    box-shadow: 0 0 0 1px rgba(23, 162, 184, 0.08), var(--monitor-shadow-md);
  }
  .card-b {
    border-top: 0;
    border-right: 0;
    border-bottom: 1px solid var(--monitor-border);
    border-left: 0;
    border-radius: 0 0 var(--monitor-radius-lg) var(--monitor-radius-lg);
    background: var(--monitor-surface);
    box-shadow: var(--monitor-shadow-sm);
    overflow: hidden;
  }
  .monitor-panel {
    position: relative;
    background: var(--monitor-surface) !important;
    background-clip: border-box;
    border-top-color: transparent;
    border-right-color: transparent;
    border-left-color: transparent;
  }
  .card-header.b-0 {
    padding-top: 0.45rem;
    padding-right: 0.85rem;
    padding-bottom: 0.45rem;
    padding-left: 0.85rem;
    border-bottom: 1px solid rgba(80, 104, 120, 0.14);
  }
  .card-body {
    padding-top: 0rem;
    padding-right: 0rem;
    padding-bottom: 0rem;
    padding-left: 0rem;
  }
  .h-15 {
    height: 15%;
  }
  .h-85 {
    height: 85%;
  }

  [tooltip] {
    position: relative;
  }
  [tooltip]:before {
    content: attr(tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    padding: 8px;
    transform: translateX(-50%) scale(0);
    transform-origin: top;
    background: #757575;
    color: white;
    border-radius: 2px;
    font-size: 0.6rem;
    font-family: var(--monitor-font-family);
    z-index: 1001;
  }
  [tooltip]:hover:before {
    transform: translateX(-50%) scale(1);
  }

  .card-header:first-child {
    border-radius: 0;
  }

  .alert-top {
    position: fixed;
    top: 3rem;
    left: 35%;
    width: 30%;
    z-index: 1050;
  }

  .form-con {
    min-height: 1.85rem;
    height: calc(1.5em + 0.45rem + 2px);
    padding: 0.18rem 0.62rem;
    border: 1px solid var(--monitor-border);
    border-radius: var(--monitor-radius-sm);
    background: #ffffff;
    box-shadow: inset 0 1px 2px rgba(44, 62, 80, 0.05);
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }
  .btn-outline-info {
    color: #17a2b8;
    border-color: #17a2b8;
    background-color: white;
  }
  .btn-outline-info:hover,
  .btn-outline-info:focus {
    border-color: #12889a;
    background-color: rgba(23, 162, 184, 0.08);
    color: #117786;
  }

  .monitor-shell input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),
  .monitor-shell select,
  .form-control,
  .form-con {
    min-height: 1.85rem;
    padding: 0.18rem 0.62rem;
    border: 1px solid var(--monitor-border);
    border-radius: var(--monitor-radius-sm);
    background: #ffffff;
    box-shadow: inset 0 1px 2px rgba(44, 62, 80, 0.05);
    transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease,
      background-color 0.15s ease;
  }
  .monitor-shell input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):focus,
  .monitor-shell select:focus,
  .form-control:focus,
  .form-con:focus {
    border-color: var(--monitor-border-strong);
    box-shadow: 0 0 0 0.15rem rgba(38, 166, 154, 0.14);
    outline: none;
  }

  @font-face {
    font-family: "Material Icons";
    font-style: normal;
    font-weight: 400;
    src: url(../css/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format("woff2");
  }
  .material-icons {
    font-family: "Material Icons";
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    font-feature-settings: "liga";
    -webkit-font-feature-settings: "liga";
    -webkit-font-smoothing: antialiased;
  }
  .material-icons.md-1 {
    font-size: 1rem;
  }
  .material-icons.md-18 {
    font-size: 18px;
  }
  .material-icons.md-24 {
    font-size: 24px;
  }
  .material-icons.md-36 {
    font-size: 36px;
  }
  .material-icons.md-48 {
    font-size: 48px;
  }
  .material-icons.md-85 {
    font-size: 1.3rem;
  }
  .material-icons.md-90 {
    font-size: 1.5rem;
  }
  .material-icons.md-95 {
    font-size: 1.8rem;
  }
  .material-icons.md-dark {
    color: rgba(0, 0, 0, 0.54);
  }
  .material-icons.md-dark.md-inactive {
    color: rgba(0, 0, 0, 0.26);
  }
  .material-icons.md-light {
    color: rgba(255, 255, 255, 1);
  }
  .material-icons.md-light.md-inactive {
    color: rgba(255, 255, 255, 0.3);
  }
  .material-icons.orange {
    color: #ff7043;
  }
  .material-icons.bblue {
    color: #26a69a;
  }
  .material-icons.green {
    color: rgb(24, 179, 45);
  }
  .material-icons.yei {
    color: #ff9800;
  }
  .material-icons.golden {
    color: #856404;
  }
  .material-icons.gray {
    color: #525a63;
  }
  .material-icons.red {
    color: #df1616;
  }
  i {
    vertical-align: middle;
    padding-bottom: 3px;
  }
  span.blue {
    color: rgb(17, 33, 255);
  }
  .icon {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.35rem;
  }
  .monitor-panel-header {
    position: relative;
    z-index: 3;
    margin: -1px -1px 0;
    padding-top: 0.16rem;
    padding-right: 0.72rem;
    padding-bottom: 0.16rem;
    padding-left: 0.72rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    background: linear-gradient(
      180deg,
      var(--monitor-header-surface),
      var(--monitor-header-surface-bottom)
    ) !important;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
    line-height: 1.2;
  }
  .monitor-panel-toolbar {
    align-items: center;
    gap: 0.3rem;
    flex-wrap: wrap;
  }
  .monitor-panel-toolbar > .flex-grow-1,
  .monitor-panel-toolbar > .d-flex.flex-column.flex-grow-1 {
    min-width: 0;
  }
  .monitor-panel-header .badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    margin-left: 0.22rem;
    margin-top: -1px;
    min-width: 1.18rem;
    min-height: 1.18rem;
    border-radius: 999px;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
  }
  .monitor-search-wrap {
    align-items: center;
    gap: 0.45rem;
  }
  .monitor-search-input {
    min-width: 13rem;
    min-height: 1.5rem;
    padding-top: 0.04rem;
    padding-bottom: 0.04rem;
    border-radius: calc(var(--monitor-radius-md) + 0.02rem);
  }
  .monitor-panel-header .btn {
    min-height: 1.42rem;
    padding: 0.04rem 0.45rem;
    font-size: 0.72rem;
    line-height: 1.05;
    border-radius: var(--monitor-radius-xs);
  }
  .monitor-panel-header .btn-group {
    box-shadow: 0 1px 4px rgba(44, 62, 80, 0.05);
  }
  .monitor-panel-header .btn-group .btn {
    min-height: 1.42rem;
    padding-top: 0.04rem;
    padding-bottom: 0.04rem;
  }
  .monitor-panel-header .badge {
    padding: 0.08rem 0.34rem;
    font-size: 0.62rem;
    font-weight: 600;
    line-height: 1;
  }
  .monitor-filter-bar {
    gap: 0.35rem;
    padding: 0.12rem 0.68rem 0.24rem;
    margin-top: 0 !important;
    margin-bottom: 0.2rem !important;
    flex-wrap: wrap;
    border-bottom: 1px solid rgba(80, 104, 120, 0.12);
    background: linear-gradient(180deg, rgba(247, 250, 251, 0.98), rgba(242, 247, 249, 0.84));
  }
  .monitor-filter-bar .btn-group,
  .monitor-panel-toolbar .btn-group {
    border-radius: var(--monitor-radius-md);
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(44, 62, 80, 0.06);
  }
  .monitor-panel-body {
    background: linear-gradient(180deg, rgba(247, 250, 251, 0.7), rgba(255, 255, 255, 0.98));
  }
  .monitor-list-scroll {
    padding-top: 0.4rem;
    padding-bottom: 0.6rem;
  }
  .monitor-program-list {
    padding-top: 0.6rem;
    padding-bottom: 0.75rem;
  }
  .monitor-map-host-wrap {
    position: relative;
    overflow: hidden;
    height: calc(100% + 23px);
  }
  .monitor-map-host-wrap.is-extracted {
    height: 0 !important;
    min-height: 0;
    opacity: 0;
    pointer-events: none;
  }
  .monitor-panel-collapse-btn,
  .monitor-units-restore-tab {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    border: 1px solid rgba(117, 225, 207, 0.28);
    border-radius: 999px;
    background: linear-gradient(180deg, rgba(47, 58, 67, 0.98), rgba(35, 44, 52, 0.96));
    color: rgba(245, 249, 252, 0.96);
    box-shadow: 0 12px 24px rgba(26, 36, 44, 0.18);
    transition:
      transform 0.18s ease,
      box-shadow 0.18s ease,
      border-color 0.18s ease,
      background 0.18s ease;
  }
  .monitor-panel-collapse-btn {
    min-width: 2.15rem;
    min-height: 2.15rem;
    padding: 0.28rem;
  }
  .monitor-panel-collapse-btn:hover,
  .monitor-panel-collapse-btn:focus-visible,
  .monitor-units-restore-tab:hover,
  .monitor-units-restore-tab:focus-visible {
    transform: translateY(-1px);
    border-color: rgba(117, 225, 207, 0.52);
    box-shadow: 0 16px 30px rgba(26, 36, 44, 0.24);
    outline: none;
  }
  .monitor-units-restore-tab {
    position: absolute;
    top: 4.95rem;
    left: 0.95rem;
    z-index: 4;
    min-height: 2.35rem;
    padding: 0.42rem 0.7rem;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }
  .monitor-map-canvas {
    height: 100%;
  }
  .monitor-map-overlay {
    pointer-events: none;
    position: absolute;
    bottom: 2.15rem;
    left: 0;
    z-index: 3;
    display: flex;
    align-items: flex-end;
  }
  .monitor-map-bottom-controls {
    pointer-events: auto;
    display: flex;
    align-items: flex-end;
    gap: 0.72rem;
  }
  .monitor-map-primary-controls {
    pointer-events: none;
    position: absolute;
    top: 0.95rem;
    left: 0.95rem;
    z-index: 4;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.58rem;
  }
  .monitor-map-eta-pill {
    pointer-events: none;
    position: absolute;
    top: 0.95rem;
    right: 1rem;
    z-index: 3;
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    padding: 0.68rem 0.82rem;
    border: 1px solid rgba(255, 255, 255, 0.72);
    border-radius: 0.9rem;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(242, 247, 249, 0.94));
    box-shadow: 0 16px 28px rgba(44, 62, 80, 0.18);
    backdrop-filter: blur(10px);
    color: #22313b;
    transition: top 0.18s ease;
  }
  .monitor-map-eta-pill.is-shifted {
    top: 6.2rem;
  }
  .monitor-map-eta-icon {
    color: #26a69a;
  }
  .monitor-map-eta-copy {
    display: flex;
    flex-direction: column;
    gap: 0.04rem;
    line-height: 1.05;
  }
  .monitor-map-eta-label {
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #607d8b;
  }
  .monitor-map-eta-copy strong {
    font-size: 0.96rem;
    font-weight: 700;
    color: #1f2d36;
  }
  .monitor-map-layer-menu {
    pointer-events: auto;
    display: flex;
    align-items: stretch;
    width: max-content;
    transform: translateX(0);
    opacity: 1;
    transition:
      transform 0.28s ease,
      opacity 0.22s ease;
  }
  .monitor-map-unit-selector {
    position: absolute;
    top: 0.95rem;
    right: 1rem;
    z-index: 4;
    display: flex;
    flex-direction: column;
    min-width: 16.2rem;
    max-width: min(20rem, calc(100% - 1.8rem));
    padding: 0.82rem 0.9rem;
    border: 1px solid rgba(255, 255, 255, 0.74);
    border-radius: 1rem;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(241, 247, 249, 0.95));
    box-shadow: 0 18px 30px rgba(44, 62, 80, 0.2);
    backdrop-filter: blur(12px);
  }
  .monitor-map-unit-search {
    display: flex;
    flex-direction: column;
    gap: 0.42rem;
  }
  .monitor-map-unit-selector-field {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    margin: 0;
    padding: 0.48rem 0.55rem;
    border: 1px solid rgba(38, 166, 154, 0.14);
    border-radius: 0.82rem;
    background: rgba(255, 255, 255, 0.86);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
    transition:
      border-color 0.18s ease,
      box-shadow 0.18s ease,
      background-color 0.18s ease;
  }
  .monitor-map-unit-selector-field.is-active {
    border-color: rgba(38, 166, 154, 0.42);
    background: linear-gradient(180deg, rgba(240, 249, 247, 0.98), rgba(232, 246, 243, 0.92));
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.5),
      0 10px 20px rgba(38, 166, 154, 0.12);
  }
  .monitor-map-unit-selector-field .material-icons {
    color: #26a69a;
  }
  .monitor-map-unit-search-input {
    width: 100%;
    min-width: 0;
    border: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 !important;
    font-size: 0.88rem;
    font-weight: 600;
    color: #22313b;
  }
  .monitor-map-unit-search-input::placeholder {
    color: #78909c;
    font-weight: 500;
  }
  .monitor-map-unit-search-input:focus {
    outline: none;
  }
  .monitor-map-unit-active-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.18rem 0.48rem;
    border-radius: 999px;
    background: rgba(38, 166, 154, 0.14);
    color: #178f84;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
  }
  .monitor-map-unit-search-clear {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.85rem;
    height: 1.85rem;
    padding: 0;
    border: 0;
    border-radius: 999px;
    background: rgba(96, 125, 139, 0.1);
    color: #607d8b;
    transition:
      background-color 0.18s ease,
      color 0.18s ease,
      transform 0.18s ease;
  }
  .monitor-map-unit-search-clear:hover,
  .monitor-map-unit-search-clear:focus-visible {
    background: rgba(38, 166, 154, 0.16);
    color: #26a69a;
    transform: scale(1.03);
    outline: none;
  }
  .monitor-map-unit-results {
    display: flex;
    flex-direction: column;
    gap: 0.34rem;
    max-height: 14.5rem;
    overflow-y: auto;
    padding-right: 0.08rem;
  }
  .monitor-map-unit-empty {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    padding: 0.7rem 0.8rem;
    border: 1px dashed rgba(96, 125, 139, 0.22);
    border-radius: 0.82rem;
    color: #607d8b;
    background: rgba(255, 255, 255, 0.72);
    font-size: 0.78rem;
    font-weight: 600;
  }
  .monitor-map-unit-result {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    width: 100%;
    padding: 0.55rem 0.62rem;
    border: 1px solid rgba(96, 125, 139, 0.14);
    border-radius: 0.82rem;
    background: rgba(255, 255, 255, 0.88);
    color: #22313b;
    text-align: left;
    transition:
      transform 0.16s ease,
      border-color 0.16s ease,
      box-shadow 0.16s ease,
      background-color 0.16s ease;
  }
  .monitor-map-unit-result:hover,
  .monitor-map-unit-result:focus-visible {
    transform: translateY(-1px);
    border-color: rgba(38, 166, 154, 0.34);
    background: rgba(240, 249, 247, 0.96);
    box-shadow: 0 12px 20px rgba(44, 62, 80, 0.12);
    outline: none;
  }
  .monitor-map-unit-result.is-active {
    border-color: rgba(23, 162, 184, 0.32);
    background: linear-gradient(90deg, rgba(23, 162, 184, 0.12), rgba(38, 166, 154, 0.1));
  }
  .monitor-map-unit-result .material-icons {
    color: #26a69a;
  }
  .monitor-map-unit-result-copy {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  .monitor-map-unit-result-copy strong {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .monitor-map-unit-result-copy strong {
    font-size: 0.82rem;
    font-weight: 700;
    color: #1f2d36;
  }
  .monitor-map-layer-menu.is-collapsed {
    transform: translateX(calc(-100% + 2.3rem));
  }
  .monitor-map-type-controls,
  .monitor-map-zoom-controls {
    pointer-events: auto;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: linear-gradient(180deg, rgba(47, 58, 67, 0.96), rgba(33, 40, 47, 0.92));
    box-shadow: 0 16px 26px rgba(26, 36, 44, 0.24);
    backdrop-filter: blur(10px);
  }
  .monitor-map-type-controls {
    pointer-events: auto;
    display: inline-flex;
    align-items: center;
    gap: 0.28rem;
    padding: 0.32rem;
    border-radius: 0.74rem;
  }
  .monitor-map-type-btn,
  .monitor-map-zoom-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.42rem;
    border: 1px solid rgba(141, 169, 186, 0.18);
    background: rgba(244, 248, 250, 0.1);
    color: rgba(245, 249, 252, 0.94);
    transition:
      transform 0.18s ease,
      background-color 0.18s ease,
      border-color 0.18s ease,
      box-shadow 0.18s ease;
  }
  .monitor-map-type-btn {
    min-height: 2.05rem;
    padding: 0.38rem 0.56rem;
    border-radius: 0.62rem;
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.02em;
  }
  .monitor-map-type-btn .material-icons {
    font-size: 1.05rem;
  }
  .monitor-map-type-btn:hover:not(:disabled),
  .monitor-map-type-btn:focus-visible:not(:disabled),
  .monitor-map-zoom-btn:hover:not(:disabled),
  .monitor-map-zoom-btn:focus-visible:not(:disabled) {
    transform: translateY(-1px);
    border-color: rgba(117, 225, 207, 0.42);
    background: rgba(117, 225, 207, 0.12);
    box-shadow: 0 10px 20px rgba(20, 30, 36, 0.16);
    outline: none;
  }
  .monitor-map-type-btn.is-active {
    border-color: rgba(117, 225, 207, 0.5);
    background: linear-gradient(90deg, rgba(38, 166, 154, 0.26), rgba(117, 225, 207, 0.08));
    box-shadow: inset 0 0 0 1px rgba(117, 225, 207, 0.12);
  }
  .monitor-map-type-btn:disabled,
  .monitor-map-zoom-btn:disabled {
    cursor: wait;
    opacity: 0.72;
  }
  .monitor-map-zoom-controls {
    pointer-events: auto;
    position: absolute;
    right: 1rem;
    bottom: 1.75rem;
    z-index: 4;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.28rem;
    padding: 0.32rem;
    border-radius: 0.74rem;
  }
  .monitor-map-zoom-btn {
    width: 2.2rem;
    height: 2.2rem;
    padding: 0;
    border-radius: 0.62rem;
  }
  .monitor-map-zoom-btn .material-icons {
    font-size: 1.05rem;
  }
  .monitor-map-layer-panel {
    display: flex;
    flex-direction: column;
    gap: 0.42rem;
    min-width: 12.6rem;
    padding: 0.72rem;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 0.9rem 0.9rem 0.9rem 0;
    background: linear-gradient(180deg, rgba(47, 58, 67, 0.96), rgba(33, 40, 47, 0.92));
    box-shadow: 0 16px 26px rgba(26, 36, 44, 0.24);
    backdrop-filter: blur(10px);
  }
  .monitor-map-layer-header {
    display: flex;
    flex-direction: column;
    gap: 0.08rem;
    margin-bottom: 0.08rem;
    color: rgba(245, 249, 252, 0.96);
  }
  .monitor-map-layer-kicker {
    font-size: 0.56rem;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(117, 225, 207, 0.86);
  }
  .monitor-map-layer-header strong {
    font-size: 0.88rem;
    line-height: 1.15;
    font-weight: 700;
  }
  .monitor-map-layer-header small {
    color: rgba(214, 224, 231, 0.76);
    font-size: 0.67rem;
    line-height: 1.28;
  }
  .monitor-map-layer-btn {
    display: flex;
    align-items: center;
    gap: 0.58rem;
    min-height: 2.45rem;
    padding: 0.52rem 0.66rem;
    border: 1px solid rgba(141, 169, 186, 0.18);
    border-radius: 0.72rem;
    background: rgba(244, 248, 250, 0.1);
    color: rgba(245, 249, 252, 0.94);
    text-align: left;
    transition:
      transform 0.18s ease,
      background-color 0.18s ease,
      border-color 0.18s ease,
      box-shadow 0.18s ease;
  }
  .monitor-map-layer-btn:hover:not(:disabled),
  .monitor-map-layer-btn:focus-visible:not(:disabled) {
    transform: translateX(2px);
    border-color: rgba(117, 225, 207, 0.42);
    background: rgba(117, 225, 207, 0.12);
    box-shadow: 0 10px 20px rgba(20, 30, 36, 0.16);
    outline: none;
  }
  .monitor-map-layer-btn.is-active {
    border-color: rgba(117, 225, 207, 0.5);
    background: linear-gradient(90deg, rgba(38, 166, 154, 0.26), rgba(117, 225, 207, 0.08));
    box-shadow: inset 0 0 0 1px rgba(117, 225, 207, 0.12);
  }
  .monitor-map-layer-btn:disabled {
    cursor: wait;
    opacity: 0.72;
  }
  .monitor-map-layer-copy {
    display: flex;
    flex-direction: column;
    gap: 0.08rem;
    min-width: 0;
  }
  .monitor-map-layer-copy > span {
    font-size: 0.78rem;
    font-weight: 600;
    line-height: 1.1;
  }
  .monitor-map-layer-copy small {
    color: rgba(214, 224, 231, 0.74);
    font-size: 0.66rem;
    line-height: 1.1;
  }
  .monitor-map-layer-toggle {
    align-self: flex-end;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.3rem;
    min-width: 2.3rem;
    height: 3.4rem;
    margin-left: 0.38rem;
    border: 0;
    border-radius: 0 0.8rem 0.8rem 0;
    background: linear-gradient(180deg, rgba(48, 58, 66, 0.98), rgba(34, 41, 48, 0.96));
    color: #f4f8fa;
    box-shadow: 0 12px 24px rgba(26, 36, 44, 0.26);
    transition:
      transform 0.18s ease,
      background-color 0.18s ease,
      box-shadow 0.18s ease;
  }
  .monitor-map-layer-toggle:hover,
  .monitor-map-layer-toggle:focus-visible {
    transform: translateX(1px);
    background: linear-gradient(180deg, rgba(55, 67, 76, 0.98), rgba(39, 47, 55, 0.96));
    box-shadow: 0 14px 24px rgba(26, 36, 44, 0.3);
    outline: none;
  }
  @media (max-width: 768px) {
    .monitor-units-restore-tab {
      top: 4.55rem;
      left: 0.75rem;
      min-height: 2.1rem;
      padding: 0.38rem 0.58rem;
      font-size: 0.66rem;
    }
    .monitor-map-unit-selector {
      top: 0.75rem;
      right: 0.75rem;
      left: 0.75rem;
      min-width: 0;
      max-width: none;
      padding: 0.72rem 0.78rem;
    }
    .monitor-map-eta-pill {
      top: 0.75rem;
      right: 0.75rem;
      padding: 0.58rem 0.68rem;
    }
    .monitor-map-eta-pill.is-shifted {
      top: 6.75rem;
    }
    .monitor-map-eta-copy strong {
      font-size: 0.86rem;
    }
    .monitor-map-overlay {
      bottom: 1.25rem;
      left: 0.55rem;
      right: 0.55rem;
    }
    .monitor-map-bottom-controls {
      flex-wrap: wrap;
      gap: 0.5rem;
    }
    .monitor-map-primary-controls {
      top: 0.75rem;
      left: 0.75rem;
      right: 0.75rem;
      gap: 0.48rem;
    }
    .monitor-map-type-controls {
      flex-wrap: wrap;
      max-width: 100%;
    }
    .monitor-map-type-btn {
      flex: 1 1 calc(50% - 0.36rem);
      justify-content: center;
    }
    .monitor-map-zoom-controls {
      right: 0.75rem;
      bottom: 1.35rem;
    }
  }
  .monitor-new-travel-form {
    gap: 0.24rem;
  }
  .monitor-caravan-check {
    position: relative;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    margin-right: 0.22rem;
  }
  .monitor-caravan-check input[type="checkbox"] {
    position: relative;
    z-index: 2;
    cursor: pointer;
  }
  .monitor-list-card,
  .monitor-program-card {
    border: 1px solid var(--monitor-border);
    border-radius: var(--monitor-radius-md);
    background: var(--monitor-surface);
    box-shadow: 0 5px 14px rgba(44, 62, 80, 0.08);
    overflow: hidden;
    transition:
      box-shadow 0.16s ease,
      border-color 0.16s ease;
  }
  .monitor-list-card {
    content-visibility: auto;
    contain: layout style paint;
    contain-intrinsic-size: auto 240px;
  }
  .monitor-list-card:hover,
  .monitor-program-card:hover {
    box-shadow: var(--monitor-shadow-md);
  }
  .monitor-list-card .card-header.b-0,
  .monitor-program-card .card-header.b-0 {
    background: linear-gradient(180deg, #fbfcfd, #f4f8fa);
    padding-top: 0.55rem;
    padding-bottom: 0.5rem;
  }
  .monitor-unit-summary-line {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    min-width: 0;
    flex-wrap: nowrap;
    line-height: 1.25;
    margin-bottom: 0.15rem;
  }
  .monitor-unit-summary-line > * {
    flex: 0 0 auto;
  }
  .monitor-unit-identity {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .monitor-unit-card-layout {
    align-items: flex-start;
    min-width: 0;
    gap: 0.75rem;
  }
  .monitor-unit-main-column {
    min-width: 0;
    flex: 1 1 auto;
    width: 0;
    max-width: 100%;
  }
  .monitor-unit-side-column {
    flex: 0 0 auto;
    margin-left: 0.25rem;
    padding-left: 0.55rem;
    border-left: 1px solid rgba(80, 104, 120, 0.14);
  }
  .monitor-unit-geocode {
    flex: 0 1 auto;
    min-width: 0;
    max-width: 18rem;
    width: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    text-decoration: none;
    border-bottom: 0;
    box-shadow: none;
    cursor: default;
  }
  .monitor-unit-geocode:hover,
  .monitor-unit-geocode:focus {
    text-decoration: none;
    border-bottom: 0;
    box-shadow: none;
    outline: none;
  }
  .monitor-unit-geocode[tooltip]:before {
    bottom: calc(100% + 0.35rem);
    left: 50%;
    max-width: 18rem;
    white-space: normal;
    line-height: 1.15;
    transform: translate(-50%, -100%) scale(0);
    transform-origin: bottom;
    pointer-events: none;
  }
  .monitor-unit-geocode[tooltip]:hover:before,
  .monitor-unit-geocode[tooltip]:focus:before {
    transform: translate(-50%, -100%) scale(1);
  }
  .monitor-unit-detail-line {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    min-width: 0;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 100%;
    line-height: 1.25;
  }
  .monitor-unit-detail-line > .material-icons,
  .monitor-unit-detail-prefix {
    flex: 0 0 auto;
  }
  .monitor-unit-detail-text {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  .monitor-unit-click-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
  .monitor-unit-edit-inline {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    min-width: 0;
    flex: 1 1 auto;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }
  .monitor-unit-edit-select {
    flex: 0 1 auto;
    width: fit-content;
    min-width: 0;
    max-width: 100%;
    max-inline-size: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .monitor-unit-edit-button {
    flex: 0 0 auto;
  }
  .monitor-lightmetrics-stream-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: auto;
    color: inherit;
    text-decoration: none;
    border: 0;
    box-shadow: none;
  }
  .monitor-lightmetrics-stream-button:hover,
  .monitor-lightmetrics-stream-button:focus {
    text-decoration: none;
    box-shadow: none;
  }
  .monitor-lightmetrics-stream-overlay {
    position: fixed;
    inset: 0;
    z-index: 1080;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
    background: rgba(12, 22, 30, 0.62);
    backdrop-filter: blur(4px);
  }
  .monitor-lightmetrics-stream-modal {
    width: min(100%, 980px);
    max-height: calc(100vh - 3rem);
    overflow: auto;
    padding: 1.25rem 1.25rem 1rem;
    border-radius: 18px;
    background: #f9fbfc;
    border: 1px solid rgba(15, 35, 46, 0.08);
  }
  .monitor-lightmetrics-stream-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 0.85rem;
  }
  .monitor-lightmetrics-stream-title {
    font-size: 1.15rem;
    font-weight: 700;
    color: #113445;
  }
  .monitor-lightmetrics-stream-subtitle {
    margin-top: 0.2rem;
    font-size: 0.88rem;
    color: #56707f;
  }
  .monitor-lightmetrics-stream-status-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
    flex-wrap: wrap;
  }
  .monitor-lightmetrics-stream-pill {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 0.35rem 0.8rem;
    background: #e3f2fd;
    color: #0d47a1;
    font-size: 0.84rem;
    font-weight: 600;
  }
  .monitor-lightmetrics-stream-video-shell {
    position: relative;
    min-height: 360px;
    border-radius: 16px;
    overflow: hidden;
    background: #09131a;
  }
  .monitor-lightmetrics-stream-video {
    width: 100%;
    min-height: 360px;
    background: #09131a;
  }
  .monitor-lightmetrics-stream-loading {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(9, 19, 26, 0.72);
    color: #f5f8fa;
  }
  .monitor-lightmetrics-stream-footer {
    margin-top: 0.85rem;
    text-align: right;
  }
  .dot {
    width: 15px;
    height: 15px;
    background-color: #ffcc00;
    border-radius: 50%;
    position: relative;
  }
  .wave {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #ffcc00;
    opacity: 0.5;
    animation: wave-animation 1.5s infinite linear;
  }
  .wave.left {
    animation-delay: 0.2s;
  }
  .wave.right {
    animation-delay: 0.4s;
  }
  @keyframes wave-animation {
    0% {
      transform: scale(0.5);
      opacity: 0.5;
    }
    50% {
      transform: scale(1.2);
      opacity: 1;
    }
    100% {
      transform: scale(0.5);
      opacity: 0.5;
    }
  }
</style>
